import { getSlotCalendarDate, getSlotSelectedCalendarDate, parseSlotCalendarDate, getSlotExceptionsForDate, isDateOpenForSlotSettings, getDateTimeWindowsForSlot } from '../utils/slot-schedule';
import { applyDatePromotionToCart, DatePromotionApplication, DatePromotionConfig, getDatePromotion, getDatePromotionDates } from '../utils/date-promotion';
import { CommonModule, Location } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, forwardRef, NgZone, ViewEncapsulation, ViewChild } from '@angular/core';
import { Auth, signInAnonymously } from '@angular/fire/auth';
import { Functions, httpsCallable, HttpsCallableResult } from '@angular/fire/functions';
import { FormBuilder, FormGroup, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IonHeader, IonToolbar, IonTitle, IonContent, LoadingController, IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent, IonSkeletonText, IonLabel, IonInput, IonThumbnail, IonItem, IonList, IonListHeader, IonCheckbox, IonProgressBar, IonSelect, IonSelectOption, IonNote, IonAlert, AlertController, IonSegment, IonSegmentButton, IonGrid, IonRow, IonCol, IonChip, IonFab, IonFabButton, IonFabList, PopoverController, IonModal, IonBadge, IonTextarea } from '@ionic/angular/standalone';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { optionsOutline, removeOutline, addOutline, arrowBackOutline, arrowForwardOutline, mailOutline, personOutline, callOutline, locationOutline, calendarNumberOutline, businessOutline, cardOutline, ticketOutline, checkmarkOutline, helpOutline, chevronDownOutline, languageOutline, timeOutline, informationCircleOutline, createOutline, swapHorizontalOutline, closeCircleOutline } from 'ionicons/icons';
import { addIcons } from 'ionicons';
import { DomSanitizer, Meta, SafeHtml, Title } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FirebaseError } from '@angular/fire/app';

import { PixelService } from 'ngx-pixel';
import { LinkifyPipe } from '../pipes/linkify.pipe';
import { SeatMapViewerComponent } from '../components/seat-map-viewer/seat-map-viewer.component';
import { DateSlotPickerComponent } from '../components/date-slot-picker/date-slot-picker.component';
import { ChoiceCardComponent } from '../components/choice-card/choice-card.component';
import { PriceRowComponent } from '../components/price-row/price-row.component';
import { QuantityStepperComponent } from '../components/quantity-stepper/quantity-stepper.component';
import { CartRecapGroup, CartRecapLine, OrderTotalComponent } from '../components/order-total/order-total.component';
import { CartLineComponent } from '../components/cart-line/cart-line.component';
import { OrderRecapComponent } from '../components/order-recap/order-recap.component';
import { FormProgressComponent } from '../components/form-progress/form-progress.component';
import { applyFamilyDiscountToCart, FamilyDiscountApplication, FamilyDiscountConfig, getFamilyDiscount, getFamilyDiscountedUnitPrice } from './family-discount';

export const DEFAULT_PROFILE_LOGO = 'https://firebasestorage.googleapis.com/v0/b/one-evenement.appspot.com/o/platform%2Ftransparent.png?alt=media&token=00335342-6bbf-4682-b7d1-2db432d150d4';
export const DEFAULT_PROFILE_BACKGROUND = 'https://firebasestorage.googleapis.com/v0/b/one-evenement.appspot.com/o/platform%2Fbackground_generic.jpg?alt=media&token=3087690f-3f50-4260-bfd4-f41b93872615';
export const DEFAULT_EVENT_LOGO = DEFAULT_PROFILE_LOGO;
export const DEFAULT_EVENT_BACKGROUND = DEFAULT_PROFILE_BACKGROUND;
export const DEFAULT_EVENT_BANNER = 'https://firebasestorage.googleapis.com/v0/b/one-evenement.appspot.com/o/platform%2Fdefault_event_banner_1200.jpg?alt=media&token=8b146f4c-46eb-4129-a935-8a4892eb2a2a';

const RESTRICTED_SLOT_WINDOW_CLIENT_ID = 'U1gtpSNQhIREVxoer9qB';
const RESTRICTED_SLOT_WINDOW_PROFILE_IDS = new Set([
  '57pIgEGORvVjALRVqI6B',
  'xuWklr4Qg6rseCwccsTx'
]);
const RESTRICTED_SLOT_WINDOW_DAYS = 42;
const GRIDX_ALL_PROFILE_IDS = new Set([
  '57pIgEGORvVjALRVqI6B',
  'qMNXFX4PpFC7IfVtlI0i',
  'r1S0k3n3faqswSuv2xXP',
  'xuWklr4Qg6rseCwccsTx'
]);

// providers: [
//   {
//     provide: NG_VALUE_ACCESSOR,
//     useExisting: forwardRef(() => IonInput),
//     multi: true,
//   }
// ]

interface CartItem {
  ticketTypeId: string | null;
  addOnId: string | null;
  isCombinedTicket: boolean;
  combinedTickets: any[];
  combinedTicketKey: string;
  priceTag: string;
  label: any;
  description: any;
  quantity: number;
  price: number;
  priceAfterPromotion: number;
  vat: number;
  seatId?: string;
  seatLabel?: string;
  seat?: any;
  visitors?: VisitorInput[];
  familyDiscountPrice?: number;
  familyDiscountPercentage?: number;
  datePromotionPrice?: number;
  datePromotionPercentage?: number;
  datePromotionDate?: string;
  datePromotionLabel?: Record<string, string>;
}

interface DatePromotionCategory {
  ticketTypeId: string;
  ticketTypeLabel: string;
  label: string;
  color: string;
}

interface DatePromotionBanner {
  key: string;
  ticketTypeIds: string[];
  categories: DatePromotionCategory[];
  label: string;
  percentage: number;
  color: string;
  textColor: string;
}

interface VisitorInput {
  fullName: string;
  firstname?: string;
  lastname?: string;
  email: string;
  phone?: string;
  gender?: string;
  country?: string;
  zipcode?: string;
  language?: string;
  jobTitle?: string;
  ageGroup?: string;
  companyName?: string;
  companyIndustry?: string;
  companyAddress?: string;
  companyZipcode?: string;
  companyCity?: string;
  visitGoal?: string;
  city?: string;
}

interface VisitorToCartMapEntry {
  ticketTypeId: string;
  ticketTypeLabel: string;
  formIndexInTicketType: number;
  ticketTypeQuantity: number;
  cartQuantity: number;
  targets: { cartIndex: number, visitorIdx: number }[];
}

export interface SlotSettings {
  startDate: any,
  endDate: any,
  isMondayOpened: boolean,
  mondayStartTime: string,
  mondayEndTime: string,
  isTuesdayOpened: boolean,
  tuesdayStartTime: string,
  tuesdayEndTime: string,
  isWednesdayOpened: boolean,
  wednesdayStartTime: string,
  wednesdayEndTime: string,
  isThursdayOpened: boolean,
  thursdayStartTime: string,
  thursdayEndTime: string,
  isFridayOpened: boolean,
  fridayStartTime: string,
  fridayEndTime: string,
  isSaturdayOpened: boolean,
  saturdayStartTime: string,
  saturdayEndTime: string,
  isSundayOpened: boolean,
  sundayStartTime: string,
  sundayEndTime: string,
  exceptions?: SlotException[],
  periods?: SlotPeriod[]
}
export interface SlotPeriod {
  templateId: string,
  templateName: string,
  startDate: any,
  endDate: any,
  settings: Omit<SlotSettings, 'periods'>
}
export interface SlotException {
  date: any,
  isClosed: boolean,
  startTime: string | null,
  endTime: string | null,
  isPrivatized?: boolean,
  promotion?: DatePromotionConfig
}
export interface TimeSlot {
  label: string,
  booked: number,
  capacity: number,
  isSelected: boolean,
  displayLabel?: string
}
export interface TicketTypeData {
  id: string,
  label: any,
  shortLabel: string,
  description: any,
  normalPriceLabel?: any,
  seniorPriceLabel?: any,
  disabledPriceLabel?: any,
  youthPriceLabel?: any,
  childrenPriceLabel?: any,
  warning: string,
  color?: string,
  price: number,
  vat: number,
  earlyBirdPrice: number,
  earlyBirdDate: any,
  salesStartDate?: any, // { seconds, nanoseconds }, null/undefined = on sale immediately
  salesEndDate?: any, // { seconds, nanoseconds }, null/undefined = on sale until the form closes
  capacity: number,
  maxPerOrder: number,
  isCombinedTicket: boolean,
  combinedTicketKey: string,
  isFree: boolean,
  freeLabel?: any,
  isLimited: boolean,
  isEarlyBird: boolean,
  isVisible: boolean,
  isStudentDiscount: boolean,
  studentPrice: number,
  isChildrenDiscount: boolean,
  childrenPrice: number,
  childrenAge: number,
  childrenMinAge: number,
  childrenMaxAge: number,
  isYouthDiscount: boolean,
  youthPrice: number,
  youthAge?: number,
  youthMinAge: number,
  youthMaxAge: number,
  isSeniorDiscount: boolean,
  seniorPrice: number,
  seniorMinAge: number,
  isDisabledDiscount: boolean,
  disabledPrice: number,
  isFamilyGroup: boolean,
  familyGroupBasePrice: number,
  familyGroupExtraTicketPrice: number,
  isRegularGroup: boolean,
  regularGroupBasePrice: number,
  regularGroupBaseTickets: number,
  regularGroupExtraTicketPrice: number,
  isDateSlot: boolean,
  isTimeSlot: boolean,
  timeSlotDuration: number,
  slotCapacityWeekday: number,
  slotCapacityWeekend: number,
  slotSettings: SlotSettings,
  createdTimestamp: Date,
  position: number,
  priceSelection?: any,
  lowestPrice?: number,
  highestPrice?: number,
  isSelected?: boolean,
  remaining?: number,
  isSoldOut?: boolean,
  isHidden?: boolean,
  isMultipleVisitorForms?: boolean,
  isGiftCard?: boolean,
  giftCardApplyToAddOns?: boolean,
  isBookable?: boolean,
  isGroupTicketOnly?: boolean,
  isComplimentaryOfferEnabled?: boolean,
  complimentaryOfferBuyQuantity?: number,
  complimentaryOfferFreeQuantity?: number,
  combinedTickets?: { eventId: string, ticketId: string, isDateSlot?: boolean }[],
  familyDiscount?: FamilyDiscountConfig
}

export interface AddOnData {
  id: string,
  label: any,
  shortLabel: string,
  description: any,
  warning: string,
  price: number,
  vat: number,
  maxPerOrder: number,
  isFree: boolean,
  isLimited: boolean,
  capacity: number,
  isVisible: boolean,
  createdTimestamp: Date,
  position: number,
  selection?: number,
  remaining?: number,
  isSoldOut?: boolean,
  isBookable?: boolean,
  applyToAllTicketTypes?: boolean,
  applicableTicketTypeIds?: string[],
  salesStartDate?: any, // { seconds, nanoseconds }, null/undefined = on sale immediately
  salesEndDate?: any, // { seconds, nanoseconds }, null/undefined = on sale until the form closes
  color?: string
}

export interface PromoCodeData {
  id: string,
  code: string,
  label: string,
  discountType: 'absolute' | 'percentage',
  discountValue: number,
  isLimited: boolean,
  capacity: number,
  isVisible: boolean,
  createdTimestamp: Date,
  remaining?: number,
  isSoldOut?: boolean,
  isArchived?: boolean,
  isGiftCard?: boolean,
  applyToAllTicketTypes?: boolean,
  applicableTicketTypeIds?: string[],
  maxTicketTypeUsableQuantity?: number,
  ticketTypeUsageCount?: number,
  applyToAddOns?: boolean,
  applyToAllAddOns?: boolean,
  applicableAddOnIds?: string[],
  orderId?: string
}

export interface FormInput {
  fieldName: string,
  fieldIcon: string,
  label: any,
  shortLabel: any,
  type: string,
  options: any[],
  firestoreNode: string,
  firestoreKey: string,
  isRequired: boolean,
  helperText?: any,
  isConfirmEmailAsked?: boolean,
  isPasteEmailBlocked?: boolean,
  isPersonalEmailBlocked?: boolean,
  isConditionEnabled?: boolean,
  conditionType?: 'showSelect' | 'hideSelect' | 'showURL' | 'hideURL',
  conditionFieldName: string,
  conditionFieldOptionIndex: number
  conditionFieldOptionValue?: string,
  conditionQueryParameter?: string,
  conditionQueryValue?: string,
  applyToAllTicketTypes?: boolean,
  applicableTicketTypeIds?: string[],
  isCustom?: boolean,
  isHidden?: boolean,
  position?: number
}

export interface FormSection {
  id: string,
  title: any,
  inputs: FormInput[],
  position: number,
  isCollapsed?: boolean,
  isAcknowledgments?: boolean
}

export interface FormData {
  id: string,
  addOns: AddOnData[],
  bannerURI: string,
  buttonColor: string,
  buttonText: string,
  clientId: string,
  eventDateFormEnd: any,
  eventDateStart: any,
  eventDefaultLanguage: string,
  eventId: string,
  eventLanguages: string[],
  eventMetadata: any,
  eventName: string,
  descriptionEnabled?: boolean,
  descriptionDisplayType?: 'tab' | 'popup',
  descriptionContent?: Record<string, string>,
  inputs: FormInput[],
  sections?: FormSection[],
  languages: string[],
  organizerCommercialName: string,
  organizerLegalName: string,
  organizerMail: string,
  organizerMetadata: any,
  organizerPrivacyURL: string,
  organizerProfileId: string,
  organizerMollieProfileId: string,
  organizerProfileLogo: string,
  organizerProfileBackground: string,
  eventLogoURI?: string | null,
  eventLogoBadgeURI?: string | null,
  eventBackgroundURI?: string | null,
  organizerProfileRedirection: string,
  organizerTermsURL: string,
  isOnlyOneRegistrationPerEmailAddress?: boolean,
  promoCodes: PromoCodeData[],
  ticketConfig: {
    address: string,
    email: string,
    website: string,
    commercialName: string,
    legalName: string,
    termsAndConditionsURL: string,
    privacyPolicyURL: string,
  },
  ticketTypes: TicketTypeData[],
  seatingEnabled?: boolean,
  seatingConfig?: SeatMapConfig
}

export interface SeatMapConfig {
  backgroundImageURI?: string;
  backgroundImageScale?: number;
  backgroundImageX?: number;
  backgroundImageY?: number;
  hasFloors?: boolean;
  floorsCount?: number;
  blocks: SeatBlock[];
}

export interface SeatBlock {
  id: string;
  name: string;
  x: number;
  y: number;
  rotation: number;
  rows: number;
  seatsPerRow: number;
  horizontalSpacing: number;
  verticalSpacing: number;
  ticketTypeId: string;
  seatSize?: number;
  firstSeatNumber?: number;
  firstRowNumber?: number | string;
  curvature?: number;
  seatShape?: 'circle' | 'rectangle';
  isDisabledAccessible?: boolean;
  floor?: number;
}

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    IonAlert,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCardSubtitle,
    IonCardContent,
    IonSkeletonText,
    IonThumbnail,
    IonItem,
    IonNote,
    IonLabel,
    IonInput,
    IonList,
    IonListHeader,
    IonCheckbox,
    IonProgressBar,
    IonSelect,
    IonSelectOption,
    IonSegment,
    IonSegmentButton,
    IonGrid,
    IonRow,
    IonCol,
    IonChip,
    TranslateModule,
    LinkifyPipe,
    IonFab,
    IonFabButton,
    IonFabList,
    IonModal,
    SeatMapViewerComponent,
    DateSlotPickerComponent,
    ChoiceCardComponent,
    PriceRowComponent,
    QuantityStepperComponent,
    OrderTotalComponent,
    CartLineComponent,
    OrderRecapComponent,
    FormProgressComponent,
    IonBadge,
    IonTextarea
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HomePage {
  @ViewChild('seatMapViewer') seatMapViewer: any;
  @ViewChild(DateSlotPickerComponent) dateSlotPicker?: DateSlotPickerComponent;
  public step: string = '1'
  public isDescriptionModalOpen: boolean = false
  public isWelkomTermsModalOpen: boolean = false
  public stepProgress: number = 0.11

  // Displays debug logs only when the application is not running in production mode.
  private silentLog(...logs: unknown[]): void {
    if (!this.production) {
      console.log(...logs)
    }
  }

  get isMultipleTicketsAllowed(): boolean {
    if (this.formData?.seatingEnabled) return false;
    if (this.ticketTypes.some(tt => tt.isCombinedTicket)) return false;
    if (this.ticketTypes.some(tt => tt.isDateSlot || tt.isTimeSlot)) return false;
    if (this.ticketTypes.some(tt => tt.isGiftCard)) return false;
    return true;
  }

  // True as soon as the cart contains at least one real ticket (ticketTypeId set). Every distinct
  // ticket type present in the cart gets its own visitor form: one per unit of quantity when that
  // ticket type has isMultipleVisitorForms == true, or exactly one (regardless of quantity) otherwise.
  // See syncVisitorFormsWithCart for how forms are built and mapped back to cart items.
  get isMultipleVisitorForms(): boolean {
    return this.cart.some((item: CartItem) => !!item.ticketTypeId);
  }

  // Returns whether the ticket type requires one visitor form per purchased unit.
  public isPerUnitVisitorForm(item: CartItem): boolean {
    if (!item.ticketTypeId) return false;
    const ticketType = this.ticketTypes.find(tt => tt.id === item.ticketTypeId);
    return !!ticketType?.isMultipleVisitorForms;
  }

  /** Returns the number of complimentary tickets earned for one paid quantity. */
  public getComplimentaryTicketQuantity(quantity: number, item: TicketTypeData | CartItem): number {
    const ticketType = 'ticketTypeId' in item
      ? this.ticketTypes.find((candidate) => candidate.id === item.ticketTypeId)
      : item
    if (!ticketType?.isComplimentaryOfferEnabled || !Number.isInteger(quantity) || quantity <= 0)
      return 0

    const buyQuantity = ticketType.complimentaryOfferBuyQuantity || 1
    const freeQuantity = ticketType.complimentaryOfferFreeQuantity || 1
    if (!Number.isInteger(buyQuantity) || buyQuantity < 1 || !Number.isInteger(freeQuantity) || freeQuantity < 1)
      return 0

    return Math.floor(quantity / buyQuantity) * freeQuantity
  }

  /** Returns the total number of paid and complimentary tickets that will be issued. */
  public getIssuedTicketQuantity(quantity: number, item: TicketTypeData | CartItem): number {
    return quantity + this.getComplimentaryTicketQuantity(quantity, item)
  }

  /** Returns the translation key matching singular or plural purchased and complimentary quantities. */
  public getComplimentaryTranslationKey(baseKey: string, purchasedQuantity: number, complimentaryQuantity: number): string {
    const purchasedKey = purchasedQuantity === 1 ? 'SINGULAR' : 'PLURAL'
    const complimentaryKey = complimentaryQuantity === 1 ? 'SINGULAR' : 'PLURAL'
    return `${baseKey}.${purchasedKey}_${complimentaryKey}`
  }

  /** Returns the purchased quantity across every price line of one ticket type. */
  public getCartTicketTypeQuantity(item: CartItem): number {
    if (!item.ticketTypeId)
      return 0

    return this.cart
      .filter((candidate) => candidate.ticketTypeId === item.ticketTypeId)
      .reduce((total, candidate) => total + candidate.quantity, 0)
  }

  /** Indicates whether an item is the last displayed price line for its ticket type. */
  public isLastCartItemForTicketType(item: CartItem): boolean {
    if (!item.ticketTypeId)
      return false

    for (let index = this.cart.length - 1; index >= 0; index--) {
      if (this.cart[index].ticketTypeId === item.ticketTypeId)
        return this.cart[index] === item
    }
    return false
  }

  // Whether the ticket type behind the current visitor form has isMultipleVisitorForms == true.
  // Used to show/hide the "Ticket X/Y" header, distinct from the cart-level isMultipleVisitorForms getter above.
  get currentEntryIsMultipleVisitorForms(): boolean {
    const ticketTypeId = this.currentVisitorFormEntry?.ticketTypeId;
    const ticketType = this.ticketTypes.find(tt => tt.id === ticketTypeId);
    return !!ticketType?.isMultipleVisitorForms;
  }

  // Backs the visitor-form header: the ticket type name and its "Ticket X/Y" counter.
  get currentVisitorFormEntry(): VisitorToCartMapEntry | null {
    return this.visitorToCartMap[this.currentVisitorIndex] || null;
  }

  // Ticket type name shown in the visitor-form header. Resolved from the ticket type on every
  // change detection pass (rather than reusing the entry's ticketTypeLabel snapshot, which is
  // computed once when the cart is synced) so the title follows the language switcher.
  get currentVisitorFormTicketTypeLabel(): string {
    const entry = this.currentVisitorFormEntry;
    if (!entry) return '';
    const ticketType = this.ticketTypes.find(tt => tt.id === entry.ticketTypeId);
    return ticketType ? this.getLocalizedLabelFromTicketType(ticketType) : entry.ticketTypeLabel;
  }

  /** Returns whether the current visitor is the buyer and must confirm their email address. */
  get isEmailConfirmationRequiredForCurrentVisitor(): boolean {
    return !this.isMultipleVisitorForms || this.currentVisitorIndex === 0
  }

  get currentDescriptionContent(): string {
    if (!this.formData.descriptionContent) return ''
    return this.formData.descriptionContent[this.selectedLanguage] || ''
  }

  private _lastDescriptionContent: string = '';
  private _lastSafeDescriptionHtml: SafeHtml | null = null;

  get safeDescriptionHtml(): SafeHtml {
    const current = this.currentDescriptionContent;
    if (this._lastDescriptionContent !== current || !this._lastSafeDescriptionHtml) {
      this._lastDescriptionContent = current;
      this._lastSafeDescriptionHtml = this.sanitizer.bypassSecurityTrustHtml(current);
    }
    return this._lastSafeDescriptionHtml;
  }

  /** Calendar day used for automatic promotions, independent of the selected time slot. */
  get promotionDate(): string | null {
    return this.selectedDate ? getSlotSelectedCalendarDate(this.selectedDate) : null;
  }

  /** Returns the date promotion of one ticket type for the current selection. */
  getTicketDatePromotion(ticketType: TicketTypeData | undefined): DatePromotionConfig | null {
    return getDatePromotion(ticketType, this.promotionDate);
  }

  /** Returns a tariff after its date promotion without changing the stored base tariff. */
  getTicketDisplayPrice(ticketType: TicketTypeData, price: number): number {
    const promotion = this.getTicketDatePromotion(ticketType);
    return promotion && Number.isFinite(price)
      ? Math.round((price * (1 - promotion.percentage! / 100) + Number.EPSILON) * 100) / 100 : price;
  }

  /** Formats the promotion day and month in the selected language, including English ordinal days. */
  getDatePromotionTitle(date: string | null = this.promotionDate): string {
    const calendarDate = date ? parseSlotCalendarDate(date) : null;
    if (!calendarDate)
      return this.translateService.instant('DATE_PROMOTION.TITLE');

    const language = this.selectedLanguage || 'en';
    const formatter = new Intl.DateTimeFormat(language, { day: 'numeric', month: 'long' });
    const parts = formatter.formatToParts(calendarDate);
    let formattedDate = formatter.format(calendarDate);
    if (language.toLowerCase().split('-')[0] === 'en') {
      const day = calendarDate.getDate();
      const suffix = day >= 11 && day <= 13 ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' } as Record<number, string>)[day % 10] || 'th';
      formattedDate = `${day}${suffix} ${parts.find(part => part.type === 'month')!.value}`;
    } else if (language.toLowerCase().split('-')[0] === 'fr' && calendarDate.getDate() === 1) {
      formattedDate = parts.map(part => part.type === 'day' ? '1er' : part.value).join('');
    }
    return this.translateService.instant('DATE_PROMOTION.GROUP_TITLE', { date: formattedDate });
  }

  /** Resolves configured promotion text or a dated title, using the cart application's own day when available. */
  getDatePromotionLabel(promotion: DatePromotionConfig | DatePromotionApplication): string {
    return promotion.label?.[this.selectedLanguage]?.trim() || promotion.label?.[this.formData.eventDefaultLanguage]?.trim() ||
      this.getDatePromotionTitle('date' in promotion ? promotion.date : this.promotionDate);
  }

  /** Lists upcoming promotion days before the customer chooses a visit date. */
  getTicketDatePromotionNotice(ticketType: TicketTypeData): string {
    const today = getSlotSelectedCalendarDate(new Date())!;
    const offers = getDatePromotionDates(ticketType).filter(offer => offer.date >= today).map(offer => {
      const date = new Date(`${offer.date}T12:00:00`).toLocaleDateString(this.selectedLanguage, { day: '2-digit', month: '2-digit', year: 'numeric' });
      return `${date} (−${offer.promotion.percentage}%)`;
    });
    return offers.length ? this.translateService.instant('DATE_PROMOTION.UPCOMING', { dates: offers.join(', ') }) : '';
  }

  private _datePromotionBannersSource: TicketTypeData[] | TicketTypeData | null = null;
  private _datePromotionBannersKey = '';
  private _datePromotionBanners: DatePromotionBanner[] = [];

  /** Groups available date offers by percentage with their title and all affected categories. */
  get activeDatePromotionBanners(): DatePromotionBanner[] {
    const seatingEnabled = this.formData?.seatingEnabled;
    const source = seatingEnabled ? this.ticketTypes : this.selectedTicketType;
    const ticketTypes = seatingEnabled ? this.ticketTypes : (this.selectedTicketType?.id ? [this.selectedTicketType] : []);
    const unavailable = new Set(this.unavailableSeatMapTicketTypeIds);
    const mapTicketTypeIds = new Set(seatingEnabled ? (this.filteredSeatingConfig?.blocks || []).map(block => block.ticketTypeId) : []);
    const key = [this.promotionDate, this.selectedLanguage, this.formData?.eventDefaultLanguage, seatingEnabled,
      ticketTypes.length, [...unavailable].join(','), [...mapTicketTypeIds].join(',')].join('|');
    if (source === this._datePromotionBannersSource && key === this._datePromotionBannersKey)
      return this._datePromotionBanners;

    const groups = new Map<number, DatePromotionCategory[]>();
    for (const ticketType of ticketTypes) {
      if (unavailable.has(ticketType.id) || (seatingEnabled && !mapTicketTypeIds.has(ticketType.id)))
        continue;
      const promotion = this.getTicketDatePromotion(ticketType);
      if (!promotion)
        continue;
      const categories = groups.get(promotion.percentage!) || [];
      categories.push({
        ticketTypeId: ticketType.id,
        ticketTypeLabel: this.getLocalizedLabelFromTicketType(ticketType),
        label: this.getDatePromotionLabel(promotion),
        color: ticketType.color || '#000000'
      });
      groups.set(promotion.percentage!, categories);
    }
    this._datePromotionBannersSource = source;
    this._datePromotionBannersKey = key;
    this._datePromotionBanners = [...groups].map(([percentage, categories]) => {
      const sameLabel = categories.every(category => category.label === categories[0].label);
      const color = categories.length === 1 ? categories[0].color : 'var(--ion-color-primary)';
      return {
        key: `${this.promotionDate}|${percentage}`,
        ticketTypeIds: categories.map(category => category.ticketTypeId),
        categories,
        label: sameLabel ? categories[0].label : this.getDatePromotionTitle(),
        percentage,
        color,
        textColor: categories.length === 1 ? this.getReadableTextColor(color) : 'var(--ion-color-primary-contrast)'
      };
    });
    return this._datePromotionBanners;
  }

  /** Indicates whether the visible calendar contains promotion dates for the relevant categories. */
  get hasDatePromotions(): boolean {
    const ticketTypes = this.formData?.seatingEnabled ? this.ticketTypes : [this.selectedTicketType];
    return ticketTypes.some(ticketType => getDatePromotionDates(ticketType).some(offer =>
      (!this.openingDateISO || offer.date >= this.openingDateISO.substring(0, 10)) &&
      (!this.closingDateISO || offer.date <= this.closingDateISO.substring(0, 10))));
  }

  private _seatMapPromotionDate: string | null = null;
  private _seatMapPromotionSource: TicketTypeData[] | null = null;
  private _seatMapPromotionTicketTypes: TicketTypeData[] = [];

  /** Supplies discounted legend price ranges while keeping the cart tariff source unchanged. */
  get seatMapTicketTypes(): TicketTypeData[] {
    if (this._seatMapPromotionSource !== this.ticketTypes || this._seatMapPromotionDate !== this.promotionDate) {
      this._seatMapPromotionSource = this.ticketTypes;
      this._seatMapPromotionDate = this.promotionDate;
      this._seatMapPromotionTicketTypes = this.ticketTypes.map(ticketType => ({ ...ticketType,
        lowestPrice: this.getTicketDisplayPrice(ticketType, ticketType.lowestPrice!),
        highestPrice: this.getTicketDisplayPrice(ticketType, ticketType.highestPrice!)
      }));
    }
    return this._seatMapPromotionTicketTypes;
  }

  /** Total automatic savings, excluding manual promo codes and add-ons. */
  get automaticDiscountTotal(): number {
    return this.familyDiscountTotal + this.datePromotionTotal;
  }

  /** VAT of paid ticket lines after automatic discounts, excluding add-ons. */
  get automaticTicketVAT(): number {
    return this.cart.filter(item => item.ticketTypeId).reduce((total, item) => {
      const rate = item.vat / 100;
      return total + getFamilyDiscountedUnitPrice(item) * item.quantity * rate / (1 + rate);
    }, 0);
  }

  /** Keeps date promotion banners stable when Angular reevaluates the selected date. */
  trackByDatePromotionGroup(_index: number, banner: DatePromotionBanner): string {
    return banner.key;
  }

  private _lastFamilyDiscountBannersKey: string = '';
  private _lastFamilyDiscountBanners: { ticketTypeId: string, html: SafeHtml, label: string, color: string, textColor: string, percentage: number }[] = [];

  /** Banners of the available seat map family discounts (one per ticket type), in the selected language. */
  get familyDiscountBanners(): { ticketTypeId: string, html: SafeHtml, label: string, color: string, textColor: string, percentage: number }[] {
    if (!this.formData?.seatingEnabled) return [];
    const unavailableIds = this.unavailableSeatMapTicketTypeIds;
    const key = this.selectedLanguage + '|' + this.ticketTypes.length + '|' + unavailableIds.join(',') + '|' + this.promotionDate;
    if (key !== this._lastFamilyDiscountBannersKey) {
      this._lastFamilyDiscountBannersKey = key;
      this._lastFamilyDiscountBanners = this.ticketTypes
        .filter(tt => !unavailableIds.includes(tt.id) && !this.getTicketDatePromotion(tt) && getFamilyDiscount(tt) !== null)
        .map(tt => {
          const banner = tt.familyDiscount?.banner || {};
          const html = banner[this.selectedLanguage] || banner[this.formData.eventDefaultLanguage] || '';
          const text = html ? (new DOMParser().parseFromString(html, 'text/html').body.textContent || '') : '';
          return {
            ticketTypeId: tt.id,
            html: text.trim().length > 0 ? this.sanitizer.bypassSecurityTrustHtml(html) : null,
            label: this.getLocalizedLabelFromTicketType(tt),
            color: tt.color || '#000000',
            textColor: this.getReadableTextColor(tt.color || '#000000'),
            percentage: getFamilyDiscount(tt)!.percentage
          };
        })
        .filter(banner => banner.html !== null) as { ticketTypeId: string, html: SafeHtml, label: string, color: string, textColor: string, percentage: number }[];
    }
    return this._lastFamilyDiscountBanners;
  }

  /** Dark or white text, whichever reads best on a hex background color (white when the color can't be parsed). */
  getReadableTextColor(backgroundColor: string): string {
    let hex = backgroundColor.trim().replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(char => char + char).join('');
    if (!/^[0-9a-f]{6}$/i.test(hex)) return '#ffffff';
    const [r, g, b] = [0, 2, 4].map(i => parseInt(hex.substring(i, i + 2), 16) / 255);
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    return luminance > 0.6 ? '#1f2937' : '#ffffff';
  }

  // Individual category or date promotion group highlighted from a banner or the map legend.
  highlightedSeatMapTicketTypeId: string | null = null;
  highlightedDatePromotionKey: string | null = null;
  private _singleHighlightedTicketTypeIds: string[] = [];
  private _lastSeatMapCaptionKey: string = '';
  private _lastSeatMapCaption: string = '';
  private _lastSeatMapCaptionItems: string[] = [];

  /** Highlights on the seat map the ticket type of a family discount and brings the map into view. */
  highlightFamilyDiscountTicketType(ticketTypeId: string) {
    this.onSeatMapHighlightRequested(ticketTypeId);
    document.querySelector('app-seat-map-viewer')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /** Resolves the highlighted group for the current day and currently available categories. */
  get highlightedDatePromotion(): DatePromotionBanner | null {
    return this.highlightedDatePromotionKey
      ? this.activeDatePromotionBanners.find(banner => banner.key === this.highlightedDatePromotionKey) || null : null;
  }

  /** Supplies stable highlight inputs so basket changes do not restart the map animation. */
  get highlightedSeatMapTicketTypeIds(): string[] {
    const group = this.highlightedDatePromotion;
    if (group) return group.ticketTypeIds;
    const id = this.highlightedSeatMapTicketTypeId;
    if ((id && this._singleHighlightedTicketTypeIds[0] !== id) || (!id && this._singleHighlightedTicketTypeIds.length))
      this._singleHighlightedTicketTypeIds = id ? [id] : [];
    return this._singleHighlightedTicketTypeIds;
  }

  /** Provides a compact title for the group caption while individual categories use the map label. */
  get seatMapHighlightTitle(): string {
    const group = this.highlightedDatePromotion;
    return group && group.categories.length > 1
      ? `${group.label} · ${this.translateService.instant('DATE_PROMOTION.CATEGORY_COUNT', { count: group.categories.length })}` : '';
  }

  /** Frames every category in a date promotion, including repeated clicks on the active offer. */
  highlightDatePromotion(banner: DatePromotionBanner): void {
    if (this.highlightedDatePromotionKey === banner.key)
      this.seatMapViewer?.focusOnTicketTypes(banner.ticketTypeIds);
    this.highlightedSeatMapTicketTypeId = null;
    this.highlightedDatePromotionKey = banner.key;
    document.querySelector('app-seat-map-viewer')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /** Switches a group highlight to the individual category clicked in the map legend. */
  onSeatMapHighlightRequested(ticketTypeId: string | null): void {
    if (ticketTypeId && this.highlightedSeatMapTicketTypeId === ticketTypeId && !this.highlightedDatePromotionKey)
      this.seatMapViewer?.focusOnTicketTypes([ticketTypeId]);
    this.highlightedDatePromotionKey = null;
    this.highlightedSeatMapTicketTypeId = ticketTypeId;
  }

  /** Clears both individual and grouped highlights without changing the selected seats. */
  clearSeatMapHighlight(): void {
    this.highlightedDatePromotionKey = null;
    this.highlightedSeatMapTicketTypeId = null;
  }

  /** Marks the caption as applied once highlighted seats receive an automatic discount in the cart. */
  get isHighlightedSeatMapDiscountApplied(): boolean {
    const ids = this.highlightedSeatMapTicketTypeIds;
    return this.datePromotionApplications.some(application => ids.includes(application.ticketTypeId)) ||
      this.familyDiscountApplications.some(application => ids.includes(application.ticketTypeId));
  }

  /** Describes an automatic date offer or the package combination and its applied state on the map. */
  get seatMapHighlightCaption(): string {
    const group = this.highlightedDatePromotion;
    if (group)
      return `${group.categories.length === 1 ? group.label + ' ' : ''}−${group.percentage}% · ${this.translateService.instant('DATE_PROMOTION.AUTOMATIC_CAPTION')}`;
    const ticketTypeId = this.highlightedSeatMapTicketTypeId;
    if (!ticketTypeId) return '';
    const isApplied = this.isHighlightedSeatMapDiscountApplied;
    const key = ticketTypeId + '|' + this.selectedLanguage + '|' + isApplied + '|' + this.promotionDate;
    if (key !== this._lastSeatMapCaptionKey) {
      this._lastSeatMapCaptionKey = key;
      const ticketType = this.ticketTypes.find(tt => tt.id === ticketTypeId);
      const promotion = this.getTicketDatePromotion(ticketType);
      const discount = promotion ? null : getFamilyDiscount(ticketType);
      this._lastSeatMapCaptionItems = [];
      if (promotion) {
        this._lastSeatMapCaption = `${this.getDatePromotionLabel(promotion)} −${promotion.percentage}% · ${this.translateService.instant('DATE_PROMOTION.AUTOMATIC_CAPTION')}`;
      } else if (!discount) {
        this._lastSeatMapCaption = '';
      } else if (isApplied) {
        this._lastSeatMapCaption = this.translateService.instant('FAMILY_DISCOUNT.APPLIED_CAPTION', { percentage: discount.percentage });
      } else {
        const combinations = discount.combinations.map(quantities =>
          Array.from(quantities.entries()).map(([priceTag, quantity]) => `${quantity} × ${this.getTicketPriceTagLabel(priceTag, ticketTypeId)}`).join(' + ')
        );
        if (combinations.length > 1) {
          this._lastSeatMapCaption = this.translateService.instant('FAMILY_DISCOUNT.HIGHLIGHT_CAPTION_MULTIPLE', { percentage: discount.percentage });
          this._lastSeatMapCaptionItems = combinations;
        } else {
          this._lastSeatMapCaption = this.translateService.instant('FAMILY_DISCOUNT.HIGHLIGHT_CAPTION', { combination: combinations[0], percentage: discount.percentage });
        }
      }
    }
    return this._lastSeatMapCaption;
  }

  /** Combinations listed under the seat map caption when several combinations give the discount. */
  get seatMapHighlightCaptionItems(): string[] {
    if (this.highlightedDatePromotion || !this.highlightedSeatMapTicketTypeId) return [];
    void this.seatMapHighlightCaption; // Refreshes the memoized caption and its items
    return this._lastSeatMapCaptionItems;
  }

  get hasDescriptionForCurrentLanguage(): boolean {
    const content = this.currentDescriptionContent;
    if (!content) return false;
    // Use DOMParser to safely extract pure text, handling entities like &nbsp;
    const doc = new DOMParser().parseFromString(content, 'text/html');
    const textContent = doc.body.textContent || "";
    return textContent.trim().length > 0;
  }

  public ticketStep: 'typeSelection' | 'priceSelection' | 'dateSelection' | 'purchaseChoice' | 'giftCardSelection' = 'typeSelection'
  private routeSub: Subscription | undefined;
  public formId: string = ""
  public readonly openDaysOfferLabel: string = "Offre journées portes ouvertes"
  private readonly openDaysOfferFormIds: string[] = [
    'eh9Z7wMVO16zO6m4zr2C',
    'g4NlrAk3QBeF4I24dKl2'
  ]
  public molliePaymentStatus: string = ""
  public mollieCheckingStatusFailed: boolean = false
  public mollieCheckinStatusErrorCode: string = ""
  public mollieTransactionToken: string = ""
  public mollieCart: CartItem[] = []
  public molliePaidValue: number = 0
  public mollieOrderId: string = ""
  public molliePaymentId: string = ""
  // SEPA Bank Transfer details to show while the transfer is awaited (status 'banktransfer-pending')
  public mollieBankTransfer: { bankName: string | null, bankAccount: string | null, bankBic: string | null, transferReference: string | null } | null = null
  public isExchangeMode: boolean = false;
  public exchangeState: any = null;
  public mollieEmail: string = '';

  // Temporary booking
  reservationId: string | null = null;
  reservationExpiry: Date | null = null;
  reservationCountdown: string = '';
  reservationInterval: any;
  public mollieFullName: string = ""
  public isFormLoaded: boolean = false
  private isMetaPixelInitialized: boolean = false
  public formData: FormData = {} as FormData
  public ticketTypes: TicketTypeData[] = []
  // Ticket types not on sale yet / anymore (admin "Mise en vente" settings)
  private outOfSalesWindowTicketTypeIds: string[] = []
  public activePromoCodes: PromoCodeData[] = []
  public addOns: AddOnData[] = []
  public selectedTicketType: TicketTypeData = {} as TicketTypeData
  // Seat map events: gift cards are sold apart from the seats, after the tickets / gift cards choice or on their hidden link
  public giftCardTicketTypes: TicketTypeData[] = []
  public seatMapPurchaseMode: 'tickets' | 'giftCards' | null = null

  public progress: number = 0
  public isAuthenticated: boolean = false

  public profileString: 'white' | 'galleria610' | 'gridx' | 'sro' = 'white'

  /**
   * ticketTypes
   */
  totalPrice: number = 0
  totalTicketTypePrice: number = 0
  totalTicketTypeVAT: number = 0
  totalAddOnPrice: number = 0
  totalAddOnVAT: number = 0
  totalPriceAfterPromotion: number = 0
  totalVAT: number = 0
  totalVATAfterPromotion: number = 0
  familyDiscountApplications: FamilyDiscountApplication[] = []
  familyDiscountTotal: number = 0
  datePromotionApplications: DatePromotionApplication[] = []
  datePromotionTotal: number = 0
  isTicketSelected: boolean = false
  get isSingleFreeTicketFlow(): boolean {
    return this.ticketTypes.length === 1 &&
      this.ticketTypes[0].isFree &&
      this.ticketTypes[0].maxPerOrder === 1 &&
      !this.requiresDateSelection(this.ticketTypes[0]) &&
      this.addOns.length === 0
  }

  get isDescriptionTabActive(): boolean {
    return !!(
      this.formData?.descriptionEnabled === true &&
      this.formData?.descriptionDisplayType === 'tab' &&
      this.hasDescriptionForCurrentLanguage
    );
  }

  /** True when a seat map event form is opened with its hidden gift cards link. */
  get isGiftCardLink(): boolean {
    return this.formData?.seatingEnabled === true && this.queryParameters['hiddenGiftCards'] === 'true'
  }

  /** Seat map events selling gift cards: the customer first chooses between tickets and gift cards. */
  get hasSeatMapPurchaseChoice(): boolean {
    return this.giftCardTicketTypes.length > 0 && !this.isGiftCardLink
  }

  /** Identifies the link a reservation is made on: '' (normal form), 'hiddenTicket:<id>' or 'hiddenGiftCards'. */
  get reservationLinkKey(): string {
    if (this.isGiftCardLink) return 'hiddenGiftCards'
    const hiddenTicketId = this.queryParameters['hiddenTicket']
    return (typeof hiddenTicketId === 'string' && hiddenTicketId.length > 0) ? 'hiddenTicket:' + hiddenTicketId : ''
  }

  /** True when the customer buys gift cards of a seat map event (no seats, no add-ons). */
  get isGiftCardMode(): boolean {
    return this.seatMapPurchaseMode === 'giftCards'
  }
  isPriceSelected: boolean = false
  isTypeSelectionSkipped: boolean = false
  cart: CartItem[] = []

  timeSlots: TimeSlot[] = []
  bookedSlotTickets: any[] = []
  allTicketTypesAvailability: Record<string, any[]> = {}
  allTicketTypesAvailabilityForSelectedDate: Record<string, any> = {}
  openingDateISO: string = this.getCalendarDateISO()
  closingDateISO: string = "" // Set when loading the form
  selectedDateISO: string = ""
  selectedDate: Date | null = null
  selectedTime: string = ""
  isSlotSelected: boolean = false
  selectedSlotTickets: TimeSlot = {} as TimeSlot
  selectedSeats: any[] = []
  soldSeats: string[] = []

  private lastSelectedSeats: any[] = []
  async onSeatSelected(seats: any[]) {
    // Identify newly selected seats
    const newSeats = seats.filter(s => !this.lastSelectedSeats.some(os => os.id === s.id));
    this.lastSelectedSeats = [...seats];
    this.selectedSeats = seats;

    for (const seat of newSeats) {
      const tt = this.ticketTypes.find(t => t.id === seat.ticketTypeId);
      if (tt) {
        const priceTag = await this.askForPrice(tt, seat);
        if (priceTag) {
          seat.priceTag = priceTag;
        } else {
          // User cancelled -> Unselect
          if (this.seatMapViewer) {
            this.seatMapViewer.selectedSeats.delete(seat.id);
            this.seatMapViewer.cdr.detectChanges();
            // Refresh local selectedSeats
            this.selectedSeats = Array.from(this.seatMapViewer.selectedSeats.values() as Iterable<any>);
            this.lastSelectedSeats = [...this.selectedSeats];
          }
        }
      }
    }

    this.computeBasketValue();
  }

  async askForPrice(ticketType: TicketTypeData, seat?: any): Promise<string | null> {
    const isEarlyBird = this.isEarlyBirdActiveForTicket(ticketType);
    const inputs: any[] = [
      {
        name: 'price',
        type: 'radio',
        label: `${isEarlyBird ? this.translateService.instant('GENERIC.EARLY-BIRD') : this.getLocalizedNormalPriceLabel(ticketType)} (${this.getTicketDisplayPrice(ticketType, isEarlyBird ? ticketType.earlyBirdPrice : ticketType.price).toFixed(2)}€)`,
        value: isEarlyBird ? 'early-bird' : 'normal',
        checked: true
      }
    ];

    if (ticketType.isStudentDiscount) {
      inputs.push({
        name: 'price',
        type: 'radio',
        label: `${this.translateService.instant('TICKET_PRICES.STUDENT')} (${this.getTicketDisplayPrice(ticketType, ticketType.studentPrice).toFixed(2)}€)`,
        value: 'student'
      });
    }

    if (ticketType.isChildrenDiscount) {
      inputs.push({
        name: 'price',
        type: 'radio',
        label: `${this.getLocalizedChildrenPriceLabel(ticketType)} ${ticketType.childrenMinAge}-${ticketType.childrenMaxAge} ${this.translateService.instant('GENERIC.YEAR_OLD')} (${this.getTicketDisplayPrice(ticketType, ticketType.childrenPrice).toFixed(2)}€)`,
        value: 'children'
      });
    }

    if (ticketType.isYouthDiscount) {
      inputs.push({
        name: 'price',
        type: 'radio',
        label: `${this.getLocalizedYouthPriceLabel(ticketType)} ${ticketType.youthMinAge}-${ticketType.youthMaxAge} ${this.translateService.instant('GENERIC.YEAR_OLD')} (${this.getTicketDisplayPrice(ticketType, ticketType.youthPrice).toFixed(2)}€)`,
        value: 'youth'
      });
    }

    if (ticketType.isSeniorDiscount) {
      inputs.push({
        name: 'price',
        type: 'radio',
        label: `${this.getLocalizedSeniorPriceLabel(ticketType)} ${ticketType.seniorMinAge}+ ${this.translateService.instant('GENERIC.YEAR_OLD')} (${this.getTicketDisplayPrice(ticketType, ticketType.seniorPrice).toFixed(2)}€)`,
        value: 'senior'
      });
    }

    if (ticketType.isDisabledDiscount) {
      inputs.push({
        name: 'price',
        type: 'radio',
        label: `${this.getLocalizedDisabledPriceLabel(ticketType)} (${this.getTicketDisplayPrice(ticketType, ticketType.disabledPrice).toFixed(2)}€)`,
        value: 'disabled'
      });
    }

    return new Promise(async (resolve) => {
      const pickPriceText = this.translateService.instant('TICKET_PRICES.PICK_PRICE_ON_MAP');
      const subHeader = seat
        ? `${this.translateService.instant('TICKET_PRICES.SEAT_LOCATION', { row: seat.row, col: seat.number })} — ${pickPriceText}`
        : pickPriceText;
      const message = seat?.isDisabledAccessible
        ? this.translateService.instant('TICKET_PRICES.SEAT_DISABLED_ACCESSIBLE_WARNING')
        : undefined;
      const alert = await this.alertController.create({
        header: this.getLocalizedLabelFromTicketType(ticketType),
        subHeader: subHeader,
        message: message,
        inputs: inputs,
        buttons: [
          {
            text: this.translateService.instant('GENERIC.CANCEL'),
            role: 'cancel',
            handler: () => resolve(null)
          },
          {
            text: this.translateService.instant('GENERIC.CONFIRM'),
            handler: (data) => resolve(data)
          }
        ],
        backdropDismiss: false,
        cssClass: seat?.isDisabledAccessible ? 'price-selection-alert disabled-seat-alert' : 'price-selection-alert'
      });
      await alert.present();
    });
  }

  public isEarlyBirdActiveForTicket(ticketType: TicketTypeData): boolean {
    if (!ticketType?.isEarlyBird || !ticketType.earlyBirdDate?.seconds) {
      return false;
    }
    const earlyBirdTimestamp = ticketType.earlyBirdDate.seconds * 1000;
    return earlyBirdTimestamp > Date.now();
  }

  // Form attribute
  inputForm: FormGroup = {} as FormGroup
  isFormSubmitted: boolean = false
  isWelkomAgreementChecked: boolean = false
  isOrganizerAgreementChecked: boolean = false
  isKoruAgreementChecked: boolean = false
  // isInternationalAgreementChecked: boolean = false
  isSwapcardFirstAgreementChecked: boolean = true
  isSwapcardSecondAgreementChecked: boolean = true
  isOptinChecked: boolean = false
  recordingUser: boolean = false
  isFormSubmissionRecorded: boolean = false

  personalDomainNames: any[] = [];  // Tableau pour stocker les données
  isPersonalEmail: boolean = false
  isPersonalEmailBlocked: boolean = false
  isConfirmEmailAsked: boolean = false
  // Cart items discounted by the promo code: labels are resolved in the current language when displayed
  public promoApplicationDetails: { cartItem: CartItem, quantity: number }[] = []
  isConfirmEmailDifferent: boolean = false
  isPasteEmailBlocked: boolean = false
  isReallyNexusClient: boolean = false
  isLuxexpoClient: boolean = false
  visitorForms: FormGroup[] = []
  currentVisitorIndex: number = 0
  totalVisitorCount: number = 0
  // One entry per generated visitor form. `targets` lists every (cartIndex, visitorIdx) slot that
  // form's answers get written back to: a single slot for per-unit forms, or every unit across every
  // cart line of that ticket type for the once-per-ticket-type forms (see syncVisitorFormsWithCart).
  // `formIndexInTicketType`/`ticketTypeQuantity` back the "Ticket X/Y" label for that ticket type.
  // `cartQuantity` is the actual number of units of that ticket type in the cart, always correct
  // regardless of isMultipleVisitorForms (unlike ticketTypeQuantity, which is hardcoded to 1 for
  // once-per-ticket-type shared forms) — used to display quantity for isMultipleVisitorForms == false.
  visitorToCartMap: VisitorToCartMapEntry[] = []

  queryParameters: any = {}
  isPreview: boolean = false

  isRefundPolicyExpired: boolean = false
  isFormClosed: boolean = false

  refundTickets: any[] = [];
  selectedRefundTickets: { [ticketId: string]: boolean } = {};
  refundSeatingEnabled: boolean = false;
  isEventRefundable: boolean = false;
  isEventExchangeable: boolean = false;
  /** Order made of free tickets only: the customer can only cancel the reservation */
  isFreeReservation: boolean = false;
  hasFixedRefundFee: boolean = false;
  fixedRefundFeeAmount: number = 0;

  appliedPromoCode: PromoCodeData | null = null

  /** Returns whether the automatic Open Days offer applies to the selected form date. */
  get isOpenDaysOfferApplied(): boolean {
    return this.openDaysOfferFormIds.includes(this.formId) &&
      this.selectedDate !== null &&
      this.selectedDate.getFullYear() === 2026 &&
      this.selectedDate.getMonth() === 8 &&
      [19, 20].includes(this.selectedDate.getDate())
  }

  /** Returns whether a manual or automatic promotion currently affects the basket. */
  get hasAppliedPromotion(): boolean {
    return this.isOpenDaysOfferApplied || this.appliedPromoCode !== null || this.familyDiscountApplications.length > 0 || this.datePromotionApplications.length > 0
  }

  // Default values for development
  defaultDevFirstName: string = ""
  defaultDevLastName: string = ""
  defaultDevEmail: string = ""

  // UTM LINKS
  utm_source: string = ''
  utm_medium: string = ''
  utm_campaign: string = ''
  utm_content: string = ''
  utm_term: string = ''

  production: boolean = environment.production
  // production: boolean = true
  isTicketDelivered: boolean = true
  isOptinVisible: boolean = true
  isOrganizerTermsVisible: boolean = true
  isWelkomTermsVisible: boolean = true

  firstLoadingBarInterval: any = null
  seatRefreshInterval: any = null

  selectedLanguage: string = 'en'

  isTwoManyLoginAttemps: boolean = false
  twoManyLoginAttemptsInterval: any = null
  twoManyLoginAttemptsTimeout: any = null
  twoManyLoginAttemptsTimer: number = 0

  constructor(
    private zone: NgZone,
    private meta: Meta,
    private route: ActivatedRoute,
    private location: Location,
    private functions: Functions,
    private auth: Auth,
    public formBuilder: FormBuilder,
    private loadingControler: LoadingController,
    private alertController: AlertController,
    private popoverController: PopoverController,
    private http: HttpClient,
    private translateService: TranslateService,
    private titleService: Title,
    private pixel: PixelService,
    private sanitizer: DomSanitizer
  ) {
    addIcons({ optionsOutline, removeOutline, addOutline, arrowBackOutline, arrowForwardOutline, mailOutline, personOutline, callOutline, locationOutline, calendarNumberOutline, businessOutline, cardOutline, ticketOutline, checkmarkOutline, helpOutline, chevronDownOutline, languageOutline, timeOutline, informationCircleOutline, createOutline, swapHorizontalOutline, closeCircleOutline });
  }

  /** Selected seats grouped by ticket type, each seat with its price tag label. */
  get selectedSeatsSummary() {
    if (!this.selectedSeats || this.selectedSeats.length === 0) return [];
    type SummarySeat = { id: string, blockName: string, row: any, number: any, priceTagLabel: string };
    const summary = new Map<string, { key: string, name: string, count: number, color: string, seats: SummarySeat[] }>();

    for (const seat of this.selectedSeats) {
      const type = this.ticketTypes.find(t => t.id === seat.ticketTypeId);
      if (!type) continue;

      const entry = summary.get(seat.ticketTypeId) || {
        key: seat.ticketTypeId,
        name: this.getLocalizedLabelFromTicketType(type),
        count: 0,
        color: type.color || '#000000',
        seats: [] as SummarySeat[]
      };
      entry.count++;
      entry.seats.push({
        id: seat.id,
        blockName: seat.blockName,
        row: seat.row,
        number: seat.number,
        priceTagLabel: this.getTicketPriceTagLabel(seat.priceTag || 'normal', seat.ticketTypeId)
      });
      summary.set(seat.ticketTypeId, entry);
    }

    return Array.from(summary.values());
  }

  // Stable DOM for the cart card: the summary is rebuilt on every change detection
  trackBySummaryKey(_index: number, item: { key: string }): string {
    return item.key;
  }

  trackByTicketTypeId(_index: number, ticketType: TicketTypeData): string {
    return ticketType.id;
  }

  trackByAddOnId(_index: number, addOn: AddOnData): string {
    return addOn.id;
  }

  trackBySeatId(_index: number, seat: any): string {
    return seat.id;
  }

  /** Removes a seat from the selection from the cart card (the seat map is synced through [initialSelectedSeats]). */
  removeSelectedSeat(seatId: string) {
    this.selectedSeats = this.selectedSeats.filter(seat => seat.id !== seatId);
    this.lastSelectedSeats = [...this.selectedSeats];
    this.computeBasketValue();
  }

  /** Removes all the selected seats from the cart card, after confirmation. */
  async emptySelectedSeats() {
    const alert = await this.alertController.create({
      header: this.translateService.instant('SEAT_MAP_CART.EMPTY_CONFIRM_TITLE'),
      message: this.translateService.instant('SEAT_MAP_CART.EMPTY_CONFIRM_MESSAGE'),
      buttons: [
        { text: this.translateService.instant('GENERIC.CANCEL'), role: 'cancel' },
        {
          text: this.translateService.instant('SEAT_MAP_CART.EMPTY'),
          role: 'destructive',
          handler: () => {
            this.selectedSeats = [];
            this.lastSelectedSeats = [];
            this.computeBasketValue();
          }
        }
      ]
    });
    await alert.present();
  }

  get totalSelectedSeatsPrice(): number {
    let total = 0;
    for (const seat of this.selectedSeats) {
      const type = this.ticketTypes.find(t => t.id === seat.ticketTypeId);
      if (type) {
        const priceTag = seat.priceTag || 'normal';
        let tagPrice = type.price;
        if (priceTag === 'early-bird' && type.isEarlyBird) tagPrice = type.earlyBirdPrice;
        else if (priceTag === 'student' && type.isStudentDiscount) tagPrice = type.studentPrice;
        else if (priceTag === 'children' && type.isChildrenDiscount) tagPrice = type.childrenPrice;
        else if (priceTag === 'youth' && type.isYouthDiscount) tagPrice = type.youthPrice;
        else if (priceTag === 'senior' && type.isSeniorDiscount) tagPrice = type.seniorPrice;
        else if (priceTag === 'disabled' && type.isDisabledDiscount) tagPrice = type.disabledPrice;
        total += tagPrice;
      }
    }
    return total;
  }

  // Complimentary offer text of a ticket type (null when not enabled)
  getComplimentaryOfferLabel(ticketType: TicketTypeData): string | null {
    if (!ticketType?.isComplimentaryOfferEnabled) return null;
    const buy = ticketType.complimentaryOfferBuyQuantity || 1;
    const free = ticketType.complimentaryOfferFreeQuantity || 1;
    return this.translateService.instant(this.getComplimentaryTranslationKey('TICKET_TYPES.COMPLIMENTARY_OFFER', buy, free), { buy, free });
  }

  public getLocalizedLabelFromTicketType(type: any): string {
    if (!type.label) return '';
    if (typeof type.label === 'string') return type.label;
    return type.label[this.selectedLanguage] || type.label[this.formData?.eventDefaultLanguage || 'en'] || (Object.values(type.label).length > 0 ? Object.values(type.label)[0] : '') as string || '';
  }

  public getLocalizedDescriptionFromTicketType(type: any): string {
    if (!type.description) return '';
    if (typeof type.description === 'string') return type.description;
    return type.description[this.selectedLanguage] || type.description[this.formData?.eventDefaultLanguage || 'en'] || (Object.values(type.description).length > 0 ? Object.values(type.description)[0] : '') as string || '';
  }

  setLanguage(lang: string) {
    this.translateService.use(lang);
    this.selectedLanguage = lang

    // Keep the URL "lang" query param in sync with the selected language.
    // This ensures that when Mollie redirects back to this URL after payment,
    // the correct language is applied instead of the original connection language.
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('lang', lang);
    const newUrl = window.location.pathname + '?' + urlParams.toString();
    this.location.replaceState(newUrl);

    // If viewing description but new language doesn't have one, jump to tickets
    if (this.step === '0' && (this.formData?.descriptionEnabled !== true || !this.hasDescriptionForCurrentLanguage)) {
      this.step = '1'
      this.stepProgress = 0.11
    }
  }

  getLocalizedLabel(input: FormInput): string {
    if (!input) return '';

    // Prioritize translation for predefined fields (handle duplicates with suffixes like _1)
    const baseFieldName = input.fieldName.split('_')[0];
    const translated = this.translateService.instant('INPUTS.' + baseFieldName);
    if (translated !== 'INPUTS.' + baseFieldName) {
      return translated;
    }

    if (!input.label) return '';
    if (typeof input.label === 'string') return input.label;
    return input.label[this.selectedLanguage] || input.label['en'] || (Object.values(input.label).length > 0 ? Object.values(input.label)[0] : '') as string || '';
  }

  getLocalizedHelperText(input: FormInput): string {
    if (!input.helperText) return ' ';
    if (typeof input.helperText === 'string') return input.helperText;
    return input.helperText[this.selectedLanguage] || input.helperText['en'] || (Object.values(input.helperText).length > 0 ? Object.values(input.helperText)[0] : ' ') as string || ' ';
  }

  getLocalizedOptionLabel(option: any): string {
    if (!option.label) return '';
    if (typeof option.label === 'string') return option.label;
    return option.label[this.selectedLanguage] || option.label['en'] || (Object.values(option.label).length > 0 ? Object.values(option.label)[0] : '') as string || '';
  }

  getLocalizedSectionTitle(section: FormSection): string {
    if (!section.title) return '';
    if (typeof section.title === 'string') return section.title;
    return section.title[this.selectedLanguage] || '';
  }

  // Returns whether the section contains at least one input visible in the current context.
  hasVisibleInputsInSection(section: FormSection): boolean {
    return section.inputs.some(input => !this.hideBasedOnInputConditions(input))
  }

  getLocalizedNormalPriceLabel(ticketType: TicketTypeData): string {
    if (!ticketType) return this.translateService.instant('GENERIC.NORMAL');
    const label = ticketType.normalPriceLabel;
    if (!label) return this.translateService.instant('GENERIC.NORMAL');
    if (typeof label === 'string' && label.trim() !== '') return label;
    if (typeof label === 'object') {
      const currentLang = this.selectedLanguage || 'en';
      const localized = label[currentLang];
      if (typeof localized === 'string' && localized.trim() !== '') {
        return localized;
      }
    }
    return this.translateService.instant('GENERIC.NORMAL');
  }

  getLocalizedSeniorPriceLabel(ticketType: TicketTypeData): string {
    if (!ticketType) return this.translateService.instant('TICKET_PRICES.SENIOR');
    const label = ticketType.seniorPriceLabel;
    if (!label) return this.translateService.instant('TICKET_PRICES.SENIOR');
    if (typeof label === 'string' && label.trim() !== '') return label;
    if (typeof label === 'object') {
      const currentLang = this.selectedLanguage || 'en';
      const localized = label[currentLang];
      if (typeof localized === 'string' && localized.trim() !== '') {
        return localized;
      }
    }
    return this.translateService.instant('TICKET_PRICES.SENIOR');
  }

  getLocalizedDisabledPriceLabel(ticketType: TicketTypeData): string {
    if (!ticketType) return this.translateService.instant('TICKET_PRICES.DISABLED');
    const label = ticketType.disabledPriceLabel;
    if (!label) return this.translateService.instant('TICKET_PRICES.DISABLED');
    if (typeof label === 'string' && label.trim() !== '') return label;
    if (typeof label === 'object') {
      const currentLang = this.selectedLanguage || 'en';
      const localized = label[currentLang];
      if (typeof localized === 'string' && localized.trim() !== '') {
        return localized;
      }
    }
    return this.translateService.instant('TICKET_PRICES.DISABLED');
  }

  getLocalizedYouthPriceLabel(ticketType: TicketTypeData): string {
    if (!ticketType) return this.translateService.instant('TICKET_PRICES.YOUTH');
    const label = ticketType.youthPriceLabel;
    if (!label) return this.translateService.instant('TICKET_PRICES.YOUTH');
    if (typeof label === 'string' && label.trim() !== '') return label;
    if (typeof label === 'object') {
      const currentLang = this.selectedLanguage || 'en';
      const localized = label[currentLang];
      if (typeof localized === 'string' && localized.trim() !== '') {
        return localized;
      }
    }
    return this.translateService.instant('TICKET_PRICES.YOUTH');
  }

  getLocalizedChildrenPriceLabel(ticketType: TicketTypeData): string {
    if (!ticketType) return this.translateService.instant('TICKET_PRICES.CHILDREN');
    const label = ticketType.childrenPriceLabel;
    if (!label) return this.translateService.instant('TICKET_PRICES.CHILDREN');
    if (typeof label === 'string' && label.trim() !== '') return label;
    if (typeof label === 'object') {
      const currentLang = this.selectedLanguage || 'en';
      const localized = label[currentLang];
      if (typeof localized === 'string' && localized.trim() !== '') {
        return localized;
      }
    }
    return this.translateService.instant('TICKET_PRICES.CHILDREN');
  }

  // Resolves the text shown instead of a price for a free ticket type.
  // freeLabel undefined/null means the ticket predates this feature (fallback to translated "FREE").
  // An explicitly empty string for the resolved language means the organizer chose to show nothing.
  getFreeLabel(ticketType: TicketTypeData): string {
    const defaultFreeLabel = this.translateService.instant('TICKET_PRICES.FREE');
    if (!ticketType || typeof ticketType.freeLabel === 'undefined' || ticketType.freeLabel === null)
      return defaultFreeLabel;

    if (typeof ticketType.freeLabel === 'string')
      return ticketType.freeLabel;

    const currentLang = this.selectedLanguage || 'en';
    const defaultLang = this.formData?.eventDefaultLanguage || 'en';
    let resolved = ticketType.freeLabel[currentLang];
    if (typeof resolved === 'undefined')
      resolved = ticketType.freeLabel[defaultLang];
    if (typeof resolved === 'undefined')
      return defaultFreeLabel;

    return resolved;
  }

  getTicketPriceTagLabel(priceTag: string | undefined | null, ticketTypeId: string | undefined | null): string {
    if (!priceTag) return "";
    const tagLower = priceTag.toLowerCase();
    const ticketType = (this.formData && this.formData.ticketTypes)
      ? this.formData.ticketTypes.find((tt: any) => tt.id === ticketTypeId)
      : null;

    let resolvedTag = "";
    if (tagLower === 'normal') {
      resolvedTag = this.getLocalizedNormalPriceLabel(ticketType as any);
    } else if (tagLower === 'senior') {
      resolvedTag = this.getLocalizedSeniorPriceLabel(ticketType as any);
    } else if (tagLower === 'disabled') {
      resolvedTag = this.getLocalizedDisabledPriceLabel(ticketType as any);
    } else if (tagLower === 'youth') {
      resolvedTag = this.getLocalizedYouthPriceLabel(ticketType as any);
    } else if (tagLower === 'children') {
      resolvedTag = this.getLocalizedChildrenPriceLabel(ticketType as any);
    } else if (tagLower === 'student') {
      resolvedTag = this.translateService.instant('TICKET_PRICES.STUDENT');
    } else if (tagLower === 'early-bird') {
      resolvedTag = this.translateService.instant('GENERIC.EARLY-BIRD');
    } else {
      resolvedTag = priceTag.charAt(0).toUpperCase() + priceTag.slice(1);
    }
    return resolvedTag;
  }

  getTicketConfirmationTagLabel(cartItem: any): string {
    if (!cartItem || !cartItem.ticketTypeId || !cartItem.priceTag) return '';
    const tagLower = cartItem.priceTag.toLowerCase();
    const resolvedTag = this.getTicketPriceTagLabel(cartItem.priceTag, cartItem.ticketTypeId);
    if (tagLower === 'normal') {
      if (resolvedTag && resolvedTag !== 'Normal' && resolvedTag !== this.translateService.instant('GENERIC.NORMAL')) {
        return resolvedTag;
      }
      return '';
    }
    return resolvedTag;
  }

  // Cart recap of the add-ons step (tickets, package discounts, add-ons): rebuilt only when the cart or the language changes
  private _cartRecapKey: [CartItem[], FamilyDiscountApplication[], DatePromotionApplication[], string] | null = null;
  private _cartRecapGroups: CartRecapGroup[] = [];
  get cartRecapGroups(): CartRecapGroup[] {
    const language = this.translateService.currentLang;
    if (this._cartRecapKey && this._cartRecapKey[0] === this.cart && this._cartRecapKey[1] === this.familyDiscountApplications && this._cartRecapKey[2] === this.datePromotionApplications && this._cartRecapKey[3] === language)
      return this._cartRecapGroups;

    const ticketLines = new Map<string, CartRecapLine>();
    const addOnLines: CartRecapLine[] = [];
    for (const cartItem of this.cart) {
      const amount = (cartItem.price || 0) * cartItem.quantity;
      if (cartItem.ticketTypeId) {
        // Seats are one cart item each: one line per ticket type and price tag
        const key = `${cartItem.ticketTypeId}|${cartItem.priceTag}`;
        const line = ticketLines.get(key);
        if (line) {
          line.quantity += cartItem.quantity;
          line.amount += amount;
          continue;
        }
        // Price tag always shown, default price included
        const detail = cartItem.priceTag === 'normal' ? this.getTicketPriceTagLabel(cartItem.priceTag, cartItem.ticketTypeId) : this.getCartRecapPriceTagLabel(cartItem);
        ticketLines.set(key, { key, label: this.getLocalizedLabelFromTicketType(cartItem), detail, quantity: cartItem.quantity, amount, dot: true, color: this.getTicketTypeColor(cartItem.ticketTypeId) });
      } else if (cartItem.addOnId) {
        addOnLines.push({ key: cartItem.addOnId, label: this.getLocalizedLabelFromTicketType(cartItem), quantity: cartItem.quantity, amount, dot: true, color: this.getAddOnColor(cartItem.addOnId) });
      }
    }

    const ticketGroupLines = Array.from(ticketLines.values());
    for (const application of this.datePromotionApplications) {
      ticketGroupLines.push({
        key: `datePromotion|${application.ticketTypeId}`,
        label: `${this.getDatePromotionLabel(application)} −${application.percentage}%`,
        detail: this.getLocalizedLabelFromTicketType(this.ticketTypes.find(ticketType => ticketType.id === application.ticketTypeId)),
        quantity: 0, amount: application.amount, discount: true, dot: true, color: this.getTicketTypeColor(application.ticketTypeId)
      });
    }
    for (const application of this.familyDiscountApplications) {
      ticketGroupLines.push({
        key: `discount|${application.ticketTypeId}`,
        label: `${this.translateService.instant('CONFIRMATION.FAMILY_DISCOUNT_APPLIED')} -${application.percentage}%`,
        detail: this.getFamilyDiscountTicketTypeLabel(application),
        quantity: 0,
        amount: application.amount,
        discount: true,
        dot: true,
        color: this.getTicketTypeColor(application.ticketTypeId)
      });
    }

    const groups: CartRecapGroup[] = [];
    if (ticketGroupLines.length > 0)
      groups.push({ key: 'tickets', title: this.translateService.instant('GENERIC.TICKETS'), lines: ticketGroupLines });
    if (addOnLines.length > 0)
      groups.push({ key: 'addOns', title: this.translateService.instant('GENERIC.ADD_ONS'), lines: addOnLines });

    this._cartRecapKey = [this.cart, this.familyDiscountApplications, this.datePromotionApplications, language];
    this._cartRecapGroups = groups;
    return groups;
  }

  // Ticket lines of the cart recap only (ticket type step: its total excludes the add-ons)
  private _ticketRecapSource: CartRecapGroup[] | null = null;
  private _ticketRecapGroups: CartRecapGroup[] = [];
  get ticketRecapGroups(): CartRecapGroup[] {
    const groups = this.cartRecapGroups;
    if (groups !== this._ticketRecapSource) {
      this._ticketRecapGroups = groups.filter(group => group.key === 'tickets');
      this._ticketRecapSource = groups;
    }
    return this._ticketRecapGroups;
  }

  // Price tag of a cart recap line ('' for the default price)
  getCartRecapPriceTagLabel(cartItem: CartItem): string {
    if (cartItem.priceTag === 'family-group')
      return this.translateService.instant('TICKET_PRICES.FAMILY_GROUP');
    if (cartItem.priceTag === 'regular-group')
      return this.translateService.instant(this.isReallyNexusClient ? 'TICKET_PRICES.NEXUS_REGULAR_GROUP' : 'TICKET_PRICES.REGULAR_GROUP');
    return this.getTicketConfirmationTagLabel(cartItem);
  }

  // Discount lines of the cart step total (package discounts, promo code or open days offer): rebuilt only when the promotion, the totals or the language change
  private _confirmationDiscountKey: any[] | null = null;
  private _confirmationDiscountGroups: CartRecapGroup[] = [];
  get confirmationDiscountGroups(): CartRecapGroup[] {
    const key = [this.familyDiscountApplications, this.datePromotionApplications, this.appliedPromoCode, this.promoApplicationDetails, this.isOpenDaysOfferApplied, this.totalPrice, this.totalPriceAfterPromotion, this.translateService.currentLang];
    if (this._confirmationDiscountKey && key.every((value, index) => value === this._confirmationDiscountKey![index]))
      return this._confirmationDiscountGroups;

    const lines: CartRecapLine[] = this.familyDiscountApplications.map(application => {
      const quantities = application.quantities.map(detail => `${detail.quantity}× ${this.getTicketPriceTagLabel(detail.priceTag, application.ticketTypeId)}`).join(', ');
      return {
        key: `discount|${application.ticketTypeId}`,
        label: `${this.translateService.instant('CONFIRMATION.FAMILY_DISCOUNT_APPLIED')} -${application.percentage}%`,
        detail: `${this.getFamilyDiscountTicketTypeLabel(application)} (${quantities})`,
        quantity: 0,
        amount: application.amount,
        discount: true
      };
    });

    for (const application of this.datePromotionApplications) {
      lines.push({
        key: `datePromotion|${application.ticketTypeId}`,
        label: `${this.getDatePromotionLabel(application)} −${application.percentage}%`,
        detail: this.getLocalizedLabelFromTicketType(this.ticketTypes.find(ticketType => ticketType.id === application.ticketTypeId)),
        quantity: 0, amount: application.amount, discount: true
      });
    }

    // Promo code or open days offer: what remains after automatic discounts.
    const promotionAmount = Math.max(0, this.totalPrice - this.automaticDiscountTotal - this.totalPriceAfterPromotion);
    if (this.isOpenDaysOfferApplied) {
      lines.push({ key: 'openDays', label: `${this.openDaysOfferLabel} -100%`, quantity: 0, amount: promotionAmount, discount: true });
    } else if (this.appliedPromoCode) {
      const percentage = this.appliedPromoCode.discountType === 'percentage' ? ` -${this.appliedPromoCode.discountValue}%` : '';
      lines.push({
        key: 'promoCode',
        label: `${this.translateService.instant('CONFIRMATION.PROMO_CODE_APPLIED')} (${this.appliedPromoCode.code})${percentage}`,
        detail: this.promoApplicationDetails.map(detail => this.getPromoApplicationDetailLabel(detail.cartItem, detail.quantity)).join(', ') || undefined,
        quantity: 0,
        amount: promotionAmount,
        discount: true
      });
    }

    this._confirmationDiscountKey = key;
    this._confirmationDiscountGroups = lines.length > 0 ? [{ key: 'discounts', title: '', lines }] : [];
    return this._confirmationDiscountGroups;
  }

  // "2× Ticket (price tag)" in the current language
  private getPromoApplicationDetailLabel(cartItem: CartItem, quantity: number): string {
    const label = this.getLocalizedLabelFromTicketType(cartItem).trim();
    const priceTag = cartItem.ticketTypeId ? this.getCartRecapPriceTagLabel(cartItem) : '';
    return `${quantity}× ${label}${priceTag ? ` (${priceTag})` : ''}`;
  }

  // Ticket type colors by id (cart line accents): rebuilt only when the ticket types change
  private _ticketTypeColorsKey: [TicketTypeData[], number] | null = null;
  private _ticketTypeColors = new Map<string, string>();
  getTicketTypeColor(ticketTypeId: string | null): string | null {
    if (!this._ticketTypeColorsKey || this._ticketTypeColorsKey[0] !== this.ticketTypes || this._ticketTypeColorsKey[1] !== this.ticketTypes.length) {
      this._ticketTypeColors = new Map(this.ticketTypes.filter(tt => !!tt.color).map(tt => [tt.id, tt.color as string]));
      this._ticketTypeColorsKey = [this.ticketTypes, this.ticketTypes.length];
    }
    return ticketTypeId ? this._ticketTypeColors.get(ticketTypeId) || null : null;
  }

  // Add-on colors by id (cart line accents): rebuilt only when the add-ons change
  private _addOnColorsKey: [AddOnData[], number] | null = null;
  private _addOnColors = new Map<string, string>();
  getAddOnColor(addOnId: string | null): string | null {
    if (!this._addOnColorsKey || this._addOnColorsKey[0] !== this.addOns || this._addOnColorsKey[1] !== this.addOns.length) {
      this._addOnColors = new Map(this.addOns.filter(addOn => !!addOn.color).map(addOn => [addOn.id, addOn.color as string]));
      this._addOnColorsKey = [this.addOns, this.addOns.length];
    }
    return addOnId ? this._addOnColors.get(addOnId) || null : null;
  }

  /** Ticket type label of a family discount applied in the cart, in the selected language. */
  getFamilyDiscountTicketTypeLabel(application: FamilyDiscountApplication): string {
    const ticketType = this.ticketTypes.find(tt => tt.id === application.ticketTypeId);
    return ticketType ? this.getLocalizedLabelFromTicketType(ticketType) : '';
  }

  getDisplayDescription(item: any): string {
    if (!item || !item.description) return '';

    if (typeof item.description === 'string') return item.description;

    if (typeof item.description === 'object') {
      if (item.description[this.selectedLanguage]) return item.description[this.selectedLanguage];
      if (this.formData.eventDefaultLanguage && item.description[this.formData.eventDefaultLanguage]) return item.description[this.formData.eventDefaultLanguage];
    }

    return '';
  }

  onPaste($event: ClipboardEvent) {
    // if (this.isPasteEmailBlocked)
    $event.preventDefault();
  }

  /** Ensures the ticketing visitor uses a persistent anonymous Firebase identity with a valid token. */
  private async ensureAnonymousAuthentication(forceTokenRefresh: boolean = false): Promise<void> {
    await this.auth.authStateReady()

    let firebaseUser = (this.auth.currentUser?.isAnonymous === true)
      ? this.auth.currentUser
      : (await signInAnonymously(this.auth)).user

    try {
      await firebaseUser.getIdToken(forceTokenRefresh)
    } catch (error) {
      if (!forceTokenRefresh)
        throw error

      firebaseUser = (await signInAnonymously(this.auth)).user
      await firebaseUser.getIdToken()
    }

    if (!this.production)
      console.log("Anonymous Firebase user", firebaseUser.uid)

    this.isAuthenticated = true
  }

  /** Calls a protected public function and retries once after recovering a missing Firebase authentication token. */
  private async callAuthenticatedFunction(
    functionName: 'reserveTickets' | 'reserveSeatedTickets' | 'registerWithoutPayment' | 'startGenericMolliePaymentSession',
    payload: any
  ): Promise<any> {
    await this.ensureAnonymousAuthentication()
    const callable = httpsCallable(this.functions, functionName)

    try {
      const result: any = await callable(payload)
      if (result?.data?.code !== 'unauthenticated')
        return result
    } catch (error: any) {
      if (error?.code !== 'functions/unauthenticated' && error?.code !== 'unauthenticated')
        throw error
    }

    await this.ensureAnonymousAuthentication(true)
    return await callable(payload)
  }

  /** Displays the queue countdown and resolves when the reserved access time is reached. */
  private waitForPublicFormAccess(waitMs: number): Promise<void> {
    const safeWaitMs = Math.max(250, waitMs)
    const waitStartedAt = Date.now()
    this.isTwoManyLoginAttemps = true
    this.twoManyLoginAttemptsTimer = Math.max(1, Math.ceil(safeWaitMs / 1000))

    if (this.twoManyLoginAttemptsInterval)
      clearInterval(this.twoManyLoginAttemptsInterval)
    if (this.twoManyLoginAttemptsTimeout)
      clearTimeout(this.twoManyLoginAttemptsTimeout)

    return new Promise((resolve) => {
      this.twoManyLoginAttemptsInterval = setInterval(() => {
        const remainingMs = Math.max(0, safeWaitMs - (Date.now() - waitStartedAt))
        this.twoManyLoginAttemptsTimer = Math.ceil(remainingMs / 1000)
        if (remainingMs <= 0) {
          clearInterval(this.twoManyLoginAttemptsInterval)
          this.twoManyLoginAttemptsInterval = null
        }
      }, 250)

      this.twoManyLoginAttemptsTimeout = setTimeout(() => {
        if (this.twoManyLoginAttemptsInterval)
          clearInterval(this.twoManyLoginAttemptsInterval)
        this.twoManyLoginAttemptsInterval = null
        this.twoManyLoginAttemptsTimeout = null
        this.twoManyLoginAttemptsTimer = 0
        resolve()
      }, safeWaitMs)
    })
  }

  /** Slug of a custom link (https://organizer-domain/gala-2026), empty for ?id= links. */
  private getFormSlugFromPath(): string {
    const slug = window.location.pathname.replace(/^\/+|\/+$/g, '').toLowerCase()
    return slug.length >= 3 && slug.length <= 60 && slug !== 'home' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug) ? slug : ''
  }

  /** Waits for the reserved queue slot and returns the sanitized public form payload. */
  private async loadPublicFormData(hiddenTicketId: string | null, hiddenGiftCards: boolean, slug: string = ''): Promise<FormData> {
    const callable = httpsCallable(this.functions, 'getPublicFormDataV2')

    while (true) {
      try {
        const response: HttpsCallableResult<any> = await callable({
          formId: this.formId,
          slug: this.formId ? null : slug,
          hiddenTicketId: hiddenTicketId,
          hiddenGiftCards: hiddenGiftCards
        })

        // A slug link learns its form id from the first response.
        if (!this.formId && typeof response.data?.formId === 'string')
          this.formId = response.data.formId

        if (response.data?.status === 'granted' && response.data.formData) {
          this.isTwoManyLoginAttemps = false
          return response.data.formData as FormData
        }

        if (response.data?.status !== 'waiting')
          throw new Error('Unexpected public form response.')

        await this.waitForPublicFormAccess(response.data.retryAfterMs ?? 1000)
      } catch (error: any) {
        if (error?.code !== 'functions/aborted')
          throw error

        await this.waitForPublicFormAccess(500 + Math.floor(Math.random() * 1000))
      }
    }
  }

  async ngOnInit() {
    // Appel de la méthode du service pour obtenir les données
    this.http.get<string[]>('assets/personalDomainNames.json').subscribe(
      (response) => {
        this.personalDomainNames = response;  // Affectation des données au tableau
        // Affichage des données dans la console
        // this.silentLog('Données:', this.personalDomainNames);
      },
      (error) => {
        console.error('Erreur de chargement des données:', error);
      }
    );
    /*
    this.routeSub = this.route.params.subscribe(params => {
      this.silentLog(params) //log the entire params object
      this.silentLog(params['id']) //log the value of id
    });
    */

    // this.inputForm = this.formBuilder.group({
    //   firstname: ['', [Validators.required]]
    // })

    // Start progress bar
    this.firstLoadingBarInterval = setInterval(() => {
      this.progress += (0.01 + this.progress / 20);

      // Stop the progress bar when it reaches 80%
      // to continuously show the demo
      if (this.progress >= 0.80) {
        this.silentLog("--- Clearing firstLoadingBarInterval 1 ---")
        clearInterval(this.firstLoadingBarInterval);
      }
    }, 50);

    this.routeSub = this.route.queryParams.subscribe(async queryParams => {

      this.formId = queryParams['id']
      if (!this.production) {
        this.silentLog("this.formId", this.formId)
      }

      this.queryParameters = queryParams
      try {
        await this.ensureAnonymousAuthentication()

        // Custom slug links carry no id: the form is loaded first, so that the code below gets its id.
        const hiddenTicketId = (typeof queryParams['hiddenTicket'] === 'string') ? queryParams['hiddenTicket'] : null
        const formSlug = this.formId ? '' : this.getFormSlugFromPath()
        const slugFormData: FormData | null = formSlug ? await this.loadPublicFormData(hiddenTicketId, queryParams['hiddenGiftCards'] === 'true', formSlug) : null

        if (!this.production)
          console.log(queryParams) //log the entire queryParams object
        this.molliePaymentStatus = queryParams['molliePaymentStatus']
        this.mollieTransactionToken = queryParams['token']
        // this.molliePaidValue = queryParams['cartValue']
        this.mollieOrderId = queryParams['mollieOrderId']
        this.mollieEmail = (queryParams['email'] !== undefined) ? queryParams['email'] : '';

        // Check exchange state
        const storedExchangeState = localStorage.getItem('welkom_exchange_state_' + this.formId);
        if (storedExchangeState) {
          if (this.molliePaymentStatus === 'paid' || this.molliePaymentStatus === 'redirected') {
            localStorage.removeItem('welkom_exchange_state_' + this.formId);
            this.isExchangeMode = false;
            this.exchangeState = null;
          } else {
            this.isExchangeMode = true;
            this.exchangeState = JSON.parse(storedExchangeState);
            // Restore the fee configuration captured when the exchange was started.
            this.hasFixedRefundFee = this.exchangeState.hasFixedRefundFee === true;
            this.fixedRefundFeeAmount = Number(this.exchangeState.fixedRefundFeeAmount) || 0;
          }
        }

        if (!this.production) {
          this.silentLog("this.molliePaymentStatus", this.molliePaymentStatus)
          this.silentLog("this.mollieTransactionToken", this.mollieTransactionToken)
          this.silentLog("this.molliePaidValue", this.molliePaidValue)
          this.silentLog("this.mollieOrderId", this.mollieOrderId)
          this.silentLog("this.mollieEmail", this.mollieEmail)
        }
        this.utm_source = queryParams['utm_source'] ?? ''
        this.utm_medium = queryParams['utm_medium'] ?? ''
        this.utm_campaign = queryParams['utm_campaign'] ?? ''
        this.utm_content = queryParams['utm_content'] ?? ''
        this.utm_term = queryParams['utm_term'] ?? ''

        if (!this.production) {
          this.silentLog("this.utm_source", this.utm_source)
          this.silentLog("this.utm_medium", this.utm_medium)
          this.silentLog("this.utm_campaign", this.utm_campaign)
          this.silentLog("this.utm_content", this.utm_content)
          this.silentLog("this.utm_term", this.utm_term)
        }

        const currentUrl = window.location.href; // or build with Router if 
        // https://galleria610-ticketing.welkom.eu/?id=Eghxudy3jcGXdllCnXGU
        if (currentUrl.indexOf("galleria610-ticketing") > -1)
          this.profileString = 'galleria610'
        else if (currentUrl.indexOf("sro-ticketing") > -1)
          this.profileString = 'sro'
        else
          this.profileString = 'white'


        if (!this.production) {
          this.silentLog("currentUrl", currentUrl)
          this.silentLog("profileString", this.profileString)
        }
        this.meta.updateTag({ property: 'og:url', content: currentUrl });
        this.meta.updateTag({ property: 'twitter:url', content: currentUrl });
        if (!this.production)
          this.silentLog("queryParameters", this.queryParameters)
        if (typeof this.queryParameters.preview !== 'undefined' && this.queryParameters.preview === 'true')
          this.isPreview = true

        // Load the sanitized public form through the access queue.
        this.formData = slugFormData ?? await this.loadPublicFormData(hiddenTicketId, queryParams['hiddenGiftCards'] === 'true')
        if (!this.production) {
          this.silentLog("this.formData", this.formData)
          this.silentLog("descriptionContent", this.formData.descriptionContent)
        }

        // 
        this.isTicketDelivered = (
          this.formData.clientId === 'g3BDjhhaGlchyZTn6n5j' || // Accent Aigu ticketing
          this.formData.clientId === 'QgJGSr6Nbf2ClO3l6oBY' || // LuCix
          this.formData.clientId === 'y69YRpC0fMTtqvVOhnn8' || // Brain + More
          this.formData.clientId === 'YDF2tDE8FCLJB4Hlt9bP' || // LNDS
          this.formData.clientId === '312dPvxKsSPKl1lIJp5c' || // Université du Luxembourg
          this.formData.clientId === 'TMB1UMPG5P5mnXZ6IxNO' // Nexus 
        ) ? false : true
        this.isOptinVisible = (
          this.formData.clientId === 'g3BDjhhaGlchyZTn6n5j' || // Accent Aigu ticketing
          this.formData.clientId === 'QgJGSr6Nbf2ClO3l6oBY' || // LuCix
          this.formData.clientId === 'y69YRpC0fMTtqvVOhnn8' || // Brain + More
          this.formData.clientId === '312dPvxKsSPKl1lIJp5c' || // Université du Luxembourg
          this.formData.clientId === 'YDF2tDE8FCLJB4Hlt9bP' || // LNDS
          this.formData.clientId === 'tf1Z0TxhbSbpQMzWsAjE' // CANCER.LU ENFUME
        ) ? false : true
        this.isOrganizerTermsVisible = (
          this.formData.clientId === 'QgJGSr6Nbf2ClO3l6oBY' || // LuCix
          this.formData.clientId === 'tf1Z0TxhbSbpQMzWsAjE_' // CANCER.LU ENFUME
        ) ? false : true
        this.isWelkomTermsVisible = (
          this.formData.clientId === 'tf1Z0TxhbSbpQMzWsAjE' // CANCER.LU ENFUME
        ) ? false : true
        this.isOrganizerAgreementChecked = !this.isOrganizerTermsVisible // If not visible, consider it checked by default
        this.isWelkomAgreementChecked = !this.isWelkomTermsVisible // If not visible, consider it checked by default


        // Description logic initialization has been moved below setLanguage

        // Overwriting profile data with ticket config is present
        if (this.formData.ticketConfig !== undefined) {
          this.formData.organizerCommercialName = this.formData.ticketConfig.commercialName
          this.formData.organizerLegalName = this.formData.ticketConfig.legalName
          this.formData.organizerMail = this.formData.ticketConfig.email
          // this.formData.organizerWebsite = this.formData.ticketConfig.website

          this.formData.organizerTermsURL = this.formData.ticketConfig.termsAndConditionsURL
          this.formData.organizerPrivacyURL = this.formData.ticketConfig.privacyPolicyURL
        }

        // Check form default language and url language
        this.selectedLanguage = (this.formData.eventDefaultLanguage !== undefined && this.formData.eventDefaultLanguage !== null && this.formData.eventDefaultLanguage.length > 0) ? this.formData.eventDefaultLanguage : 'en'
        // console.log("selectedLanguage from event", this.selectedLanguage)
        this.selectedLanguage = (this.formData.eventLanguages !== undefined && this.formData.eventLanguages !== null && this.formData.eventLanguages.length > 0 && this.formData.eventLanguages.includes(queryParams['lang'])) ? queryParams['lang'] : this.selectedLanguage
        // console.log("selectedLanguage from URL", this.selectedLanguage)
        this.setLanguage(this.selectedLanguage)

        // Handle description logic (now that language is initialized)
        if (this.formData.descriptionEnabled === true && this.hasDescriptionForCurrentLanguage) {
          if (this.formData.descriptionDisplayType === 'tab') {
            this.step = '0'
            this.stepProgress = 0.05
          } else {
            if (this.isSingleFreeTicketFlow) {
              this.step = '3'
              this.stepProgress = 0.66
            } else {
              this.step = '1'
              this.stepProgress = 0.11
            }
          }
        } else {
          if (this.isSingleFreeTicketFlow) {
            this.step = '3'
            this.stepProgress = 0.66
          } else {
            this.step = '1'
            this.stepProgress = 0.11
          }
        }

        // Set page title with the event name
        const pageTitle = (this.formData.eventName !== undefined && this.formData.eventName !== null && this.formData.eventName.length > 0) ? this.formData.eventName : 'Event'
        this.titleService.setTitle(pageTitle)

        this.initializeTrackingPixels(currentUrl)

        if (
          this.molliePaymentStatus !== 'paid' &&
          this.molliePaymentStatus !== 'redirected' &&
          this.molliePaymentStatus !== 'failed' &&
          this.molliePaymentStatus !== 'askForRefund'
        ) {
          /*
          // Set Meta & Google Pixel IDs and start tracking for Galleria 610 event
          if (currentUrl.indexOf("ticketing.galleria610.lu") > -1) {
            // if (this.formId === 'g4NlrAk3QBeF4I24dKl2') { // Golden Age of Rally
            this.silentLog("Initializing Meta Pixel for Galleria 610")
            this.pixel.initialize(environment.metaPixelId); // Galleria 610 Meta Pixel ID

            this.silentLog("Initializing Google Pixel for Galleria 610")
            this.initGooglePixel(environment.googlePixelId, environment.googlePixelConversionLabel);
          }
          else if (currentUrl.indexOf("ticketing.giolabs.lu") > -1) {
            // } else if (this.formId === 'eh9Z7wMVO16zO6m4zr2C') { // GIOLABS SOS
            this.silentLog("Initializing Meta Pixel for GIOLABS")
            this.pixel.initialize(environment.metaPixelId); // GIOLABS Meta Pixel ID

            this.silentLog("Initializing Google Pixel for GIOLABS")
            this.initGooglePixel(environment.googlePixelId, environment.googlePixelConversionLabel);
          }
          */

          // Prepare form data, ticket types, add-ons, inputs, etc.
          // Except for payment & registration redirection
          this.prepareFormData()

          // Check for existing reservation in local storage and restore cart if valid
          const storedReservation = localStorage.getItem('welkom_reservation_' + this.formId);
          if (storedReservation) {
            const parsed = JSON.parse(storedReservation);
            if (new Date(parsed.expiry) > new Date() && (parsed.reservationLinkKey ?? '') !== this.reservationLinkKey) {
              // Booked on another link (normal form, hidden ticket link, hidden gift cards link): its items are not sold
              // on this link, release them instead of restoring them
              await this.unbookTemporaryTickets(parsed.id, false);
            } else if (new Date(parsed.expiry) > new Date()) {
              this.reservationId = parsed.id;
              this.reservationExpiry = new Date(parsed.expiry);
              this.startReservationTimer();
              await this.restoreCart(parsed); // Restores tickets, add-ons, and advances to Step 3
            } else {
              // Expired while away, try to unbook just in case
              this.unbookTemporaryTickets(parsed.id);
            }
          } else if (this.isSingleFreeTicketFlow && !this.isDescriptionTabActive) {
            await this.goToStep3()
          }
        } else if (this.molliePaymentStatus === 'askForRefund') {


          // Getting payment status using Firebase Function 'checkGenericRefundStatus'
          const checkPaymentStatus = httpsCallable(this.functions, 'checkGenericRefundStatus');
          const refundStatusResponse: HttpsCallableResult<any> = await checkPaymentStatus({
            clientId: this.formData.clientId,
            eventId: this.formData.eventId,
            orderId: this.mollieOrderId,
            testMode: this.production ? false : true,
          });

          if (refundStatusResponse.data.success) {
            this.silentLog("------ refundStatusResponse", refundStatusResponse)
            this.zone.run(() => {
              this.molliePaidValue = parseFloat(refundStatusResponse.data.molliePaidValue);
              this.isRefundPolicyExpired = refundStatusResponse.data.isRefundPolicyExpired;
              this.isEventRefundable = refundStatusResponse.data.isRefundable === true;
              this.isEventExchangeable = refundStatusResponse.data.isExchangeable === true;
              const refundStatusTickets: any[] = refundStatusResponse.data.tickets || [];
              this.isFreeReservation = refundStatusTickets.length > 0 && refundStatusTickets.every((ticket: any) => !(ticket.ticketPrice > 0));
              this.refundTickets = this.processRefundTickets(refundStatusTickets);
              this.refundSeatingEnabled = refundStatusResponse.data.seatingEnabled === true;
              this.hasFixedRefundFee = refundStatusResponse.data.hasFixedRefundFee === true;
              this.fixedRefundFeeAmount = Number(refundStatusResponse.data.fixedRefundFeeAmount) || 0;
              this.molliePaymentStatus = 'askForRefund';
            })

            if (!this.production) {
              this.silentLog("isRefundPolicyExpired", this.isRefundPolicyExpired)
            }
          } else {
            console.warn("Refund status check failed")
            this.zone.run(() => {
              this.mollieCheckingStatusFailed = true
              this.mollieCheckinStatusErrorCode = refundStatusResponse.data.code;
            });
          }

          /*
          if (!this.production)
            this.silentLog("refundStatusResponse", refundStatusResponse)
   
          if (orderDoc.exists()) {
            const orderData = orderDoc.data()
            if (!this.production)
              this.silentLog("orderData for refund request", orderData)
   
            if (orderData['refundTimestamp'] !== undefined) {
              // Refund has already been processed
              this.molliePaymentStatus = 'refundProcessed'
            } else {
              let refundDateLimit: number = 0
              if (orderData['isDataSlot'] && orderData['slotDate'] !== undefined) {
                refundDateLimit = orderData['slotDate'].seconds * 1000 - 48 * 60 * 60 * 1000 // 48 hours before slot date
              } else {
                refundDateLimit = this.formData.eventDateStart.seconds * 1000 - 48 * 60 * 60 * 1000 // 48 hours before event start date
              }
              this.isRefundPolicyExpired = (new Date().getTime() > refundDateLimit)
   
              if (!this.production) {
                this.silentLog("refundDateLimit", new Date(refundDateLimit))
                this.silentLog("isRefundPolicyExpired", this.isRefundPolicyExpired)
              }
            }
          } else {
            if (!this.production)
              console.warn("Order not found for refund request")
          }
          */

          // Prepare form data, ticket types, add-ons, inputs, etc.
          // Except for payment & registration redirection
          this.prepareFormData()
        } else if (this.molliePaymentStatus === 'paid') {
          this.isFormLoaded = true

          this.trackMetaPixelEvent("Purchase", {
            value: this.molliePaidValue,
            currency: "EUR"
          })
        } else if (this.molliePaymentStatus === 'redirected') {
          this.isFormLoaded = true

          // The backend now owns the reservation while Mollie confirms the payment.
          this.clearTemporaryReservationState();

          // Getting payment status using Firebase Function 'checkGenericPaymentStatus'
          const checkPaymentStatus = httpsCallable(this.functions, 'checkGenericPaymentStatus');
          const paymentStatusResponse: HttpsCallableResult<any> = await checkPaymentStatus({
            clientId: this.formData.clientId,
            eventId: this.formData.eventId,
            testMode: this.production ? false : true,
            token: this.mollieTransactionToken
          });

          if (!this.production)
            this.silentLog("paymentStatusResponse", paymentStatusResponse)

          if (paymentStatusResponse.data.success) {
            this.zone.run(() => {
              const mollieStatus = paymentStatusResponse.data.status;
              if (mollieStatus === 'paid') {
                this.molliePaymentStatus = 'paid';
              } else if (paymentStatusResponse.data.method === 'banktransfer' && (mollieStatus === 'open' || mollieStatus === 'pending')) {
                // SEPA Bank Transfer: the payment stays open until the transfer is received, tickets are sent once it is paid
                this.molliePaymentStatus = 'banktransfer-pending';
                this.mollieBankTransfer = paymentStatusResponse.data.bankTransfer || null;
              } else {
                this.molliePaymentStatus = 'failed';
              }
              this.molliePaymentId = paymentStatusResponse.data.molliePaymentId;
              this.mollieCart = paymentStatusResponse.data.cart;
              this.mollieEmail = paymentStatusResponse.data.customer.email;
              this.mollieFullName = paymentStatusResponse.data.customer.fullName;
              this.molliePaidValue = parseFloat(paymentStatusResponse.data.amount);

              // this.mollieCart.forEach((cartItem: CartItem) => {
              //   this.molliePaidValue += cartItem.priceAfterPromotion * cartItem.quantity;
              // })
            })

            if (!this.production) {
              this.silentLog("molliePaymentStatus", this.molliePaymentStatus)
              this.silentLog("molliePaymentId", this.molliePaymentId)
              this.silentLog("mollieCart", this.mollieCart)
              this.silentLog("mollieEmail", this.mollieEmail)
              this.silentLog("mollieFullName", this.mollieFullName)
              this.silentLog("molliePaidValue", this.molliePaidValue)
            }

            if (paymentStatusResponse.data.status === 'paid') {
              this.trackMetaPixelEvent("Purchase", {
                value: this.molliePaidValue,
                currency: "EUR"
              })
            }
          } else {
            console.warn("Payment status check failed")
            this.mollieCheckingStatusFailed = true
            this.mollieCheckinStatusErrorCode = paymentStatusResponse.data.code;
          }

          if (!this.production)
            this.silentLog("--- Clearing firstLoadingBarInterval 2 ---")

          // Loading bar management
          clearInterval(this.firstLoadingBarInterval);
          this.progress = 0.8
          const secondLoadingBarInterval = setInterval(() => {
            this.progress += 0.01;

            // Stop the progress bar when it reaches 80%
            // to continuously show the demo
            if (this.progress >= 1) {
              clearInterval(secondLoadingBarInterval);
            }
          }, 50);
          this.isFormLoaded = true;
        }
      } catch (error: unknown) {
        console.error("Error in ngOnInit:", error);
        const err = error as Partial<FirebaseError>;


        switch (err.code) {
          case 'auth/quota-exceeded':
          case 'auth/too-many-requests':
            throw new Error('Anonymous authentication is temporarily unavailable. Please try again later.');
          case 'auth/operation-not-allowed':
            throw new Error('Anonymous authentication is not enabled for this Firebase project.');
          default:
            console.error('Public form loading error:', err);
            throw error;
        }
      }
    });
  }

  // Prepare form data, ticket types, add-ons, inputs, etc.
  prepareFormData() {
    // console.info("--- prepareFormData ---")

    // this.formData.descriptionContent = (this.formData.descriptionContent !== undefined) ? this.formData.descriptionContent.replaceAll('<p></p>', '<br />') : ""
    // this.formData.responseContent = (this.formData.responseContent !== undefined) ? this.formData.responseContent.replaceAll('<p></p>', '<br />') : ""
    // this.silentLog("this.formData.descriptionContent", this.formData.descriptionContent)
    // this.formData.descriptionContent = this.formData.descriptionContent.replaceAll("<p>", "<p style='margin: 0px;'>")
    // this.silentLog("this.formData.descriptionContent", this.formData.descriptionContent)

    // Check if the refundPolicy is expired, less than48 hours before the start of the event
    // if (this.formData.refundPolicy && this.formData.refundPolicy.isEnabled) {

    // this.silentLog("this.formData.eventDateStart", this.formData.eventDateStart)
    /*
    const startDate = this.formData.eventDateStart.seconds * 1000
    const now = new Date().getTime()
    const diff = startDate - now
    // this.silentLog("diff", diff)
    if (diff < 48 * 60 * 60 * 1000) { // less than 48 hours
      this.isRefundPolicyExpired = true
    }
    // }
    */

    // Check if the form is closed, with the eventDateFormEnd
    // this.silentLog("this.formData.eventDateFormEnd", this.formData.eventDateFormEnd)
    const formEndDate = this.formData.eventDateFormEnd.seconds * 1000
    if (formEndDate < new Date().getTime()) { // form end date is in the past
      this.isFormClosed = true
    }
    this.isReallyNexusClient = this.formData.clientId === 'TMB1UMPG5P5mnXZ6IxNO'
    this.isLuxexpoClient = this.formData.clientId === 'PRBbBnjm2ktqBSzINKFk'

    // Legacy fallback: these clients used to force nominative visitor forms on every ticket type.
    // Now isMultipleVisitorForms is configurable per ticket type in the admin; this only applies
    // when a ticket type hasn't been explicitly configured yet (isMultipleVisitorForms === undefined).
    const legacyForcedMultipleVisitorForms = (
      this.formData.clientId === 'TMB1UMPG5P5mnXZ6IxNO' || // Nexus
      this.formData.clientId === 'F4Phx5ZuOgP4OIs50gWH' || // LSA
      this.formData.eventId === 'k6KCnJ0Rh0Bx93GKwz2D' // 
    )

    // Init ticket types
    if (!this.production)
      this.silentLog("this.formData.ticketTypes", this.formData.ticketTypes)
    this.ticketTypes = []
    const hiddenTicketId = this.queryParameters['hiddenTicket']
    const nowMs = Date.now()
    this.outOfSalesWindowTicketTypeIds = []

    this.formData.ticketTypes.forEach((ticketType: TicketTypeData) => {
      ticketType.priceSelection = {}
      ticketType.remaining = (ticketType.isLimited && ticketType.remaining !== undefined) ? ticketType.remaining : ticketType.capacity
      ticketType.isMultipleVisitorForms = (ticketType.isMultipleVisitorForms === undefined) ? legacyForcedMultipleVisitorForms : ticketType.isMultipleVisitorForms

      // Ticket types not on sale yet / anymore are not offered (seat map: their seats are shown as unavailable)
      if (!this.isWithinSalesWindow(ticketType, nowMs)) {
        this.outOfSalesWindowTicketTypeIds.push(ticketType.id)
        return
      }

      if (hiddenTicketId) {
        // If hiddenTicket is in the URL, load only the matching ticket (if visible)
        if (ticketType.id === hiddenTicketId && ticketType.isVisible) {
          this.ticketTypes.push(ticketType)
        }
      } else if (this.isGiftCardLink) {
        // Hidden gift cards link of a seat map event: load only its hidden gift cards
        if (ticketType.isVisible && ticketType.isGiftCard && ticketType.isHidden === true) {
          this.ticketTypes.push(ticketType)
        }
      } else {
        // Default behavior: load only visible tickets with isHidden !== true
        if (ticketType.isVisible && ticketType.isHidden !== true) {
          this.ticketTypes.push(ticketType)
        }
      }
    })
    if (!this.production)
      this.silentLog("this.ticketTypes", this.ticketTypes)

    // Sort ticket types by position
    this.ticketTypes.sort((a: TicketTypeData, b: TicketTypeData) => {
      if (a.position < b.position) {
        return -1; // a comes before b
      } else if (a.position > b.position) {
        return 1; // b comes before a
      } else {
        return 0; // no change in order
      }
    });

    // For each ticket type, find lowestPrice and highestPrice
    this.ticketTypes.forEach((ticketType: TicketTypeData) => {
      const allPrices: number[] = []
      if (ticketType.isGroupTicketOnly) {
        allPrices.push(ticketType.regularGroupBasePrice)
      } else if (
        ticketType.isEarlyBird && ticketType.earlyBirdDate.seconds * 1000 > (new Date().getTime()) &&
        ticketType.earlyBirdPrice > 0
      )
        allPrices.push(ticketType.earlyBirdPrice)
      else if (!ticketType.isEarlyBird || ticketType.earlyBirdDate.seconds * 1000 <= (new Date().getTime()))
        allPrices.push(ticketType.price)

      if (ticketType.isStudentDiscount && ticketType.studentPrice > 0)
        allPrices.push(ticketType.studentPrice)

      if (ticketType.isChildrenDiscount && ticketType.childrenPrice > 0)
        allPrices.push(ticketType.childrenPrice)

      if (ticketType.isYouthDiscount && ticketType.youthPrice > 0)
        allPrices.push(ticketType.youthPrice)

      if (ticketType.isSeniorDiscount && ticketType.seniorPrice > 0)
        allPrices.push(ticketType.seniorPrice)
      if (ticketType.isDisabledDiscount && ticketType.disabledPrice > 0)
        allPrices.push(ticketType.disabledPrice)

      ticketType.lowestPrice = Math.min(...allPrices)
      ticketType.highestPrice = Math.max(...allPrices)
    })

    // Seat map events sell their gift cards apart from the seats
    this.giftCardTicketTypes = this.formData.seatingEnabled ? this.ticketTypes.filter((ticketType: TicketTypeData) => ticketType.isGiftCard) : []

    // Init add-ons
    if (!this.production)
      this.silentLog("this.formData.addOns", this.formData.addOns)
    this.addOns = []
    this.formData.addOns.forEach((addOn: AddOnData) => {
      addOn.selection = 0
      addOn.remaining = (addOn.isLimited && addOn.remaining !== undefined) ? addOn.remaining : addOn.capacity

      // Remove the add-on if it is not visible or not on sale yet / anymore
      if (addOn.isVisible && this.isWithinSalesWindow(addOn, nowMs)) {
        this.addOns.push(addOn)
      }
    })
    if (!this.production)
      this.silentLog("this.addOns", this.addOns)

    // Sort ticket types by position
    this.addOns.sort((a: AddOnData, b: AddOnData) => {
      if (a.position < b.position) {
        return -1; // a comes before b
      } else if (a.position > b.position) {
        return 1; // b comes before a
      } else {
        return 0; // no change in order
      }
    });

    // Init time slots
    if (this.formData.seatingEnabled && !this.eventHasDateSelection()) {
      if (this.formData.eventDateStart && this.formData.eventDateStart.seconds) {
        this.selectedDate = new Date(this.formData.eventDateStart.seconds * 1000);
      } else {
        this.selectedDate = new Date();
      }
      this.selectedDate.setHours(0, 0, 0, 0);
      this.selectedDateISO = this.selectedDate.toISOString();
    }

    if (!this.production) {
      this.defaultDevFirstName = "Test FirstName"
      this.defaultDevLastName = "Test LastName"
      this.defaultDevEmail = "welkom2030@yopmail.com"
    }

    // Initialize form attributes and validators
    this.inputForm = this.buildInputFormGroup(true)

    if (!this.production) {
      this.silentLog("inputForm", this.inputForm)
      this.applyDevDefaultsToForm(this.inputForm)
    }

    // Auto-select ticket if there is only one free ticket type with maxPerOrder === 1 and no add-ons
    if (this.isSingleFreeTicketFlow) {
      this.isTypeSelectionSkipped = true
      this.selectedTicketType = this.ticketTypes[0]
      this.selectedTicketType.priceSelection = { 'normal': 1 }
      this.isTicketSelected = true
      this.isPriceSelected = true
      this.ticketStep = 'priceSelection'
      this.totalTicketTypePrice = 0
      this.totalTicketTypeVAT = 0
      this.totalPrice = 0
      this.cart = [{
        ticketTypeId: this.selectedTicketType.id,
        addOnId: null,
        isCombinedTicket: false,
        combinedTickets: [],
        combinedTicketKey: '',
        priceTag: 'normal',
        label: this.selectedTicketType.label,
        description: this.selectedTicketType.description,
        quantity: 1,
        price: 0,
        priceAfterPromotion: 0,
        vat: 0
      }]

    }

    // Check input conditions
    this.formData.inputs.forEach((formInputWithCondition: FormInput, formInputIndex: number) => {
      if (formInputWithCondition.isConditionEnabled) {
        this.formData.inputs[formInputIndex].conditionFieldOptionValue = ""
        this.formData.inputs.forEach((formInput: FormInput) => {
          if (
            formInput.fieldName === formInputWithCondition.conditionFieldName &&
            formInputWithCondition.conditionFieldOptionIndex !== null &&
            formInputWithCondition.conditionFieldOptionIndex >= 0 &&
            formInputWithCondition.conditionFieldOptionIndex < formInput.options.length
          ) {
            this.silentLog("condition input field name found", formInputWithCondition.conditionFieldName)
            this.silentLog("formInputWithCondition.conditionFieldOptionIndex", formInputWithCondition.conditionFieldOptionIndex)
            this.silentLog("formInput.options", formInput.options)
            this.formData.inputs[formInputIndex].conditionFieldOptionValue = formInput.options[formInputWithCondition.conditionFieldOptionIndex].value
            this.silentLog("option found", this.formData.inputs[formInputIndex].conditionFieldOptionValue)
          }
        })
      }
    })

    // Sort form inputs to have the mail at the end
    this.formData.inputs.sort((a: FormInput, b: FormInput) => {
      if (a.type === 'email' && b.type !== 'email') {
        return 1; // a comes after b
      } else if (a.type !== 'email' && b.type === 'email') {
        return -1; // b comes after a
      } else {
        return 0; // no change in order
      }
    });
    if (!this.production)
      this.silentLog("this.formData.inputs", this.formData.inputs)

    if (!this.production)
      this.silentLog("--- Clearing firstLoadingBarInterval 2 ---")
    clearInterval(this.firstLoadingBarInterval);
    this.progress = 0.8
    const secondLoadingBarInterval = setInterval(() => {
      this.progress += 0.01;

      // Stop the progress bar when it reaches 80%
      // to continuously show the demo
      if (this.progress >= 1) {
        clearInterval(secondLoadingBarInterval);
        this.isFormLoaded = true
      }
    }, 50);

    // Load the ticket types remaining
    this.getTicketTypesRemaining()

    // Load the addOns remaining
    this.getAddOnsRemaining()


    // Initial check for seated tickets if seating is enabled and date is pre-selected
    if (this.formData.seatingEnabled && this.selectedDate) {
      this.fetchBookedSeatsForSlot(this.selectedDate, this.selectedTime);
    }

    // POSSIBLE IMPROVMENT (⚠️ might cause performance issues with high traffic):
    // Periodically refresh seat availability every 60 seconds if seating is enabled
    // if (this.formData.seatingEnabled) {
    //   if (this.seatRefreshInterval) clearInterval(this.seatRefreshInterval);
    //   this.seatRefreshInterval = setInterval(() => {
    //     if (this.step === '1' && (this.ticketStep === 'typeSelection' || this.ticketStep === 'priceSelection') && this.selectedDate) {
    //       this.fetchBookedSeatsForSlot(this.selectedDate, this.selectedTime);
    //     }
    //   }, 60000); // 60 seconds
    // }

    // Seat map events selling gift cards start with the tickets / gift cards choice (only the gift cards on their hidden link)
    const hasSeatMapGiftCards = this.giftCardTicketTypes.length > 0
    if (hasSeatMapGiftCards && this.step !== '0') {
      this.goToStep1()
    }

    if (!hasSeatMapGiftCards && this.formData.seatingEnabled && this.step !== '0' && this.eventHasDateSelection() && this.ticketStep !== 'dateSelection' && !this.isSlotSelected) {
      const tt = this.ticketTypes.find(tt => this.requiresDateSelection(tt));
      if (tt) {
        this.selectedTicketType = tt;
        this.goToDateSelection();
        return;
      }
    }

    // Skip type selection if there is only one ticket type
    if (!this.isSingleFreeTicketFlow && !hasSeatMapGiftCards) {
      if (this.ticketTypes.length === 1 && this.ticketTypes[0].isSoldOut !== true) {
        if (!this.production) {
          this.silentLog("Skipping type selection, only one ticket type available")
        }
        this.isTypeSelectionSkipped = true
        this.selectedTicketType = this.ticketTypes[0]
        this.isTicketSelected = true
        this.isPriceSelected = false
        this.ticketStep = 'priceSelection'
        if (this.step !== '0') {
          this.goToPriceSelection()
        }
      } else {
        if (!this.production) {
          this.silentLog("Not skipping type selection, multiple ticket types available")
        }
        this.isTypeSelectionSkipped = false
        this.selectedTicketType = {} as TicketTypeData
        this.isTicketSelected = false
        this.isPriceSelected = false
        if (this.step !== '0') {
          this.goToTypeSelection()
        }
      }
    }

    this.silentLog("======> this.selectedTicketType", this.selectedTicketType)
    /*
    this.silentLog("--- prepareFormData done ---")
    this.silentLog("is Production", this.production)
    if (!this.production && this.ticketTypes.length > 0) {
      this.ticketTypes[0].isSoldOut = true;
    }
    */

    // Sort inputs by position
    // If no position is defined, first name, last name and email are first
    this.formData.inputs.sort((a: FormInput, b: FormInput) => {
      let posA = (typeof a.position !== 'undefined' && a.position !== null) ? a.position : null;
      let posB = (typeof b.position !== 'undefined' && b.position !== null) ? b.position : null;

      if (posA === null) {
        if (a.fieldName === 'userFirstname') posA = -3;
        else if (a.fieldName === 'userLastname') posA = -2;
        else if (a.fieldName === 'userEmail') posA = -1;
        else posA = Infinity;
      }

      if (posB === null) {
        if (b.fieldName === 'userFirstname') posB = -3;
        else if (b.fieldName === 'userLastname') posB = -2;
        else if (b.fieldName === 'userEmail') posB = -1;
        else posB = Infinity;
      }

      if (posA < posB) {
        return -1; // a comes before b
      } else if (posA > posB) {
        return 1; // b comes before a
      } else {
        return 0; // no change in order
      }
    });

    if (!this.production) {
      this.defaultDevFirstName = "Test FirstName"
      this.defaultDevLastName = "Test LastName"
    }

    // this.isFormLoaded = true
  }

  /** Initializes the Meta Pixel selected for the current checkout and preserves Galleria610 Google tracking. */
  private initializeTrackingPixels(currentUrl: string): void {
    const metaPixelConfig = environment.metaPixelConfigs.find(config =>
      config.eventId === this.formData.eventId && config.formId === this.formId
    )

    if (metaPixelConfig) {
      this.silentLog("Initializing configured Meta Pixel", metaPixelConfig.pixelId)
      this.pixel.initialize(metaPixelConfig.pixelId)
      this.isMetaPixelInitialized = true
      /*
      } else if (currentUrl.indexOf("ticketing.galleria610.lu") > -1) {
        this.silentLog("Initializing Meta Pixel for Galleria 610")
        this.pixel.initialize(environment.metaPixelId)
        this.isMetaPixelInitialized = true
      }
      */
    } else if (GRIDX_ALL_PROFILE_IDS.has(this.formData.organizerProfileId)) {
      this.silentLog("Initializing Meta Pixel for All GRIDX events")
      this.pixel.initialize(environment.metaPixelId)
      this.isMetaPixelInitialized = true
      this.silentLog("Initializing Google Pixel for Galleria 610")
      this.initGooglePixel(environment.googlePixelId, environment.googlePixelConversionLabel)
    }
  }

  /** Sends a standard Meta event only when a Pixel was initialized for the current checkout. */
  private trackMetaPixelEvent(eventName: 'AddToCart' | 'InitiateCheckout' | 'Purchase', properties?: any): void {
    if (!this.isMetaPixelInitialized)
      return

    this.silentLog(`${eventName} Meta Pixel`)
    this.pixel.track(eventName, properties)
  }

  /** Initializes Google Ads tracking for the supplied account and conversion label. */
  private initGooglePixel(googlePixelId: string, googlePixelConversionLabel: string) {
    if (!googlePixelId) return;

    const win = window as any;
    win.dataLayer = win.dataLayer || [];
    if (!win.gtag) {
      win.gtag = function () {
        win.dataLayer.push(arguments);
      };
    }

    const existingScript = document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${googlePixelId}"]`);
    if (!existingScript) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${googlePixelId}`;
      document.head.appendChild(script);
    }

    win.gtag('js', new Date());
    win.gtag('config', googlePixelId);

    if (googlePixelConversionLabel) {
      win.gtag('event', 'conversion', {
        'send_to': `${googlePixelId}/${googlePixelConversionLabel}`,
        'value': 1.0,
        'currency': 'USD'
      });
    }
  }

  private buildInputFormGroup(applyFlags: boolean): FormGroup {
    if (applyFlags) {
      this.isPersonalEmailBlocked = false
      this.isConfirmEmailAsked = false
      this.isPasteEmailBlocked = false
    }

    let controls: any = {}

    let allInputs = [...this.formData.inputs];
    if (this.formData.sections) {
      this.formData.sections.forEach(s => {
        if (s.inputs) {
          s.inputs.forEach(i => {
            if (!allInputs.some(ai => ai.fieldName === i.fieldName)) {
              allInputs.push(i);
            }
          });
        }
      });
    }

    allInputs.forEach((formInput: FormInput) => {
      if (formInput.type === 'email') {
        if (applyFlags && formInput.isPersonalEmailBlocked)
          this.isPersonalEmailBlocked = true

        controls[formInput.fieldName] = (formInput.isRequired) ? ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._+-]+@[a-z0-9.-]+\\.[a-z]{2,10}$')]] : ['', [Validators.pattern('^[a-zA-Z0-9._+-]+@[a-z0-9.-]+\\.[a-z]{2,10}$')]]

        if (applyFlags)
          this.isConfirmEmailAsked = true

        controls[formInput.fieldName + '_confirm'] = (formInput.isRequired) ? ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._+-]+@[a-z0-9.-]+\\.[a-z]{2,10}$')]] : ['', [Validators.pattern('^[a-zA-Z0-9._+-]+@[a-z0-9.-]+\\.[a-z]{2,10}$')]]

        if (applyFlags && formInput.isPasteEmailBlocked) {
          this.isPasteEmailBlocked = true
        }
      } else if (formInput.type === 'tel')
        controls[formInput.fieldName] = (formInput.isRequired) ? ['', [Validators.required, Validators.pattern('^[+]+[0-9]{6,14}')]] : ['', [Validators.pattern('^[+]+[0-9]{6,14}')]]
      else if (formInput.type === 'checkbox')
        controls[formInput.fieldName] = (formInput.isRequired) ? [false, [Validators.requiredTrue]] : [false]
      else if (formInput.type === 'select' || formInput.type === 'selectMultiple')
        controls[formInput.fieldName] = (formInput.isRequired) ? [null, [Validators.required]] : [null]
      else if (formInput.fieldName === 'userFirstname' || formInput.fieldName === 'userLastname')
        controls[formInput.fieldName] = (formInput.isRequired) ? ['', [Validators.required]] : ['']
      else
        controls[formInput.fieldName] = (formInput.isRequired) ? ['', [Validators.required]] : ['']
    })

    const formGroup = this.formBuilder.group(controls)
    formGroup.updateValueAndValidity()
    return formGroup
  }

  private syncVisitorFormsWithCart() {
    if (!this.isMultipleVisitorForms)
      return

    // Per-unit ticket types get one dedicated entry per unit of quantity (as before). Ticket types
    // that don't require per-unit forms get exactly one shared entry, whose targets span every unit
    // across every cart line for that ticket type (a ticket type can appear in several cart lines,
    // e.g. one per price tier).
    type VisitorFormEntry = {
      ticketTypeId: string, ticketTypeLabel: string, formIndexInTicketType: number,
      ticketTypeQuantity: number, cartQuantity: number, targets: { cartIndex: number, visitorIdx: number }[]
    }

    // Total quantity bought per ticket type, used as the "Y" in the "Ticket X/Y" label for
    // per-unit ticket types only (Y is always 1 for the once-per-ticket-type shared forms,
    // regardless of how many units were bought).
    const quantityByTicketType = new Map<string, number>()
    this.cart.forEach((item: CartItem) => {
      if (!item.ticketTypeId) return
      quantityByTicketType.set(item.ticketTypeId, (quantityByTicketType.get(item.ticketTypeId) || 0) + item.quantity)
    })

    const formIndexByTicketType = new Map<string, number>()
    const nextFormIndexInTicketType = (ticketTypeId: string): number => {
      const next = (formIndexByTicketType.get(ticketTypeId) || 0) + 1
      formIndexByTicketType.set(ticketTypeId, next)
      return next
    }

    const ticketEntries: VisitorFormEntry[] = []
    const sharedEntryByTicketType = new Map<string, VisitorFormEntry>()
    this.cart.forEach((item: CartItem, cartIndex: number) => {
      if (!item.ticketTypeId) return
      const ticketType = this.ticketTypes.find(tt => tt.id === item.ticketTypeId)
      const ticketTypeLabel = ticketType ? this.getLocalizedLabelFromTicketType(ticketType) : ''

      const cartQuantity = quantityByTicketType.get(item.ticketTypeId) || 0

      if (this.isPerUnitVisitorForm(item)) {
        const ticketTypeQuantity = cartQuantity
        for (let i = 0; i < item.quantity; i++) {
          ticketEntries.push({
            ticketTypeId: item.ticketTypeId, ticketTypeLabel, ticketTypeQuantity, cartQuantity,
            formIndexInTicketType: nextFormIndexInTicketType(item.ticketTypeId),
            targets: [{ cartIndex, visitorIdx: i }]
          })
        }
      } else {
        let entry = sharedEntryByTicketType.get(item.ticketTypeId)
        if (!entry) {
          entry = { ticketTypeId: item.ticketTypeId, ticketTypeLabel, ticketTypeQuantity: 1, cartQuantity, formIndexInTicketType: 1, targets: [] }
          sharedEntryByTicketType.set(item.ticketTypeId, entry)
          ticketEntries.push(entry)
        }
        for (let i = 0; i < item.quantity; i++) {
          entry.targets.push({ cartIndex, visitorIdx: i })
        }
      }
    })

    this.totalVisitorCount = ticketEntries.length

    if (ticketEntries.length === 0) {
      this.visitorForms = []
      this.visitorToCartMap = []
      this.currentVisitorIndex = 0
      return
    }

    const existingForms = this.visitorForms
    const existingFormsByEntryKey = new Map<string, FormGroup>()
    this.visitorToCartMap.forEach((entry, index) => {
      const existingForm = existingForms[index]
      if (existingForm) {
        existingFormsByEntryKey.set(`${entry.ticketTypeId}:${entry.formIndexInTicketType}`, existingForm)
      }
    })

    this.visitorForms = ticketEntries.map((entry, idx) => {
      const entryKey = `${entry.ticketTypeId}:${entry.formIndexInTicketType}`
      const existingForm = existingFormsByEntryKey.get(entryKey)
      const isNewForm = !existingForm
      const form = existingForm || this.buildInputFormGroup(false)
      const firstTarget = entry.targets[0]
      const existingVisitor = this.cart[firstTarget.cartIndex]?.visitors?.[firstTarget.visitorIdx]
      if (existingVisitor && isNewForm) {
        this.applyVisitorToForm(form, existingVisitor)
      } else if (isNewForm && idx === 0 && !this.production) {
        // Dev convenience: pre-fill only the first visitor form so the flow can be clicked through
        // without typing. Every other visitor form starts empty, since a shared default across all
        // of them would always collide with the duplicate-email check.
        this.applyDevDefaultsToForm(form)
      }
      return form
    })

    this.visitorToCartMap = ticketEntries

    if (this.currentVisitorIndex >= this.visitorForms.length)
      this.currentVisitorIndex = this.visitorForms.length - 1
    if (this.currentVisitorIndex < 0)
      this.currentVisitorIndex = 0

    this.inputForm = this.visitorForms[this.currentVisitorIndex]
    this.isFormSubmitted = false
  }

  goToVisitor(index: number) {
    if (!this.isMultipleVisitorForms)
      return
    if (index < 0 || index >= this.visitorForms.length)
      return
    this.currentVisitorIndex = index
    this.inputForm = this.visitorForms[this.currentVisitorIndex]
    this.isFormSubmitted = false
  }

  private applyVisitorToForm(form: FormGroup, visitor: VisitorInput) {
    const patch: any = {}
    if (form.get('userFirstname')) patch['userFirstname'] = visitor.firstname || ''
    if (form.get('userLastname')) patch['userLastname'] = visitor.lastname || ''
    if (form.get('userEmail')) patch['userEmail'] = visitor.email || ''
    if (form.get('userEmail_confirm')) patch['userEmail_confirm'] = visitor.email || ''
    if (form.get('userPhone')) patch['userPhone'] = visitor.phone || ''
    if (form.get('userMobile')) patch['userMobile'] = visitor.phone || ''
    if (form.get('companyName')) patch['companyName'] = visitor.companyName || ''
    if (form.get('userCountry')) patch['userCountry'] = visitor.country || ''
    if (form.get('userZipcode')) patch['userZipcode'] = visitor.zipcode || ''
    if (form.get('userLanguage')) patch['userLanguage'] = visitor.language || ''
    if (form.get('userJobTitle')) patch['userJobTitle'] = visitor.jobTitle || ''
    if (form.get('userVisitGoal')) patch['userVisitGoal'] = visitor.visitGoal || ''
    if (form.get('userFullName')) patch['userFullName'] = visitor.fullName || ''
    if (form.get('fullName')) patch['fullName'] = visitor.fullName || ''
    if (form.get('userCity')) patch['userCity'] = visitor.city || ''

    if (!patch['userFirstname'] && form.get('userFirstname') && visitor.fullName) {
      const parts = visitor.fullName.split(' ')
      patch['userFirstname'] = parts.shift() || ''
      if (form.get('userLastname'))
        patch['userLastname'] = parts.join(' ')
    }

    form.patchValue(patch, { emitEvent: false })
  }

  // Dev-only convenience pre-fill, applied once to a freshly-built FormGroup (never bound via
  // ngModel, so it can't leak across forms the way a shared template binding would).
  private applyDevDefaultsToForm(form: FormGroup) {
    const patch: any = {}
    if (form.get('userFirstname')) patch['userFirstname'] = this.defaultDevFirstName
    if (form.get('userLastname')) patch['userLastname'] = this.defaultDevLastName
    if (form.get('userEmail')) patch['userEmail'] = this.defaultDevEmail
    if (form.get('userEmail_confirm')) patch['userEmail_confirm'] = this.defaultDevEmail
    form.patchValue(patch, { emitEvent: false })
  }

  private extractVisitorFromForm(form: FormGroup): VisitorInput {
    const val: any = form.value || {}
    const firstname = val.userFirstname || val.firstname || ''
    const lastname = val.userLastname || val.lastname || ''
    const email = val.userEmail || val.email || ''
    let fullName = val.userFullName || val.fullName || ''
    if (!fullName && (firstname || lastname))
      fullName = `${firstname} ${lastname}`.trim()
    if (!fullName && email)
      fullName = email
    const phone = val.userPhone || val.userMobile || val.mobile || ''

    return {
      fullName,
      firstname,
      lastname,
      email,
      phone,
      gender: val.userGender || val.gender || '',
      country: val.userCountry || val.country || '',
      zipcode: val.userZipcode || val.zipcode || '',
      language: val.userLanguage || val.language || this.selectedLanguage,
      jobTitle: val.userJobTitle || val.jobTitle || '',
      companyName: val.companyName || '',
      companyIndustry: val.companyIndustry || '',
      companyAddress: val.companyAddress || '',
      companyZipcode: val.companyZipcode || '',
      companyCity: val.companyCity || '',
      visitGoal: val.userVisitGoal || val.visitGoal || '',
      city: val.userCity || val.city || '',
      ageGroup: val.userAgeGroup || val.ageGroup || ''
    }
  }

  private getEmailFieldNames(): string[] {
    const emailFields: string[] = []
    const addIfEmail = (input?: FormInput) => {
      if (!input || input.type !== 'email') return
      if (!emailFields.includes(input.fieldName))
        emailFields.push(input.fieldName)
    }

    if (Array.isArray(this.formData?.inputs))
      this.formData.inputs.forEach(addIfEmail)
    if (Array.isArray(this.formData?.sections)) {
      this.formData.sections.forEach(section => {
        if (Array.isArray(section?.inputs))
          section.inputs.forEach(addIfEmail)
      })
    }

    return emailFields
  }

  private getEmailValueFromForm(form: FormGroup): string {
    const values: any = form?.value || {}
    const emailFields = this.getEmailFieldNames()
    for (const fieldName of emailFields) {
      const rawValue = values[fieldName]
      if (typeof rawValue === 'string' && rawValue.trim().length > 0)
        return rawValue.trim()
    }
    return ''
  }

  private normalizeEmail(email: string): string {
    return email.trim().toLowerCase()
  }

  // Ticket type behind the visitor form at this index has isMultipleVisitorForms == true (i.e.
  // it's a per-unit form, not a shared once-per-ticket-type form).
  private isPerUnitVisitorFormEntry(index: number): boolean {
    const ticketTypeId = this.visitorToCartMap[index]?.ticketTypeId
    const ticketType = this.ticketTypes.find(tt => tt.id === ticketTypeId)
    return !!ticketType?.isMultipleVisitorForms
  }

  // Email uniqueness is only enforced between forms of ticket types with isMultipleVisitorForms ==
  // true: e.g. buying 2x a ticket type requiring one form per visitor must use 2 different emails,
  // but a shared (isMultipleVisitorForms == false) ticket type's single form may reuse any of those
  // emails, and is never checked against other shared forms either.
  private findDuplicateVisitorEmailIndex(currentIndex: number): number | null {
    if (!this.isMultipleVisitorForms || !Array.isArray(this.visitorForms))
      return null
    if (currentIndex < 0 || currentIndex >= this.visitorForms.length)
      return null
    if (!this.isPerUnitVisitorFormEntry(currentIndex))
      return null

    const currentForm = this.visitorForms[currentIndex]
    const currentEmail = this.normalizeEmail(this.getEmailValueFromForm(currentForm))
    if (!currentEmail)
      return null

    for (let i = 0; i < this.visitorForms.length; i++) {
      if (i === currentIndex) continue
      if (!this.isPerUnitVisitorFormEntry(i)) continue
      const email = this.normalizeEmail(this.getEmailValueFromForm(this.visitorForms[i]))
      if (!email) continue
      if (email === currentEmail)
        return i
    }

    return null
  }

  private updateCartVisitorsFromForms() {
    if (!this.isMultipleVisitorForms)
      return

    this.cart.forEach((item: CartItem) => {
      if (item.ticketTypeId)
        item.visitors = []
    })

    this.visitorForms.forEach((form: FormGroup, index: number) => {
      const entry = this.visitorToCartMap[index]
      if (!entry) return
      const visitor = this.extractVisitorFromForm(form)
      entry.targets.forEach(target => {
        const cartItem = this.cart[target.cartIndex]
        if (!cartItem) return
        if (!cartItem.visitors)
          cartItem.visitors = []

        cartItem.visitors[target.visitorIdx] = visitor
      })
    })
  }

  get visitorEmails(): string[] {
    if (!this.isMultipleVisitorForms) {
      const email = (this.inputForm?.value?.userEmail || '').trim()
      return email ? [email] : []
    }

    const emails: string[] = []
    this.cart.forEach((item) => {
      if (!item.ticketTypeId || !Array.isArray(item.visitors))
        return
      item.visitors.forEach((v) => {
        if (v?.email)
          emails.push(v.email)
      })
    })
    return emails
  }

  // Returns the purchaser email from the first form completed in the checkout flow.
  get buyerEmail(): string {
    const buyerForm = this.isMultipleVisitorForms ? this.visitorForms[0] : this.inputForm
    return buyerForm ? this.getEmailValueFromForm(buyerForm) : ''
  }

  private getFirstVisitorInCart(): VisitorInput | null {
    if (!Array.isArray(this.cart))
      return null

    for (const item of this.cart) {
      if (!item.ticketTypeId || !Array.isArray(item.visitors))
        continue
      const visitor = item.visitors.find((v) => !!v)
      if (visitor)
        return visitor
    }
    return null
  }

  get errorControl() {
    return this.inputForm.controls;
  }

  ngOnDestroy() {
    this?.routeSub?.unsubscribe();
    if (this.twoManyLoginAttemptsInterval) clearInterval(this.twoManyLoginAttemptsInterval);
    if (this.twoManyLoginAttemptsTimeout) clearTimeout(this.twoManyLoginAttemptsTimeout);
    if (this.seatRefreshInterval) clearInterval(this.seatRefreshInterval);
    if (this.reservationInterval) clearInterval(this.reservationInterval);
  }

  stepChanged(event: any) {
    this.silentLog("--- stepChanged ---")
    this.step = event.detail.value
    this.silentLog("this.step", this.step)

    if (this.step === '1') {
      this.stepProgress = 0.11
    } else if (this.step === '2') {
      // Check if the user has selected at least one ticket type
      if (!this.isTicketSelected) {
        const errorAlert = this.alertController.create({
          header: this.translateService.instant('DIALOGS.MISSING_TICKET_TYPE.TITLE'),
          message: this.translateService.instant('DIALOGS.MISSING_TICKET_TYPE.SUBTITLE'),
          buttons: ['OK']
        })
        errorAlert.then(alert => alert.present())

        setTimeout(() => {
          this.ticketStep = 'typeSelection'
          this.goToStep1()
        }, 1000)
        return
      } else if (this.isTicketSelected && !this.isPriceSelected) {
        const errorAlert = this.alertController.create({
          header: this.translateService.instant('DIALOGS.MISSING_TICKET_PRICE.TITLE'),
          message: this.translateService.instant('DIALOGS.MISSING_TICKET_PRICE.SUBTITLE'),
          buttons: ['OK']
        })
        errorAlert.then(alert => alert.present())

        setTimeout(() => {
          this.ticketStep = 'priceSelection'
          this.goToStep1()
        }, 1000)
        return
      } else if (
        this.isTicketSelected &&
        this.isPriceSelected &&
        this.requiresDateSelection(this.selectedTicketType) &&
        !this.isSlotSelected
      ) {
        const errorAlert = this.alertController.create({
          header: this.translateService.instant('DIALOGS.MISSING_SLOT.TITLE'),
          message: this.translateService.instant('DIALOGS.MISSING_SLOT.SUBTITLE'),
          buttons: ['OK']
        })
        errorAlert.then(alert => alert.present())

        setTimeout(() => {
          this.ticketStep = 'dateSelection'
          this.goToStep1()
        }, 1000)
        return
      }
      this.stepProgress = 0.50
    } else if (this.step === '3') {
      // Check if the user has selected at least one ticket type
      if (!this.isTicketSelected) {
        const errorAlert = this.alertController.create({
          header: this.translateService.instant('DIALOGS.MISSING_TICKET_TYPE.TITLE'),
          message: this.translateService.instant('DIALOGS.MISSING_TICKET_TYPE.SUBTITLE'),
          buttons: ['OK']
        })
        errorAlert.then(alert => alert.present())

        setTimeout(() => {
          this.ticketStep = 'typeSelection'
          this.goToStep1()
        }, 1000)
        return
      } else if (this.isTicketSelected && !this.isPriceSelected) {
        const errorAlert = this.alertController.create({
          header: this.translateService.instant('DIALOGS.MISSING_TICKET_PRICE.TITLE'),
          message: this.translateService.instant('DIALOGS.MISSING_TICKET_PRICE.SUBTITLE'),
          buttons: ['OK']
        })
        errorAlert.then(alert => alert.present())

        setTimeout(() => {
          this.ticketStep = 'priceSelection'
          this.goToStep1()
        }, 1000)
        return
      } else if (
        this.isTicketSelected &&
        this.isPriceSelected &&
        this.requiresDateSelection(this.selectedTicketType) &&
        !this.isSlotSelected
      ) {
        const errorAlert = this.alertController.create({
          header: this.translateService.instant('DIALOGS.MISSING_SLOT.TITLE'),
          message: this.translateService.instant('DIALOGS.MISSING_SLOT.SUBTITLE'),
          buttons: ['OK']
        })
        errorAlert.then(alert => alert.present())

        setTimeout(() => {
          this.ticketStep = 'dateSelection'
          this.goToStep1()
        }, 1000)
        return
      }
      if (this.isMultipleVisitorForms) {
        this.syncVisitorFormsWithCart()
        if (this.visitorForms.length > 0)
          this.goToVisitor(this.currentVisitorIndex)
      }
      this.stepProgress = 0.75
    } else if (this.step === '4') {
      // Check if the user has selected at least one ticket type
      if (!this.isTicketSelected) {
        const errorAlert = this.alertController.create({
          header: this.translateService.instant('DIALOGS.MISSING_TICKET_TYPE.TITLE'),
          message: this.translateService.instant('DIALOGS.MISSING_TICKET_TYPE.SUBTITLE'),
          buttons: ['OK']
        })
        errorAlert.then(alert => alert.present())

        setTimeout(() => {
          this.ticketStep = 'typeSelection'
          this.goToStep1()
        }, 1000)
        return
      } else if (this.isTicketSelected && !this.isPriceSelected) {
        const errorAlert = this.alertController.create({
          header: this.translateService.instant('DIALOGS.MISSING_TICKET_PRICE.TITLE'),
          message: this.translateService.instant('DIALOGS.MISSING_TICKET_PRICE.SUBTITLE'),
          buttons: ['OK']
        })
        errorAlert.then(alert => alert.present())

        setTimeout(() => {
          this.ticketStep = 'priceSelection'
          this.goToStep1()
        }, 1000)
        return
      } else if (
        this.isTicketSelected &&
        this.isPriceSelected &&
        this.requiresDateSelection(this.selectedTicketType) &&
        !this.isSlotSelected
      ) {
        const errorAlert = this.alertController.create({
          header: this.translateService.instant('DIALOGS.MISSING_SLOT.TITLE'),
          message: this.translateService.instant('DIALOGS.MISSING_SLOT.SUBTITLE'),
          buttons: ['OK']
        })
        errorAlert.then(alert => alert.present())

        setTimeout(() => {
          this.ticketStep = 'dateSelection'
          this.goToStep1()
        }, 1000)
        return
      }
      // (this.formData.organizerProfileId === 'qMNXFX4PpFC7IfVtlI0i' && !this.isKoruAgreementChecked) || 
      // (this.isMultipleVisitorForms && this.selectedTicketType.id === 'Eqa4EywCv1tzr48Rq9DG' && !this.isInternationalAgreementChecked) ||
      else if (
        !this.inputForm.valid ||
        !this.isWelkomAgreementChecked ||
        !this.isOrganizerAgreementChecked ||
        (this.isReallyNexusClient && (!this.isSwapcardFirstAgreementChecked || !this.isSwapcardSecondAgreementChecked)) ||
        this.isPersonalEmail ||
        this.isConfirmEmailDifferent
      ) {
        const errorAlert = this.alertController.create({
          header: this.translateService.instant('DIALOGS.MISSING_INPUTS.TITLE'),
          message: this.translateService.instant('DIALOGS.MISSING_INPUTS.SUBTITLE'),
          buttons: ['OK']
        })
        errorAlert.then(alert => alert.present())

        setTimeout(() => {
          this.goToStep3()
        }, 1000)
        return
      }

      this.goToStep4() // Force to refresh discount and final price
    }
  }

  // Toggle the ticket type selection and unselect all other ticket types
  async toggleTicketSelection(tickeType: TicketTypeData) {
    this.silentLog("--- toggleTicketSelection ---")

    if (!this.production)
      this.silentLog("tickeType", tickeType)

    if (tickeType.isSoldOut) {
      return
    }

    this.isTicketSelected = false
    for (const ticketType of this.ticketTypes) {
      if (ticketType.id === tickeType.id) {
        ticketType.isSelected = !ticketType.isSelected
        this.selectedTicketType = ticketType
        this.isTicketSelected = ticketType.isSelected

        if (ticketType.isSelected) {
          if (this.formData.seatingEnabled && (ticketType.isStudentDiscount || ticketType.isChildrenDiscount || ticketType.isYouthDiscount || ticketType.isSeniorDiscount || ticketType.isDisabledDiscount)) {
            const priceTag = await this.askForPrice(ticketType);
            if (priceTag) {
              ticketType.priceSelection = { [priceTag]: 1 };
            } else {
              ticketType.isSelected = false;
              this.isTicketSelected = false;
              this.selectedTicketType = {} as TicketTypeData;
            }
          } else {
            const isEarlyBird = this.isEarlyBirdActiveForTicket(ticketType);
            ticketType.priceSelection = { [isEarlyBird ? 'early-bird' : 'normal']: 1 };
          }
        } else {
          ticketType.priceSelection = {};
        }
      } else {
        ticketType.isSelected = false;
      }
    }

    this.computeBasketValue();

    if (!this.production)
      this.silentLog("this.selectedTicketType", this.selectedTicketType)
  }

  // Check if the early bird price is active (view call)
  get isEarlyBirdActive(): boolean {
    if (!this.selectedTicketType?.isEarlyBird || !this.selectedTicketType.earlyBirdDate?.seconds) {
      return false;
    }

    const earlyBirdTimestamp = this.selectedTicketType.earlyBirdDate.seconds * 1000;
    return earlyBirdTimestamp > Date.now();
  }

  // Get add-ons that are applicable to the currently selected ticket type
  get filteredAddOns(): AddOnData[] {
    if (this.isMultipleTicketsAllowed) {
      // Find all unique ticket type IDs currently in the cart
      const cartTicketTypeIds = Array.from(new Set(
        this.cart
          .filter(item => item.ticketTypeId !== null)
          .map(item => item.ticketTypeId as string)
      ));

      if (cartTicketTypeIds.length === 0) {
        return [];
      }

      return this.addOns.filter((addOn: AddOnData) => {
        if (addOn.applyToAllTicketTypes !== false) {
          return true;
        }
        return cartTicketTypeIds.some(id => (addOn.applicableTicketTypeIds ?? []).includes(id));
      });
    }

    if (!this.selectedTicketType || this.selectedTicketType.isGiftCard) {
      return [];
    }

    if (!this.selectedTicketType.id) {
      return this.addOns;
    }

    return this.addOns.filter((addOn: AddOnData) => {
      // If applyToAllTicketTypes is undefined or true, show the add-on
      if (addOn.applyToAllTicketTypes !== false) {
        return true;
      }

      // If applyToAllTicketTypes is false, check if the current ticket type is in the applicable list
      if (!(addOn.applicableTicketTypeIds ?? []).includes(this.selectedTicketType.id)) {
        return false;
      }

      return true;
    });
  }

  // Returns whether every configured ticket type is free.
  get allTicketTypesAreFree(): boolean {
    return this.ticketTypes.length > 0 && this.ticketTypes.every((ticketType: TicketTypeData) => ticketType.isFree);
  }

  // Returns whether the cart contains at least one add-on (cart step).
  get cartHasAddOns(): boolean {
    return this.cart.some((item: CartItem) => !!item.addOnId);
  }

  // Returns whether at least one currently available add-on is selected.
  get hasSelectedAddOns(): boolean {
    return this.filteredAddOns.some((addOn: AddOnData) => (addOn.selection || 0) > 0);
  }

  // Returns whether every currently available add-on is free.
  get allAvailableAddOnsAreFree(): boolean {
    const availableAddOns = this.filteredAddOns;
    return availableAddOns.length > 0 && availableAddOns.every((addOn: AddOnData) => addOn.isFree);
  }

  // Decrease the add-on selection
  removeAddOnSelection(addOn: AddOnData) {
    this.silentLog("--- removeAddOnSelection ---")
    if (!this.production)
      this.silentLog("addOn.selection", addOn.selection)

    if (addOn.selection !== undefined) {
      if (addOn.selection > 0) {
        addOn.selection--
      }
    } else {
      addOn.selection = 0
    }

    this.computeBasketValue()
  }

  // Increase the ticket type selection
  addAddOnSelection(addOn: AddOnData) {
    this.silentLog("--- addAddOnSelection ---")
    if (!this.production) {
      this.silentLog("addOn", addOn)
      this.silentLog("addOn.selection", addOn.selection)
      this.silentLog("addOn.maxPerOrder", addOn.maxPerOrder)
      this.silentLog("addOn remaingin", addOn.remaining)
    }

    if (addOn.selection !== undefined)
      this.silentLog("addOn.selection", addOn.selection)

    // Beware of addOn.maxPerOrder
    // Count the total number of add-ons selected for all price tags
    let totalSelectedAddOns: number = 0
    this.cart.forEach((cartItem: CartItem) => {
      if (cartItem.addOnId === addOn.id) {
        totalSelectedAddOns += cartItem.quantity
      }
    })
    if (!this.production)
      this.silentLog("totalSelectedAddOns", totalSelectedAddOns)

    if (totalSelectedAddOns >= addOn.maxPerOrder) {
      const errorAlert = this.alertController.create({
        header: this.translateService.instant('DIALOGS.MAXIMUM_ADDONS.TITLE'),
        message: this.translateService.instant('DIALOGS.MAXIMUM_ADDONS.MESSAGE', { max: addOn.maxPerOrder }),
        buttons: ['OK']
      })
      errorAlert.then(alert => alert.present())
      return
    } else if (addOn.remaining !== undefined && addOn.remaining !== null && totalSelectedAddOns >= addOn.remaining) {
      const errorAlert = this.alertController.create({
        header: this.translateService.instant('DIALOGS.NO_MORE_ADDONS.TITLE'),
        message: this.translateService.instant('DIALOGS.NO_MORE_ADDONS.MESSAGE'),
        buttons: ['OK']
      })
      errorAlert.then(alert => alert.present())
      return
    }

    if (addOn.selection !== undefined && addOn.selection !== undefined) {
      addOn.selection++
    } else {
      addOn.selection = 1
    }

    this.computeBasketValue()
  }

  // Decrease the ticket type selection
  // Decrease the ticket type selection
  removePriceSelection(priceTag: string, ticketType?: TicketTypeData) {
    const targetTicketType = ticketType || this.selectedTicketType;
    if (!targetTicketType) return;

    this.silentLog("--- removePriceSelection ---")
    if (!this.production)
      this.silentLog("ticketType.selection", targetTicketType.priceSelection)

    if (targetTicketType.priceSelection !== undefined && targetTicketType.priceSelection[priceTag] !== undefined) {
      if (targetTicketType.priceSelection[priceTag] > 0) {
        if (priceTag === 'family-group' && targetTicketType.priceSelection[priceTag] === 3)
          targetTicketType.priceSelection[priceTag] = 0 // Family group starts with 2 adults and 1 child tickets
        else if (priceTag === 'regular-group' && targetTicketType.priceSelection[priceTag] === targetTicketType.regularGroupBaseTickets)
          targetTicketType.priceSelection[priceTag] = 0 // Regular group starts with X base tickets
        else
          targetTicketType.priceSelection[priceTag]--
      }
    } else if (targetTicketType.priceSelection !== undefined) {
      targetTicketType.priceSelection[priceTag] = 0
    } else {
      targetTicketType.priceSelection = {}
      targetTicketType.priceSelection[priceTag] = 0
    }

    this.computeBasketValue()
  }

  // Increase the ticket type selection
  addPriceSelection(priceTag: string, ticketType?: TicketTypeData) {
    const targetTicketType = ticketType || this.selectedTicketType;
    if (!targetTicketType) return;

    this.silentLog("--- addPriceSelection ---")
    if (!this.production) {
      this.silentLog("priceTag", priceTag)
      this.silentLog("targetTicketType", targetTicketType)
      this.silentLog("targetTicketType.priceSelection", targetTicketType.priceSelection)
    }
    if (targetTicketType.priceSelection !== undefined)
      this.silentLog("targetTicketType.priceSelection[priceTag]", targetTicketType.priceSelection[priceTag])
    this.silentLog('------> targetTicketType.remaining = ', targetTicketType.remaining);

    // Beware of targetTicketType.maxPerOrder
    // Count the total number of tickets selected for all price tags
    let totalSelectedTickets = 0
    this.cart.forEach((cartItem: CartItem) => {
      if (cartItem.ticketTypeId === targetTicketType.id) {
        totalSelectedTickets += cartItem.quantity
      }
    })
    if (!this.production)
      this.silentLog("totalSelectedTickets", totalSelectedTickets)

    if (totalSelectedTickets >= targetTicketType.maxPerOrder) {
      const errorAlert = this.alertController.create({
        header: this.translateService.instant('DIALOGS.MAXIMUM_TICKETS.TITLE'),
        message: this.translateService.instant('DIALOGS.MAXIMUM_TICKETS.MESSAGE', { max: targetTicketType.maxPerOrder }),
        buttons: ['OK']
      })
      errorAlert.then(alert => alert.present())
      return
    } else if (
      targetTicketType.remaining !== undefined &&
      targetTicketType.remaining !== null &&
      this.getIssuedTicketQuantity(totalSelectedTickets + 1, targetTicketType) > targetTicketType.remaining
    ) {
      const errorAlert = this.alertController.create({
        header: this.translateService.instant('DIALOGS.NO_MORE_TICKETS.TITLE'),
        message: this.translateService.instant('DIALOGS.NO_MORE_TICKETS.MESSAGE'),
        buttons: ['OK']
      })
      errorAlert.then(alert => alert.present())
      return
    }

    if (targetTicketType.priceSelection !== undefined && targetTicketType.priceSelection[priceTag] !== undefined) {
      if (priceTag === 'family-group' && targetTicketType.priceSelection[priceTag] === 0) {
        if (totalSelectedTickets + 3 > targetTicketType.maxPerOrder) {
          const errorAlert = this.alertController.create({
            header: this.translateService.instant('DIALOGS.MAXIMUM_TICKETS.TITLE'),
            message: this.translateService.instant('DIALOGS.MAXIMUM_TICKETS.MESSAGE', { max: targetTicketType.maxPerOrder }),
            buttons: ['OK']
          })
          errorAlert.then(alert => alert.present())
          return
        } else if (targetTicketType.remaining && (totalSelectedTickets + 3) > targetTicketType.remaining) {
          const errorAlert = this.alertController.create({
            header: this.translateService.instant('DIALOGS.NO_MORE_TICKETS.TITLE'),
            message: this.translateService.instant('DIALOGS.NO_MORE_TICKETS.MESSAGE'),
            buttons: ['OK']
          })
          errorAlert.then(alert => alert.present())
          return
        }

        targetTicketType.priceSelection[priceTag] = 3 // Family group starts with 2 adults and 1 child tickets
      } else if (priceTag === 'regular-group' && targetTicketType.priceSelection[priceTag] === 0) {
        if (totalSelectedTickets + targetTicketType.regularGroupBaseTickets > targetTicketType.maxPerOrder) {
          const errorAlert = this.alertController.create({
            header: this.translateService.instant('DIALOGS.MAXIMUM_TICKETS.TITLE'),
            message: this.translateService.instant('DIALOGS.MAXIMUM_TICKETS.MESSAGE', { max: targetTicketType.maxPerOrder }),
            buttons: ['OK']
          })
          errorAlert.then(alert => alert.present())
          return
        } else if (targetTicketType.remaining && (totalSelectedTickets + targetTicketType.regularGroupBaseTickets) > targetTicketType.remaining) {
          const errorAlert = this.alertController.create({
            header: this.translateService.instant('DIALOGS.NO_MORE_TICKETS.TITLE'),
            message: this.translateService.instant('DIALOGS.NO_MORE_TICKETS.MESSAGE'),
            buttons: ['OK']
          })
          errorAlert.then(alert => alert.present())
          return
        }

        targetTicketType.priceSelection[priceTag] = targetTicketType.regularGroupBaseTickets // Regular group starts with X base tickets
      } else
        targetTicketType.priceSelection[priceTag]++
    } else if (targetTicketType.priceSelection !== undefined) {
      if (priceTag === 'family-group') {
        if (totalSelectedTickets + 3 > targetTicketType.maxPerOrder) {
          const errorAlert = this.alertController.create({
            header: this.translateService.instant('DIALOGS.MAXIMUM_TICKETS.TITLE'),
            message: this.translateService.instant('DIALOGS.MAXIMUM_TICKETS.MESSAGE', { max: targetTicketType.maxPerOrder }),
            buttons: ['OK']
          })
          errorAlert.then(alert => alert.present())
          return
        } else if (targetTicketType.remaining && (totalSelectedTickets + 3) > targetTicketType.remaining) {
          const errorAlert = this.alertController.create({
            header: this.translateService.instant('DIALOGS.NO_MORE_TICKETS.TITLE'),
            message: this.translateService.instant('DIALOGS.NO_MORE_TICKETS.MESSAGE'),
            buttons: ['OK']
          })
          errorAlert.then(alert => alert.present())
          return
        }

        targetTicketType.priceSelection[priceTag] = 3 // Family group starts with 2 adults and 1 child tickets
      } else if (priceTag === 'regular-group') {
        if (totalSelectedTickets + targetTicketType.regularGroupBaseTickets > targetTicketType.maxPerOrder) {
          const errorAlert = this.alertController.create({
            header: this.translateService.instant('DIALOGS.MAXIMUM_TICKETS.TITLE'),
            message: this.translateService.instant('DIALOGS.MAXIMUM_TICKETS.MESSAGE', { max: targetTicketType.maxPerOrder }),
            buttons: ['OK']
          })
          errorAlert.then(alert => alert.present())
          return
        } else if (targetTicketType.remaining && (totalSelectedTickets + targetTicketType.regularGroupBaseTickets) > targetTicketType.remaining) {
          const errorAlert = this.alertController.create({
            header: this.translateService.instant('DIALOGS.NO_MORE_TICKETS.TITLE'),
            message: this.translateService.instant('DIALOGS.NO_MORE_TICKETS.MESSAGE'),
            buttons: ['OK']
          })
          errorAlert.then(alert => alert.present())
          return
        }

        targetTicketType.priceSelection[priceTag] = targetTicketType.regularGroupBaseTickets // Regular group starts with X base tickets
      } else
        targetTicketType.priceSelection[priceTag] = 1
    } else {
      targetTicketType.priceSelection = {}
      if (priceTag === 'family-group') {
        targetTicketType.priceSelection[priceTag] = 3 // Family group starts with 2 adults and 1 child tickets
      } else if (priceTag === 'regular-group') {
        targetTicketType.priceSelection[priceTag] = targetTicketType.regularGroupBaseTickets // Regular group starts with X base tickets
      } else
        targetTicketType.priceSelection[priceTag] = 1
    }

    this.computeBasketValue()
  }

  computeBasketValue() {
    this.silentLog("--- computeBasketValue ---")
    if (!this.production)
      this.silentLog("this.ticketTypes", this.ticketTypes)

    this.isTicketSelected = false
    this.isPriceSelected = false
    this.totalTicketTypePrice = 0
    this.totalTicketTypeVAT = 0
    this.totalAddOnPrice = 0
    this.totalAddOnVAT = 0
    this.totalPrice = 0
    this.totalVAT = 0
    // TVA = HT * VATRATE = VATRATE * TTC / (1 + VATRATE)
    this.cart = []

    if (this.formData.seatingEnabled && this.selectedSeats.length > 0) {
      this.selectedSeats.forEach(seat => {
        this.isTicketSelected = true
        this.isPriceSelected = true
        const tt = this.ticketTypes.find(t => t.id === seat.ticketTypeId)
        if (tt) {
          const priceTag = seat.priceTag || 'normal'
          let tagPrice = tt.price
          if (priceTag === 'early-bird' && tt.isEarlyBird) tagPrice = tt.earlyBirdPrice
          else if (priceTag === 'student' && tt.isStudentDiscount) tagPrice = tt.studentPrice
          else if (priceTag === 'children' && tt.isChildrenDiscount) tagPrice = tt.childrenPrice
          else if (priceTag === 'youth' && tt.isYouthDiscount) tagPrice = tt.youthPrice
          else if (priceTag === 'senior' && tt.isSeniorDiscount) tagPrice = tt.seniorPrice
          else if (priceTag === 'disabled' && tt.isDisabledDiscount) tagPrice = tt.disabledPrice

          // Final fallback to base price if tag price is missing/invalid
          if (tagPrice === undefined || tagPrice === null || Number.isNaN(tagPrice)) {
            tagPrice = tt.price || 0;
          }

          const TTC = tagPrice
          const VATRATE = (tt.vat !== undefined && !Number.isNaN(tt.vat)) ? tt.vat / 100 : 0
          this.totalTicketTypePrice += TTC
          this.totalTicketTypeVAT += VATRATE * TTC / (1 + VATRATE)
          this.totalPrice += TTC
          this.totalVAT += VATRATE * TTC / (1 + VATRATE)

          const cartItem: CartItem = {
            ticketTypeId: tt.id,
            seat: {
              id: seat.id,
              row: seat.row,
              col: seat.col,
              number: seat.number,
              blockName: seat.blockName,
              floor: seat.floor,
              ticketTypeLabel: tt.label,
              isDisabledAccessible: seat.isDisabledAccessible
            },
            addOnId: null,
            isCombinedTicket: tt.isCombinedTicket,
            combinedTickets: tt.combinedTickets || [],
            combinedTicketKey: tt.combinedTicketKey || "",
            priceTag: priceTag,
            label: tt.label,
            description: tt.description,
            quantity: 1,
            price: tagPrice,
            priceAfterPromotion: tagPrice,
            vat: (tt.vat !== undefined && !Number.isNaN(tt.vat)) ? tt.vat : 0,
          }
          this.cart.push(cartItem)
        }
      })
    }

    const ticketTypesToProcess = this.isGiftCardMode ? this.giftCardTicketTypes : (this.isMultipleTicketsAllowed ? this.ticketTypes : (this.selectedTicketType ? [this.selectedTicketType] : []));
    this.silentLog("------> ticketTypesToProcess = ", ticketTypesToProcess);
    ticketTypesToProcess.forEach((ticketType: TicketTypeData) => {
      this.silentLog("------> ticketType = ", ticketType);
      if (ticketType !== undefined && ticketType.priceSelection !== undefined && ticketType.priceSelection !== null) {
        Object.keys(ticketType.priceSelection).forEach((priceTag: string) => {
          if (!this.production)
            this.silentLog("priceTag", priceTag)
          if (typeof ticketType.priceSelection[priceTag] === 'number' && ticketType.priceSelection[priceTag] > 0) {
            this.isTicketSelected = true
            this.isPriceSelected = true
            let tagPrice: number = 0
            if (priceTag === 'normal')
              tagPrice = ticketType.price
            else if (priceTag === 'early-bird')
              tagPrice = ticketType.earlyBirdPrice
            else if (priceTag === 'student')
              tagPrice = ticketType.studentPrice
            else if (priceTag === 'children')
              tagPrice = ticketType.childrenPrice
            else if (priceTag === 'youth')
              tagPrice = ticketType.youthPrice
            else if (priceTag === 'senior')
              tagPrice = ticketType.seniorPrice
            else if (priceTag === 'disabled')
              tagPrice = ticketType.disabledPrice
            else if (priceTag === 'family-group')
              tagPrice = 0
            else if (priceTag === 'regular-group')
              tagPrice = 0

            // Final fallback to base price if tag price is missing/invalid (except for group placeholders)
            if ((tagPrice === undefined || tagPrice === null || Number.isNaN(tagPrice)) && priceTag !== 'family-group' && priceTag !== 'regular-group') {
              tagPrice = ticketType.price || 0;
            }

            if (!this.production)
              this.silentLog("tagPrice", tagPrice)

            const tagSelection: number = ticketType.priceSelection[priceTag]
            if (!this.production)
              this.silentLog("tagSelection", tagSelection)
            if (priceTag === 'family-group' && tagSelection >= 3) {
              let TTC: number = ticketType.familyGroupBasePrice + ticketType.familyGroupExtraTicketPrice * (tagSelection - 3)
              let VATRATE: number = ticketType.vat / 100
              this.totalTicketTypePrice += TTC
              this.totalTicketTypeVAT += VATRATE * TTC / (1 + VATRATE)
              this.totalPrice += TTC
              this.totalVAT += VATRATE * TTC / (1 + VATRATE)
              tagPrice = Math.round(1000 * TTC / tagSelection) / 1000
            } else if (priceTag === 'regular-group' && tagSelection >= ticketType.regularGroupBaseTickets) {
              let TTC: number = ticketType.regularGroupBasePrice + ticketType.regularGroupExtraTicketPrice * (tagSelection - ticketType.regularGroupBaseTickets)
              let VATRATE: number = ticketType.vat / 100
              this.totalTicketTypePrice += TTC
              this.totalTicketTypeVAT += VATRATE * TTC / (1 + VATRATE)
              this.totalPrice += TTC
              this.totalVAT += VATRATE * TTC / (1 + VATRATE)
              tagPrice = Math.round(1000 * TTC / tagSelection) / 1000
            } else {
              let TTC: number = tagPrice * tagSelection
              let VATRATE: number = ticketType.vat / 100
              this.totalTicketTypePrice += TTC
              this.totalTicketTypeVAT += VATRATE * TTC / (1 + VATRATE)
              this.totalPrice += TTC
              this.totalVAT += VATRATE * TTC / (1 + VATRATE)

              if (!this.production) {
                this.silentLog("TTC", TTC)
                this.silentLog("VATRATE", VATRATE)
                this.silentLog("this.totalTicketTypeVAT", this.totalTicketTypeVAT)
                this.silentLog("this.totalVAT", this.totalVAT)
              }
            }

            // Add the ticket type to the cart
            const cartItem: CartItem = {
              ticketTypeId: ticketType.id,
              addOnId: null,
              isCombinedTicket: ticketType.isCombinedTicket,
              combinedTickets: ticketType.combinedTickets || [],
              combinedTicketKey: ticketType.combinedTicketKey || "",
              priceTag: priceTag,
              label: ticketType.label,
              description: ticketType.description,
              quantity: tagSelection,
              price: tagPrice,
              priceAfterPromotion: tagPrice, // No promotion applied yet
              vat: (ticketType.vat !== undefined && !Number.isNaN(ticketType.vat)) ? ticketType.vat : 0,
            }
            this.cart.push(cartItem)
          }
        })
      }
    })

    if (!this.production) {
      this.silentLog("this.totalPrice after ticketTypes", this.totalTicketTypePrice)
      this.silentLog("this.totalVAT after ticketTypes", this.totalTicketTypeVAT)
    }

    this.formData.addOns.forEach((addOn: AddOnData) => {
      if (!this.production)
        this.silentLog("addOn", addOn)
      if (typeof addOn.selection === 'number' && addOn.selection > 0) {
        this.isPriceSelected = true
        const tagPrice: number = addOn.price
        let addOnVAT: number = (addOn.vat !== undefined && !Number.isNaN(addOn.vat)) ? addOn.vat : 0

        // if (tagPrice > 0) {
        const tagSelection: number = addOn.selection
        if (!this.production)
          this.silentLog("tagSelection", tagSelection)
        let TTC: number = tagPrice * tagSelection
        let VATRATE: number = addOnVAT / 100
        this.totalAddOnPrice += TTC
        this.totalAddOnVAT += VATRATE * TTC / (1 + VATRATE)
        this.totalPrice += TTC
        this.totalVAT += VATRATE * TTC / (1 + VATRATE)

        // Add the ticket type to the cart
        const cartItem: CartItem = {
          ticketTypeId: null,
          addOnId: addOn.id,
          isCombinedTicket: false,
          combinedTickets: [],
          combinedTicketKey: "",
          priceTag: "",
          label: addOn.label,
          description: addOn.description,
          quantity: tagSelection,
          price: tagPrice,
          priceAfterPromotion: tagPrice, // No promotion applied yet
          vat: addOnVAT,
        }
        this.cart.push(cartItem)
        // } else {
        //   console.warn ("Price not set for this ticket tag")
        //   this.silentLog("priceTag", priceTag)
        // }
      }
    })

    // Date promotions are scoped to a ticket type and take precedence over its package discount.
    this.datePromotionApplications = applyDatePromotionToCart(this.cart, new Map(this.ticketTypes.map(tt => [tt.id, tt])), this.promotionDate)
    this.datePromotionTotal = this.datePromotionApplications.reduce((total, application) => total + application.amount, 0)
    // Seat map family discount (applied before promo codes)
    this.familyDiscountApplications = this.formData.seatingEnabled
      ? applyFamilyDiscountToCart(this.cart, new Map(this.ticketTypes.map(tt => [tt.id, tt])))
      : []
    this.familyDiscountTotal = this.familyDiscountApplications.reduce((total, application) => total + application.amount, 0)
    this.cart.forEach((cartItem: CartItem) => cartItem.priceAfterPromotion = getFamilyDiscountedUnitPrice(cartItem))
    void this.applyPromoCode()

    if (!this.production) {
      this.silentLog("this.cart after computeBasketValue", this.cart)
      this.silentLog("this.totalPrice after addOns", this.totalAddOnPrice)
      this.silentLog("this.totalVAT after addOns", this.totalAddOnVAT)
    }

    if (this.isMultipleVisitorForms)
      this.syncVisitorFormsWithCart()
  }

  async restoreCart(parsedData: any) {
    this.silentLog("--- restoreCart ---", parsedData);
    if (!parsedData) return;

    // 1. Restore Ticket Type
    if (parsedData.ticketTypesPriceSelections) {
      this.ticketTypes.forEach(tt => {
        if (parsedData.ticketTypesPriceSelections[tt.id]) {
          tt.priceSelection = parsedData.ticketTypesPriceSelections[tt.id];
        }
      });
    }
    if (parsedData.selectedTicketTypeId) {
      const ticketType = this.ticketTypes.find(t => t.id === parsedData.selectedTicketTypeId);
      if (ticketType) {
        this.selectedTicketType = ticketType;
        ticketType.isSelected = true;
        this.isTicketSelected = true;
        if (parsedData.priceSelection) {
          ticketType.priceSelection = parsedData.priceSelection;
        }
      }
    }
    this.silentLog("------ this.ticketTypes ------ ", this.ticketTypes);
    // 2. Restore Add-ons
    if (parsedData.addOnsSelections) {
      this.formData.addOns.forEach(addon => { // Changed this.addOns to this.formData.addOns
        if (parsedData.addOnsSelections[addon.id] !== undefined && parsedData.addOnsSelections[addon.id] !== null) { // Added null/undefined check
          addon.selection = parsedData.addOnsSelections[addon.id];
        }
      });
    }
    // 3. Restore Date/Slot if applicable
    if (this.selectedTicketType && this.requiresDateSelection(this.selectedTicketType) && parsedData.selectedDate) {
      this.selectedDate = new Date(parsedData.selectedDate);
      this.selectedDateISO = this.selectedDate.toISOString();

      // Ensure slots are loaded
      this.bookedSlotTickets = await this.getBookedTimeSlots();

      if (this.selectedTicketType.isTimeSlot && parsedData.selectedSlotTickets) {
        this.displayTimeSlots();
        // Match the slot
        const slot = this.timeSlots.find(s => s.label === parsedData.selectedSlotTickets.label);
        if (slot) {
          this.toggleTimeSlotSelection(slot);
        }
      } else {
        // Date only slot
        const bookedDay = this.getBookedSlotTicketsForDate(this.selectedDate);
        if (bookedDay) {
          this.selectedSlotTickets = bookedDay;
          this.isSlotSelected = true;
        }
      }

      if (this.formData.seatingEnabled) {
        await this.fetchBookedSeatsForSlot(this.selectedDate, this.selectedTime);
      }
    }

    // Restore the gift cards purchase of a seat map event
    if (this.formData?.seatingEnabled && parsedData.seatMapPurchaseMode === 'giftCards') {
      this.seatMapPurchaseMode = 'giftCards';
    }

    // Restore Seating if applicable
    if (this.formData?.seatingEnabled && parsedData.selectedSeats) {
      this.selectedSeats = parsedData.selectedSeats;
      this.lastSelectedSeats = [...this.selectedSeats];
    }

    // 4. Re-calculate totals and Advance to Step 3
    this.computeBasketValue();
    this.goToStep3();
  }


  get filteredSeatingConfig(): SeatMapConfig | undefined {
    if (!this.formData.seatingConfig) return undefined;
    if (!this.formData.seatingEnabled || !this.eventHasDateSelection() || !this.isSlotSelected) return this.formData.seatingConfig;

    // Total ticket selections from cart (excluding current seat map selections for other categories if we want to be strict, but usually we just care if it's generally available)
    const totalTicketSelections = 0; // Simple check for now, can be improved to include cart

    // Filter blocks based on ticket type availability for selected date/time
    const filteredBlocks = this.formData.seatingConfig.blocks.filter(block => {
      const tt = this.ticketTypes.find(t => t.id === block.ticketTypeId);
      if (!tt) return false;
      if (!tt.isVisible) return false;

      if (this.requiresDateSelection(tt)) {
        const availability = this.allTicketTypesAvailabilityForSelectedDate[tt.id];
        if (!availability) return true; // If no data, show it (fallback)

        if (availability.timeSlots === null) {
          return availability.booked + totalTicketSelections < availability.capacity;
        } else {
          // Check if at least one time slot is available for this category
          // Or if the CURRENT selected slot is available for this category
          const selectedSlotLabel = this.selectedSlotTickets?.label;
          if (selectedSlotLabel && availability.timeSlots[selectedSlotLabel]) {
            return availability.timeSlots[selectedSlotLabel].booked + totalTicketSelections < availability.timeSlots[selectedSlotLabel].capacity;
          }

          // Fallback: check if ANY slot is available
          return Object.values(availability.timeSlots).some((slot: any) => slot.booked + totalTicketSelections < slot.capacity);
        }
      }

      return false;
    });

    return {
      ...this.formData.seatingConfig,
      blocks: filteredBlocks
    };
  }

  // Ticket type ids whose seats should render as unavailable (visible but not selectable)
  // on the seat map because the selected date falls outside the ticket type's calendar
  // opening window, weekly schedule, or a closing exception.
  get unavailableSeatMapTicketTypeIds(): string[] {
    if (!this.formData.seatingEnabled) return [];
    if (!this.selectedDate) return this.outOfSalesWindowTicketTypeIds;
    const selectedDate = this.selectedDate;
    return this.outOfSalesWindowTicketTypeIds.concat(this.ticketTypes
      .filter(tt => {
        if (!this.requiresDateSelection(tt)) return false;
        if (tt.isDateSlot) return !this.isDateOpenForSlotSettings(selectedDate, tt.slotSettings);
        // Combined ticket: unavailable if any of its date-slotted sub-tickets is closed for the selected date
        return this.getDateSlottedSubTickets(tt).some(sub => {
          const subDetails = this.ticketTypes.find(t => t.id === sub.ticketId);
          return subDetails ? !this.isDateOpenForSlotSettings(selectedDate, subDetails.slotSettings) : false;
        });
      })
      .map(tt => tt.id));
  }

  /** True when a ticket type / add-on is on sale at the given time. Missing sale dates (legacy items, default settings) mean no restriction. */
  private isWithinSalesWindow(item: { salesStartDate?: any, salesEndDate?: any }, nowMs: number): boolean {
    if (typeof item.salesStartDate?.seconds === 'number' && item.salesStartDate.seconds * 1000 > nowMs)
      return false
    if (typeof item.salesEndDate?.seconds === 'number' && item.salesEndDate.seconds * 1000 <= nowMs)
      return false
    return true
  }

  async goToStep0(editOrder: boolean = false) {
    this.silentLog("--- goToStep0 ---")

    const _goToStep0 = () => {
      this.step = '0'
      this.stepProgress = 0.05
    }

    if (editOrder) {
      const alert = await this.alertController.create({
        header: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.TITLE'),
        message: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.MESSAGE'),
        buttons: [
          {
            text: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.KEEP'),
            role: 'cancel',
            handler: () => { }
          },
          {
            text: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.MODIFY'),
            role: 'confirm',
            handler: async () => {
              await this.unbookTemporaryTickets(this.reservationId, false)
              _goToStep0()
            }
          }
        ]
      })
      await alert.present()
    } else {
      _goToStep0()
    }
  }

  goToStep1() {
    this.silentLog("--- goToStep1 ---")
    if (this.giftCardTicketTypes.length > 0) {
      if (this.isGiftCardLink)
        this.goToGiftCardSelection()
      else
        this.goToPurchaseChoice()
      return
    }

    if (this.formData.seatingEnabled && this.eventHasDateSelection() && this.ticketStep !== 'dateSelection' && !this.isSlotSelected) {
      const tt = this.ticketTypes.find(tt => this.requiresDateSelection(tt));
      if (tt) {
        this.selectedTicketType = tt;
        this.goToDateSelection();
        return;
      }
    }

    if (this.isMultipleTicketsAllowed) {
      this.step = '1'
      this.ticketStep = 'typeSelection'
      this.stepProgress = 0.11
    } else if (this.ticketTypes.length === 1 && !this.ticketTypes[0].isSoldOut) {
      this.goToPriceSelection()
    } else {
      this.step = '1'
      this.stepProgress = 0.11
    }
  }
  async goToTypeSelection(editOrder: boolean = false) {
    this.silentLog("--- goToTypeSelection ---")

    const _goToTypeSelection = () => {
      this.step = '1'
      this.ticketStep = 'typeSelection'
      this.stepProgress = 0.11

      this.resetPromoCode()
    }

    if (editOrder) {
      const alert = await this.alertController.create({
        header: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.TITLE'),
        message: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.MESSAGE'),
        buttons: [
          {
            text: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.KEEP'),
            role: 'cancel',
            handler: () => { }
          },
          {
            text: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.MODIFY'),
            role: 'confirm',
            handler: async () => {
              await this.unbookTemporaryTickets(this.reservationId, false)
              _goToTypeSelection()
            }
          }
        ]
      })
      await alert.present()
    } else {
      _goToTypeSelection()
    }
  }

  /** Seat map events: shows the tickets / gift cards choice. */
  goToPurchaseChoice() {
    this.silentLog("--- goToPurchaseChoice ---")
    this.step = '1'
    this.ticketStep = 'purchaseChoice'
    this.stepProgress = 0.11
  }

  /** Seat map events: the customer buys tickets, the gift cards selection is dropped. */
  chooseSeatMapTickets() {
    this.seatMapPurchaseMode = 'tickets'
    this.giftCardTicketTypes.forEach((ticketType: TicketTypeData) => ticketType.priceSelection = {})

    const seatTicketTypes = this.ticketTypes.filter((ticketType: TicketTypeData) => !ticketType.isGiftCard)
    const dateTicketType = seatTicketTypes.find((ticketType: TicketTypeData) => this.requiresDateSelection(ticketType))
    this.selectedTicketType = dateTicketType || (seatTicketTypes.length === 1 ? seatTicketTypes[0] : {} as TicketTypeData)
    if (dateTicketType)
      this.goToDateSelection()
    else
      this.goToTypeSelection()
  }

  /** Seat map events: the customer buys gift cards, the selected seats are dropped. */
  chooseSeatMapGiftCards() {
    this.selectedSeats = []
    this.lastSelectedSeats = []
    this.goToGiftCardSelection()
  }

  /** Seat map events: gift cards and their quantities (no seats, no add-ons). */
  async goToGiftCardSelection(editOrder: boolean = false) {
    this.silentLog("--- goToGiftCardSelection ---")

    const _goToGiftCardSelection = () => {
      this.seatMapPurchaseMode = 'giftCards'
      // A gift card as selected ticket type: no date / time slot and no add-ons
      this.selectedTicketType = this.giftCardTicketTypes[0]
      this.step = '1'
      this.ticketStep = 'giftCardSelection'
      this.stepProgress = this.hasSeatMapPurchaseChoice ? 0.22 : 0.11

      this.resetPromoCode()
    }

    if (editOrder) {
      const alert = await this.alertController.create({
        header: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.TITLE'),
        message: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.MESSAGE'),
        buttons: [
          {
            text: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.KEEP'),
            role: 'cancel',
            handler: () => { }
          },
          {
            text: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.MODIFY'),
            role: 'confirm',
            handler: async () => {
              await this.unbookTemporaryTickets(this.reservationId, false)
              _goToGiftCardSelection()
            }
          }
        ]
      })
      await alert.present()
    } else {
      _goToGiftCardSelection()
    }
  }

  onGiftCardSelectionBack() {
    if (this.hasSeatMapPurchaseChoice) {
      this.goToPurchaseChoice()
    } else {
      this.goToStep0()
    }
  }

  getDateSlottedSubTickets(ticketType: TicketTypeData) {
    if (!ticketType || !ticketType.combinedTickets) return [];
    return ticketType.combinedTickets.filter(sub => sub.isDateSlot);
  }

  /** Returns whether the current event must keep the rolling six-week booking window. */
  private hasRestrictedSlotBookingWindow(): boolean {
    return this.formData?.clientId === RESTRICTED_SLOT_WINDOW_CLIENT_ID &&
      RESTRICTED_SLOT_WINDOW_PROFILE_IDS.has(this.formData?.organizerProfileId)
  }

  /** Converts a supported slot boundary value to an ISO calendar date. */
  private getSlotBoundaryISO(rawDate: any): string | null {
    if (!rawDate)
      return null

    let parsedDate: Date
    if (typeof rawDate.toDate === 'function')
      parsedDate = rawDate.toDate()
    else if (typeof rawDate.seconds === 'number')
      parsedDate = new Date(rawDate.seconds * 1000)
    else if (typeof rawDate._seconds === 'number')
      parsedDate = new Date(rawDate._seconds * 1000)
    else
      parsedDate = new Date(rawDate)

    return isNaN(parsedDate.getTime()) ? null : parsedDate.toISOString().substring(0, 10)
  }

  /** Formats a local calendar date as YYYY-MM-DD. */
  private getCalendarDateISO(date: Date = new Date()): string {
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  /** Adds calendar days to an ISO date without daylight-saving shifts. */
  private addCalendarDays(dateISO: string, days: number): string {
    const [year, month, day] = dateISO.split('-').map(Number)
    const date = new Date(Date.UTC(year, month - 1, day))
    date.setUTCDate(date.getUTCDate() + days)
    return date.toISOString().substring(0, 10)
  }

  /** Resolves the selectable slot range for a regular or combined ticket type. */
  private getTicketSlotDateRange(ticketType: TicketTypeData): { openingDateISO: string, closingDateISO: string } {
    const todayISO = this.getCalendarDateISO()
    const fallbackClosingDateISO = this.addCalendarDays(todayISO, RESTRICTED_SLOT_WINDOW_DAYS)
    let openingDateISO = todayISO
    let closingDateISO: string | null = null

    const slotSettings: SlotSettings[] = []
    if (ticketType.isCombinedTicket) {
      this.getDateSlottedSubTickets(ticketType).forEach((subTicket: { eventId: string, isDateSlot?: boolean, ticketId: string }) => {
        const subTicketDetails = this.ticketTypes.find(ticket => ticket.id === subTicket.ticketId)
        if (subTicketDetails?.slotSettings)
          slotSettings.push(subTicketDetails.slotSettings)
      })
    } else if (ticketType.slotSettings) {
      slotSettings.push(ticketType.slotSettings)
    }

    slotSettings.forEach(settings => {
      const startDateISO = this.getSlotBoundaryISO(settings.startDate)
      const endDateISO = this.getSlotBoundaryISO(settings.endDate)

      if (startDateISO && startDateISO > openingDateISO)
        openingDateISO = startDateISO
      if (endDateISO && (!closingDateISO || endDateISO < closingDateISO))
        closingDateISO = endDateISO
    })

    closingDateISO = closingDateISO || fallbackClosingDateISO
    if (this.hasRestrictedSlotBookingWindow() && closingDateISO > fallbackClosingDateISO)
      closingDateISO = fallbackClosingDateISO

    return { openingDateISO, closingDateISO }
  }

  /** Counts every availability day from today through the configured closing date. */
  private getDaysToSeek(ticketType: TicketTypeData): number {
    const { closingDateISO } = this.getTicketSlotDateRange(ticketType)
    const [endYear, endMonth, endDay] = closingDateISO.split('-').map(Number)
    const today = new Date()
    const todayUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())
    const closingDateUTC = Date.UTC(endYear, endMonth - 1, endDay)
    return Math.max(1, Math.floor((closingDateUTC - todayUTC) / (24 * 60 * 60 * 1000)) + 1)
  }

  requiresDateSelection(ticketType: TicketTypeData): boolean {
    if (!ticketType) return false;
    return ticketType.isDateSlot || this.getDateSlottedSubTickets(ticketType).length > 0;
  }

  eventHasDateSelection(): boolean {
    if (!this.ticketTypes) return false;
    return this.ticketTypes.some(tt => this.requiresDateSelection(tt));
  }

  eventHasTimeSlotSelection(): boolean {
    if (!this.ticketTypes) return false;
    return this.ticketTypes.some(tt => tt.isTimeSlot && this.requiresDateSelection(tt));
  }

  async goToPriceSelection(editOrder: boolean = false) {
    this.silentLog("--- goToPriceSelection ---")
    if (this.isMultipleTicketsAllowed) {
      this.goToTypeSelection(editOrder);
      return;
    }

    const _goToPriceSelection = () => {
      this.step = '1'
      this.ticketStep = 'priceSelection'
      this.stepProgress = 0.22
      this.isSlotSelected = false
    }

    if (editOrder) {
      const alert = await this.alertController.create({
        header: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.TITLE'),
        message: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.MESSAGE'),
        buttons: [
          {
            text: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.KEEP'),
            role: 'cancel',
            handler: () => { }
          },
          {
            text: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.MODIFY'),
            role: 'confirm',
            handler: async () => {
              await this.unbookTemporaryTickets(this.reservationId, false)
              if (this.formData.seatingEnabled) {
                this.goToTypeSelection()
              } else {
                _goToPriceSelection()
              }
            }
          }
        ]
      })
      await alert.present()
    } else {
      if (this.formData.seatingEnabled) {
        this.goToTypeSelection()
      } else {
        _goToPriceSelection()
      }
    }
  }
  async goToDateSelection(editOrder: boolean = false) {
    this.silentLog("--- goToDateSelection ---")

    const _goToDateSelection = async () => {
      this.selectedDate = null;
      this.selectedDateISO = "";
      this.selectedTime = "";
      this.isSlotSelected = false;
      this.selectedSlotTickets = {} as TimeSlot;
      this.timeSlots = [];
      this.computeBasketValue();

      try {
        const slotDateRange = this.getTicketSlotDateRange(this.selectedTicketType)
        this.openingDateISO = slotDateRange.openingDateISO
        this.closingDateISO = slotDateRange.closingDateISO

        // Call a Firebase function to get the booked time slots
        this.bookedSlotTickets = await this.getBookedTimeSlots()
        if (!this.production) {
          this.silentLog("this.bookedSlotTickets", this.bookedSlotTickets)
          this.silentLog("this.openingDateISO", this.openingDateISO)
          this.silentLog("this.closingDateISO", this.closingDateISO)
        }

        /*
        // Find availability for the selected calendar date.
        this.selectedSlotTickets = this.getBookedSlotTicketsForDate(this.selectedDate)
        this.silentLog("this.selectedSlotTickets", this.selectedSlotTickets)
    
        // Get total ticket selections from cart
        let totalTicketSelections = 0
        this.cart.forEach((cartItem: CartItem) => {
          if (cartItem.ticketTypeId === this.selectedTicketType.id) {
            totalTicketSelections += cartItem.quantity
          }
        })
        this.silentLog("totalTicketSelections", totalTicketSelections)
        
        // Check if the date is available
        if (this.selectedSlotTickets.booked + totalTicketSelections <= this.selectedSlotTickets.capacity)
          this.isSlotSelected = true
        */

      } catch (error) {
        console.error(error)

        // Alert the user of the error
        const errorAlert = await this.alertController.create({
          header: this.translateService.instant('DIALOGS.SLOT_SYNC_ERROR.TITLE'),
          message: this.translateService.instant('DIALOGS.SLOT_SYNC_ERROR.MESSAGE')
        })
        errorAlert.present()

        return
      }

      this.step = '1'
      this.ticketStep = 'dateSelection'
      this.stepProgress = 0.22

      // Move the calendar viewport to the first selectable date without selecting it.
      setTimeout(() => {
        void this.dateSlotPicker?.resetCalendar(this.openingDateISO)
      })
    }

    if (editOrder) {
      const alert = await this.alertController.create({
        header: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.TITLE'),
        message: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.MESSAGE'),
        buttons: [
          {
            text: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.KEEP'),
            role: 'cancel',
            handler: () => { }
          },
          {
            text: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.MODIFY'),
            role: 'confirm',
            handler: async () => {
              await this.unbookTemporaryTickets(this.reservationId, false)
              if (this.formData.seatingEnabled) {
                this.goToTypeSelection()
              } else {
                _goToDateSelection()
              }
            }
          }
        ]
      })
      await alert.present()
    } else {
      _goToDateSelection()
    }
  }

  async onDateConfirmed() {
    if (this.formData.seatingEnabled) {
      await this.fetchAllTicketTypesAvailability();
      this.goToTypeSelection(); // Show ticket selection (seat map or list)
    } else {
      this.goToStep2();
    }
  }

  async fetchAllTicketTypesAvailability() {
    this.silentLog("--- fetchAllTicketTypesAvailability ---")
    const slottedTicketTypes = this.ticketTypes.filter(tt => this.requiresDateSelection(tt));

    // Use parallel fetching to save time
    const promises = slottedTicketTypes.map(async (tt) => {
      try {
        const availability = await this.getBookedTimeSlots(tt);
        this.allTicketTypesAvailability[tt.id] = availability;
      } catch (error) {
        console.error(`Error fetching availability for ${tt.id}:`, error);
      }
    });

    await Promise.all(promises);
    this.updateAllTicketTypesAvailabilityForSelectedDate();
  }

  updateAllTicketTypesAvailabilityForSelectedDate() {
    if (!this.selectedDate) return;

    this.allTicketTypesAvailabilityForSelectedDate = {};
    Object.keys(this.allTicketTypesAvailability).forEach(ttId => {
      const data = this.getBookedSlotTicketsForDate(this.selectedDate, this.allTicketTypesAvailability[ttId]);
      if (data) {
        this.allTicketTypesAvailabilityForSelectedDate[ttId] = data;
      }
    });

    // Fetch sold seats for the selected date (if no time slot selection is required)
    if (this.formData.seatingEnabled && this.selectedDate && !this.eventHasTimeSlotSelection()) {
      this.fetchBookedSeatsForSlot(this.selectedDate);
    }
  }

  onSeatMapBack() {
    // Reset the seat selection for the current ticket type
    this.selectedSeats = [];
    this.computeBasketValue();
    this.onTicketSelectionBack();
  }

  onTicketSelectionBack() {
    if (this.formData.seatingEnabled && this.eventHasDateSelection()) {
      this.goToDateSelection();
    } else if (this.hasSeatMapPurchaseChoice) {
      this.goToPurchaseChoice();
    } else {
      this.goToStep0();
    }
  }
  async goToStep2(editOrder: boolean = false) {
    this.silentLog("--- goToStep2 ---")

    const _goToStep2 = () => {
      this.step = '2'
      this.stepProgress = 0.50
    }

    if (editOrder) {
      const alert = await this.alertController.create({
        header: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.TITLE'),
        message: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.MESSAGE'),
        buttons: [
          {
            text: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.KEEP'),
            role: 'cancel',
            handler: () => { }
          },
          {
            text: this.translateService.instant('DIALOGS.EDIT_ORDER_CONFIRMATION.MODIFY'),
            role: 'confirm',
            handler: async () => {
              await this.unbookTemporaryTickets(this.reservationId, false)
              if (this.formData.seatingEnabled) {
                this.goToTypeSelection()
              } else {
                this.goToPriceSelection()
              }
            }
          }
        ]
      })
      await alert.present()
    } else {
      // Check if the user has selected at least one PAID ticket type if CHILDREN or YOUTH price tag is selected
      if (this.isLuxexpoClient) {
        this.silentLog("Special check Luxexpo for children/youth price tag with no paid tickets")
        let hasChildrenPriceTag: boolean = false
        let hasYouthPriceTag: boolean = false
        Object.keys(this.selectedTicketType.priceSelection).forEach((priceTag: string) => {
          if (priceTag === 'children' && this.selectedTicketType.priceSelection[priceTag] > 0) {
            hasChildrenPriceTag = true
          }
          if (priceTag === 'youth' && this.selectedTicketType.priceSelection[priceTag] > 0) {
            hasYouthPriceTag = true
          }
        })
        if (hasChildrenPriceTag || hasYouthPriceTag) {
          let hasPaidTicket: boolean = false
          Object.keys(this.selectedTicketType.priceSelection).forEach((priceTag: string) => {
            if (priceTag !== 'children' && priceTag !== 'youth' && this.selectedTicketType.priceSelection[priceTag] > 0) {
              hasPaidTicket = true
            }
          })
          if (!hasPaidTicket) {
            const errorAlert = this.alertController.create({
              header: this.translateService.instant(hasChildrenPriceTag ? 'DIALOGS.CHILDREN_PRICE_TAG_REQUIRES_ADULT.TITLE' : 'DIALOGS.YOUTH_PRICE_TAG_REQUIRES_ADULT.TITLE'),
              message: this.translateService.instant(hasChildrenPriceTag ? 'DIALOGS.CHILDREN_PRICE_TAG_REQUIRES_ADULT.MESSAGE' : 'DIALOGS.YOUTH_PRICE_TAG_REQUIRES_ADULT.MESSAGE'),
              buttons: ['OK']
            })
            errorAlert.then(alert => alert.present())

            setTimeout(() => {
              this.ticketStep = 'priceSelection'
              this.goToStep1()
            }, 1000)
            return
          }
        }
      }

      _goToStep2()
    }
  }

  async goToStep3() {
    this.silentLog("--- goToStep3 ---")

    if (this.requiresDateSelection(this.selectedTicketType) && !this.isSlotSelected) {
      await this.goToDateSelection();
      return;
    }

    // Seat map gift cards are not seated: they are booked like standard tickets
    const isSeatedCart = this.formData.seatingEnabled && !this.isGiftCardMode
    if (isSeatedCart && !this.reservationId) {
      const success = await this.bookTemporarySeatedTickets();
      if (!success) return;
    } else if (!isSeatedCart && !this.reservationId) {
      const cart = this.getBookableItems().map((item: any) => ({
        ticketTypeId: item.ticketTypeId,
        addOnId: item.addOnId,
        quantity: item.quantity,
        isCombinedTicket: item.isCombinedTicket,
        combinedTickets: item.isCombinedTicket ? item.combinedTickets : []
      }));

      if (cart.length !== 0) {
        const success = await this.bookTemporaryTickets();
        if (!success) return;
      }
    }

    if (this.isMultipleVisitorForms) {
      this.currentVisitorIndex = 0
      this.syncVisitorFormsWithCart()
      if (this.visitorForms.length > 0)
        this.goToVisitor(0)
    }

    // Check if the user has selected at least one PAID ticket type if CHILDREN or YOUTH price tag is selected
    if (this.isLuxexpoClient) {
      this.silentLog("Special check Luxexpo for children/youth price tag with no paid tickets")
      let hasChildrenPriceTag: boolean = false
      let hasYouthPriceTag: boolean = false
      Object.keys(this.selectedTicketType.priceSelection).forEach((priceTag: string) => {
        if (priceTag === 'children' && this.selectedTicketType.priceSelection[priceTag] > 0) {
          hasChildrenPriceTag = true
        }
        if (priceTag === 'youth' && this.selectedTicketType.priceSelection[priceTag] > 0) {
          hasYouthPriceTag = true
        }
      })
      if (hasChildrenPriceTag || hasYouthPriceTag) {
        let hasPaidTicket: boolean = false
        Object.keys(this.selectedTicketType.priceSelection).forEach((priceTag: string) => {
          if (priceTag !== 'children' && priceTag !== 'youth' && this.selectedTicketType.priceSelection[priceTag] > 0) {
            hasPaidTicket = true
          }
        })
        if (!hasPaidTicket) {
          const errorAlert = this.alertController.create({
            header: this.translateService.instant(hasChildrenPriceTag ? 'DIALOGS.CHILDREN_PRICE_TAG_REQUIRES_ADULT.TITLE' : 'DIALOGS.YOUTH_PRICE_TAG_REQUIRES_ADULT.TITLE'),
            message: this.translateService.instant(hasChildrenPriceTag ? 'DIALOGS.CHILDREN_PRICE_TAG_REQUIRES_ADULT.MESSAGE' : 'DIALOGS.YOUTH_PRICE_TAG_REQUIRES_ADULT.MESSAGE'),
            buttons: ['OK']
          })
          errorAlert.then(alert => alert.present())

          setTimeout(() => {
            this.ticketStep = 'priceSelection'
            this.goToStep1()
          }, 1000)
          return
        }
      }
    }

    this.step = '3'
    this.stepProgress = 0.75
    void this.trackPublicFormConversion(2)

    this.trackMetaPixelEvent("AddToCart")
  }
  async goToStep4() {
    this.silentLog("--- goToStep4 ---")

    /*
    const loading = await this.loadingControler.create({ message: "Checking available tickets..." })
    loading.present()
   
    // Check cart sold out before proceeding
    await this.getTicketTypesRemaining()
   
    loading.dismiss()
   
    // Aggregate cart quantities by ticket type
    const cartQuantities: { [key: string]: number } = {}
    this.cart.forEach((item: CartItem) => {
      if (item.ticketTypeId) {
        cartQuantities[item.ticketTypeId] = (cartQuantities[item.ticketTypeId] || 0) + item.quantity
      }
    })
   
    for (const ticketTypeId of Object.keys(cartQuantities)) {
      const ticketType = this.formData.ticketTypes.find((tt: TicketTypeData) => tt.id === ticketTypeId)
      if (ticketType && ticketType.isLimited) {
        // if (ticketType.isSoldOut || (ticketType.remaining !== null && ticketType.remaining !== undefined && cartQuantities[ticketTypeId] > ticketType.remaining)) {
        if (ticketType && ticketType.isSoldOut) {
          console.warn("Capacity check failed for", ticketTypeId, "requested:", cartQuantities[ticketTypeId], "available:", ticketType.remaining)
          const errorAlert = await this.alertController.create({
            header: this.translateService.instant('DIALOGS.IS_SOLD_OUT.TITLE'),
            message: this.translateService.instant('DIALOGS.IS_SOLD_OUT.SUBTITLE'),
            buttons: ['OK']
          })
          await errorAlert.present()
   
          setTimeout(() => {
            this.ticketStep = 'typeSelection'
            this.goToStep1()
          }, 1000)
          return
        }
      }
    }
    */

    this.applyPromoCode()
    this.step = '4'
    this.stepProgress = 1
    void this.trackPublicFormConversion(3)
  }

  /** Records a conversion milestone without interrupting the ticketing journey on analytics failure. */
  private async trackPublicFormConversion(stage: 2 | 3): Promise<void> {
    if (!this.formId)
      return

    try {
      const callable = httpsCallable(this.functions, 'trackPublicFormConversionV2')
      await callable({ formId: this.formId, stage })
    } catch (error) {
      console.warn('Unable to track public form conversion stage', stage, error)
    }
  }

  /** Matches availability by calendar date regardless of the server's UTC day or array order. */
  private getBookedSlotTicketsForDate(date: Date | string | null, availability: any[] = this.bookedSlotTickets): any {
    if (!date)
      return undefined;
    const dateISO = getSlotSelectedCalendarDate(date);
    if (!dateISO)
      return undefined;
    return availability.find(day => getSlotCalendarDate(day.date) === dateISO);
  }

  // Getting booked ticket counter for each availble date/time slot
  async getTicketTypesRemaining(): Promise<any> {
    if (!this.production)
      this.silentLog("--- getTicketTypesRemaining ---")

    return new Promise(async (resolve, reject) => {

      // const loading = await this.loadingControler.create({message: "Getting available tickets..."})
      // loading.present()

      try {
        // Call a Firebase function to send the confirmation email and add the visitor to firestore
        const callable = httpsCallable(this.functions, "getTicketTypesRemaining");

        const result: any = await callable({
          clientId: this.formData.clientId,
          eventId: this.formData.eventId,
          orderId: this.reservationId
        })
        if (!this.production)
          this.silentLog("getTicketTypesRemaining results", result)
        if (!result.data.success)
          throw ({ code: result.data.code, header: 'Server error', message: result.data.message })

        // loading.dismiss()
        if (!this.production)
          this.silentLog("result.data", result.data)
        this.formData.ticketTypes.forEach((ticketType: TicketTypeData) => {
          const remainingTicketType = result.data.ticketTypesRemaining.find((remaining: any) => remaining.id === ticketType.id)
          remainingTicketType.remaining = (remainingTicketType.remaining !== null && remainingTicketType.remaining !== undefined && !remainingTicketType.isCombinedTicket && !remainingTicketType.isDateSlot) ? remainingTicketType.remaining : null
          if (remainingTicketType) {
            if (!this.production)
              this.silentLog("FOUND remainingTicketType", remainingTicketType)
            ticketType.remaining = remainingTicketType.remaining
            ticketType.isSoldOut = (remainingTicketType.remaining !== null && remainingTicketType.remaining <= 0 && ticketType.capacity > 0) ? true : false
            if (!this.production)
              this.silentLog("ticketType.isSoldOut", ticketType.isSoldOut)
          }
        })
        if (!this.production)
          this.silentLog("this.formData.ticketTypes", this.formData.ticketTypes)
        resolve(true)
      } catch (error: any) {
        console.error(error)
        // loading.dismiss()

        reject(error)
      }
    })
  }

  // Getting booked ticket counter for each availble date/time slot
  async getAddOnsRemaining(): Promise<any> {
    if (!this.production)
      this.silentLog("--- getAddOnsRemaining ---")

    return new Promise(async (resolve, reject) => {

      // const loading = await this.loadingControler.create({message: "Getting available tickets..."})
      // loading.present()

      try {
        // Call a Firebase function to send the confirmation email and add the visitor to firestore
        const callable = httpsCallable(this.functions, "getAddOnsRemaining");

        const result: any = await callable({
          clientId: this.formData.clientId,
          eventId: this.formData.eventId,
          orderId: this.reservationId
        })
        if (!this.production)
          this.silentLog("getAddOnsRemaining results", result)
        if (!result.data.success)
          throw ({ code: result.data.code, header: 'Server error', message: result.data.message })

        // loading.dismiss()
        if (!this.production)
          this.silentLog("result.data", result.data)
        this.formData.addOns.forEach((addOn: AddOnData) => {
          const remainingAddon = result.data.addOnsRemaining.find((remaining: any) => remaining.id === addOn.id)
          if (remainingAddon) {
            addOn.remaining = remainingAddon.remaining
            addOn.isSoldOut = (remainingAddon.remaining !== null && remainingAddon.remaining <= 0 && remainingAddon.capacity > 0) ? true : false
          }
        })
        if (!this.production)
          this.silentLog("this.formData.addOns", this.formData.addOns)
        resolve(true)
      } catch (error: any) {
        console.error(error)
        // loading.dismiss()

        reject(error)
      }
    })
  }

  // Getting booked ticket counter for each availble date/time slot
  async getBookedTimeSlots(ticketType: TicketTypeData = this.selectedTicketType): Promise<any> {
    this.silentLog("--- getBookedTimeSlots ---")

    return new Promise(async (resolve, reject) => {

      const loading = await this.loadingControler.create({ message: this.translateService.instant('TIME_SLOTS.GETTING_SLOTS') })
      loading.present()

      try {
        let functionName = "getBookedSlotTicketsV2";
        let ticketTypeId = ticketType.id;

        if (ticketType.isCombinedTicket) {
          functionName = "getBookedCombinedSlotTicketsV2";
        }

        const callable = httpsCallable(this.functions, functionName);

        const result: any = await callable({
          clientId: this.formData.clientId,
          eventId: this.formData.eventId,
          ticketTypeId: ticketTypeId,
          ticketTypeSlotCapacityWeekday: ticketType.slotCapacityWeekday,
          ticketTypeSlotCapacityWeekend: ticketType.slotCapacityWeekend,
          daysToSeek: this.getDaysToSeek(ticketType)
        })
        if (!this.production)
          this.silentLog("getBookedSlotTicketsV2 results", result)
        if (!result.data.success)
          throw ({ code: result.data.code, header: 'Server error', message: result.data.message })

        loading.dismiss()
        if (!this.production)
          this.silentLog("result.data", result.data)
        this.bookedSlotTickets = result.data.bookedSlotTickets
        resolve(result.data.bookedSlotTickets)
      } catch (error: any) {
        console.error(error)
        loading.dismiss()

        reject(error)
      }
    })
  }

  async fetchBookedSeatsForSlot(date: Date, slotTime?: string) {
    if (!this.formData.seatingEnabled) return;

    try {
      const callable = httpsCallable(this.functions, 'getBookedEventSeats');
      const result: any = await callable({
        clientId: this.formData.clientId,
        eventId: this.formData.eventId,
        slotDate: date.toISOString().substring(0, 10),
        slotTime: slotTime,
        isDateSlot: this.eventHasDateSelection()
      });
      if (result.data.success) {
        this.soldSeats = result.data.soldSeats || [];
        this.silentLog("Fetched sold seats:", this.soldSeats);
      }
    } catch (error) {
      console.error("Error fetching booked event seats:", error);
    }
  }

  // Get timeSlots and display when a date is selected
  displayTimeSlots() {
    this.silentLog("--- displayTimeSlots ---")

    this.timeSlots = []

    if (this.selectedDate === null) {
      console.warn("No date selected")
      return
    }

    const slotSettings = this.selectedTicketType?.slotSettings;
    if (!this.isDateOpenForSlotSettings(this.selectedDate, slotSettings)) {
      return;
    }
    const allowedTimeWindows = this.getDateTimeWindowsForSlot(this.selectedDate, slotSettings);

    const bookedDay = this.getBookedSlotTicketsForDate(this.selectedDate)
    if (bookedDay?.timeSlots) {
      // Get now time as hh:mm
      const now = new Date();
      const isToday = getSlotSelectedCalendarDate(this.selectedDate) === getSlotSelectedCalendarDate(now);
      const nowHHMM = ("0" + now.getHours()).slice(-2) + ":" + ("0" + now.getMinutes()).slice(-2)
      this.silentLog("nowHHMM", nowHHMM)
      // Subtract slot duration to nowHHMM
      const slotDuration = Math.floor(this.selectedTicketType.timeSlotDuration / 60) // in hours
      let nowHours = parseInt(nowHHMM.split(":")[0])
      let nowMinutes = parseInt(nowHHMM.split(":")[1])
      nowHours -= slotDuration
      if (nowHours < 0) nowHours = 0
      const nowHHMMMinusSlotDuration: string = ("0" + nowHours).slice(-2) + ":" + ("0" + nowMinutes).slice(-2)
      this.silentLog("nowHHMMMinusSlotDuration", nowHHMMMinusSlotDuration)

      const hasPostStartGracePeriod = this.formData.clientId === 'U1gtpSNQhIREVxoer9qB' &&
        this.formData.eventId === 'qWB710AV7eBB2HgTik0k'
      const postStartGracePeriodMinutes = 10

      const timeToMinutes = (time: string) => {
        const [h, m] = time.split(':')
        return parseInt(h || '0') * 60 + parseInt(m || '0')
      }
      const minutesToLabel = (minutes: number) => {
        const h = Math.floor(minutes / 60)
        const m = minutes % 60
        return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`
      }

      Object.keys(bookedDay.timeSlots).forEach((timeSlotLabel: string) => {
        const [startPart] = timeSlotLabel.split('-').map((p: string) => p.trim());
        const slotStart = startPart || timeSlotLabel;

        // Hide past time slots only when the selected calendar date is today.
        if (isToday) {
          const [slotHours, slotMinutes] = slotStart.split(':').map(Number)
          const slotStartDateTime = new Date(this.selectedDate!)
          slotStartDateTime.setHours(slotHours, slotMinutes, 0, 0)
          const gracePeriodEndDateTime = new Date(slotStartDateTime.getTime() + postStartGracePeriodMinutes * 60 * 1000)
          const isPastTimeSlot = hasPostStartGracePeriod
            ? now.getTime() > gracePeriodEndDateTime.getTime()
            : slotStart <= nowHHMMMinusSlotDuration

          if (isPastTimeSlot) {
            this.silentLog("Skipping past time slot", timeSlotLabel)
            return
          }
        }
        /*
        if (allowedStartTime && timeToMinutes(slotStart) < timeToMinutes(allowedStartTime)) {
          return;
        }
        if (allowedEndTime && timeToMinutes(slotStart) >= timeToMinutes(allowedEndTime)) {
          return;
        }
        */

        const startMinutes = timeToMinutes(slotStart);
        const durationMinutes = this.selectedTicketType.timeSlotDuration || 0;
        const computedEndMinutes = startMinutes + durationMinutes;
        // Find the exception/opening window this slot start falls within, to cap its end time correctly
        const containingWindow = allowedTimeWindows.find((window) => {
          if (!window.startTime || !window.endTime) return false;
          return startMinutes >= timeToMinutes(window.startTime) && startMinutes < timeToMinutes(window.endTime);
        });
        const allowedEndMinutes = containingWindow?.endTime ? timeToMinutes(containingWindow.endTime) : null;
        const dayEndMinutes = (allowedEndMinutes !== null) ? allowedEndMinutes : (24 * 60 - 1);
        if (startMinutes >= dayEndMinutes) {
          return;
        }
        const endMinutes = Math.min(computedEndMinutes, dayEndMinutes);
        const endLabel = minutesToLabel(endMinutes);
        const displayLabel = `${slotStart}`;
        // const displayLabel = `${slotStart} - ${endLabel}`;

        this.timeSlots.push({
          label: slotStart,
          displayLabel: displayLabel,
          isSelected: false,
          booked: bookedDay.timeSlots[timeSlotLabel].booked,
          capacity: bookedDay.timeSlots[timeSlotLabel].capacity
        })
      })
    }
    if (!this.production) {
      this.silentLog("this.timeSlots", this.timeSlots)
      this.silentLog("this.selectedSlotTickets", this.selectedSlotTickets)
    }
  }
  // Quantity of the selected ticket type in the cart (time slot availability)
  get selectedTicketTypeCartQuantity(): number {
    let quantity = 0
    for (const cartItem of this.cart) {
      if (cartItem.ticketTypeId === this.selectedTicketType?.id)
        quantity += cartItem.quantity
    }
    return quantity
  }
  toggleTimeSlotSelection(timeSlot: TimeSlot) {
    this.silentLog("--- toggleTimeSlotSelection ---")
    if (!this.production) {
      this.silentLog("timeSlot", timeSlot)
      this.silentLog("this.timeSlots", this.timeSlots)
    }

    // Unselect all other time slots
    this.timeSlots.forEach((slot: TimeSlot) => {
      if (slot.label === timeSlot.label) {
        slot.isSelected = !slot.isSelected
        if (slot.isSelected) {
          this.selectedTime = (slot as any).displayLabel || slot.label
          this.selectedSlotTickets = timeSlot
          this.isSlotSelected = true

          if (this.formData.seatingEnabled && this.selectedDate) {
            this.fetchBookedSeatsForSlot(this.selectedDate, slot.label);
          }

          // Set selected date hour
          this?.selectedDate?.setHours(parseInt(slot.label.split(":")[0]), parseInt(slot.label.split(":")[1]), 0, 0); // Set time to midnight
        } else {
          this.selectedTime = "-"
          this.selectedSlotTickets = {} as TimeSlot
          this.isSlotSelected = false
          this.soldSeats = [];
        }
      } else {
        slot.isSelected = false
      }
    });

    if (this.formData.seatingEnabled) {
      this.selectedSeats = [];
      this.computeBasketValue();
    }
    this.silentLog("this.timeSlots", this.timeSlots)
  }


  /** Returns ticket exceptions or the active template period's exceptions. */
  private getSlotExceptionsForDate(date: Date | string, slotSettings?: SlotSettings): SlotException[] {
    return getSlotExceptionsForDate(date, slotSettings);
  }

  /** Checks calendar bounds and the active template period's opening days. */
  private isDateOpenForSlotSettings(date: Date, slotSettings?: SlotSettings): boolean {
    return isDateOpenForSlotSettings(date, slotSettings);
  }

  /** Resolves the active template period's opening windows for the chosen day. */
  private getDateTimeWindowsForSlot(date: Date, slotSettings?: SlotSettings): { startTime: string | null, endTime: string | null }[] {
    return getDateTimeWindowsForSlot(date, slotSettings);
  }

  private isManualHoliday(date: Date): boolean {
    /*
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();
    // if (day === 11 && month === 11) return true; // Special G610 event
    if (day === 25 && month === 11) return true; // Christmas
    if (day === 26 && month === 11) return true; // St Etienne
    if (day === 1 && month === 0) return true; // New Year
    if (day === 6 && month === 3 && year === 2026) return true; // Easter Monday 2026
    if (day === 1 && month === 4) return true; // Labour Day
    if (day === 9 && month === 4) return true; // Europe Day
    if (day === 14 && month === 4 && year === 2026) return true; // Ascension 2026
    if (day === 25 && month === 4 && year === 2026) return true; // Pentecost Monday 2026
    if (day === 23 && month === 5) return true; // National Day
    if (day === 15 && month === 7) return true; // Assumption of Mary to Heaven
    if (day === 1 && month === 10) return true; // All Saints' Day
    */
    return false;
  }

  /** Keeps the selected calendar day in local time before resolving its opening hours. */
  onSelectedDateChanged(event: any) {
    this.silentLog("--- onSelectedDateChanged ---")
    // this.silentLog("datevalue", event.detail.value)

    const selectedDateISO = event.detail.value?.toString()
    const selectedDate = parseSlotCalendarDate(selectedDateISO)
    if (!selectedDate)
      return
    this.selectedDateISO = selectedDateISO
    this.selectedDate = selectedDate
    this.clearSeatMapHighlight();
    const slotSettings = this.selectedTicketType?.slotSettings
    if (slotSettings && this.selectedDate) {
      if (!this.isDateOpenForSlotSettings(this.selectedDate, slotSettings)) {
        this.selectedDate = null;
        this.selectedDateISO = "";
        this.selectedSlotTickets = {} as TimeSlot;
        this.isSlotSelected = false;
        this.computeBasketValue();
        return;
      }
      const [{ startTime }] = this.getDateTimeWindowsForSlot(this.selectedDate, slotSettings);
      if (startTime) {
        const [hours, minutes] = startTime.split(":")
        this.selectedDate.setHours(parseInt(hours, 10), parseInt(minutes || "0", 10), 0, 0)
      }
    }

    if (this.formData.seatingEnabled) {
      this.selectedSeats = [];
      this.updateAllTicketTypesAvailabilityForSelectedDate();
    }
    this.computeBasketValue();
    this.silentLog("this.selectedDate", this.selectedDate)

    // Inform user of availability for date only ticket type
    if (!this.selectedTicketType.isTimeSlot) {
      const bookedDay = this.getBookedSlotTicketsForDate(this.selectedDate)
      this.selectedSlotTickets = bookedDay || {} as TimeSlot
      // this.silentLog("this.selectedSlotTickets", this.selectedSlotTickets)
      this.isSlotSelected = !!bookedDay
    } else {
      this.selectedTime = "-"
      this.selectedSlotTickets = {} as TimeSlot
      this.isSlotSelected = false
    }


    if (this.selectedTicketType.isTimeSlot)
      this.displayTimeSlots()
  }
  /** Detects effective privatizations inside the currently selectable calendar range. */
  get hasPrivatizedException(): boolean {
    const settings = this.selectedTicketType?.slotSettings;
    const candidates: SlotException[] = [...(settings?.exceptions || [])];
    (settings?.periods || []).forEach(period => candidates.push(...(period.settings.exceptions || [])));
    return candidates.some(exception => {
      const dateKey = getSlotCalendarDate(exception.date);
      if (!dateKey || (this.openingDateISO && dateKey < this.openingDateISO) ||
          (this.closingDateISO && dateKey > this.closingDateISO))
        return false;
      return this.getSlotExceptionsForDate(dateKey, settings)
        .some(effective => effective.isPrivatized);
    });
  }
  highlightedDates = (isoString: string) => {
    const date = parseSlotCalendarDate(isoString);
    if (!date)
      return undefined;
    const dateISO = isoString.substring(0, 10);
    if (dateISO < this.openingDateISO || dateISO > this.closingDateISO)
      return undefined;
    // this.silentLog("this.selectedTicketType", this.selectedTicketType)
    // this.silentLog("this.selectedTicketType.slotSettings", this.selectedTicketType.slotSettings)

    const slotSettings = this.selectedTicketType?.slotSettings;
    if (slotSettings) {
      const exceptions = this.getSlotExceptionsForDate(date, slotSettings);
      if (exceptions.some((exception: SlotException) => exception.isPrivatized)) {
        return {
          textColor: '#ffffff',
          backgroundColor: '#ffa500',
        };
      }
    }

    const promotionTicketTypes = this.formData.seatingEnabled ? this.ticketTypes : [this.selectedTicketType];
    if (promotionTicketTypes.some(ticketType => getDatePromotion(ticketType, dateISO)) && this.isDateEnabled(isoString)) {
      return { textColor: '#ffffff', backgroundColor: '#23764b' };
    }

    // Get total ticket selections from cart
    let totalTicketSelections = 0
    this.cart.forEach((cartItem: CartItem) => {
      if (cartItem.ticketTypeId === this.selectedTicketType.id) {
        totalTicketSelections += cartItem.quantity
      }
    })
    // this.silentLog("totalTicketSelections", totalTicketSelections)

    // Check remaining capacity for the full configured slot range
    if (dateISO >= this.openingDateISO && dateISO <= this.closingDateISO) {

      // Check if the date is opened
      const slotSettings = this.selectedTicketType.slotSettings;
      const exceptions = this.getSlotExceptionsForDate(date, slotSettings);
      if (exceptions.some((exception: SlotException) => exception.isClosed))
        return false;
      if (exceptions.length === 0 && this.isManualHoliday(date))
        return false;
      if (!this.isDateOpenForSlotSettings(date, slotSettings))
        return false;

      // Check if the date is available
      const bookedSlotTickets = this.getBookedSlotTicketsForDate(date)
      // this.silentLog("bookedSlotTickets", bookedSlotTickets)

      if (!bookedSlotTickets)
        return undefined;

      if (bookedSlotTickets.timeSlots === null) {
        if (bookedSlotTickets.booked + totalTicketSelections > bookedSlotTickets.capacity) {
          return {
            textColor: 'var(--ion-color-danger-contrast)',
            backgroundColor: 'var(--ion-color-danger)',
          };
        }
      } else {
        // Check if at least one time slot is available
        let isTimeSlotAvailable = false
        Object.keys(bookedSlotTickets.timeSlots).forEach((timeSlotLabel: string) => {
          if (bookedSlotTickets.timeSlots[timeSlotLabel].booked + totalTicketSelections <= bookedSlotTickets.timeSlots[timeSlotLabel].capacity) {
            isTimeSlotAvailable = true
          }
        })
        if (isTimeSlotAvailable)
          return true
        else {
          return {
            textColor: 'var(--ion-color-danger-contrast)',
            backgroundColor: 'var(--ion-color-danger)',
          };
        }
      }
    }

    return undefined;
  };
  isDateEnabled = (isoString: string): boolean => {
    const date = parseSlotCalendarDate(isoString);
    if (!date)
      return false;
    const dateISO = isoString.substring(0, 10);
    if (dateISO < this.openingDateISO || dateISO > this.closingDateISO)
      return false;
    // const utcDay = date.getUTCDate();
    // this.silentLog("this.selectedTicketType", this.selectedTicketType)
    // this.silentLog("this.selectedTicketType.slotSettings", this.selectedTicketType.slotSettings)

    const slotSettings = this.selectedTicketType?.slotSettings;
    const exceptions = this.getSlotExceptionsForDate(date, slotSettings);
    if (exceptions.some((exception: SlotException) => exception.isClosed))
      return false;
    if (exceptions.some((exception: SlotException) => exception.isPrivatized))
      return false;
    if (exceptions.length === 0 && this.isManualHoliday(date))
      return false;

    // Get total ticket selections from cart
    let totalTicketSelections = 0
    this.cart.forEach((cartItem: CartItem) => {
      if (cartItem.ticketTypeId === this.selectedTicketType.id) {
        totalTicketSelections += cartItem.quantity
      }
    })
    // this.silentLog("totalTicketSelections", totalTicketSelections)

    // Check remaining capacity for the full configured slot range
    if (dateISO >= this.openingDateISO && dateISO <= this.closingDateISO) {
      // Check if the date is opened
      if (!this.isDateOpenForSlotSettings(date, slotSettings))
        return false

      // Check if the date is fully booked
      // Check if the date is available
      const bookedSlotTickets = this.getBookedSlotTicketsForDate(date)
      if (!bookedSlotTickets)
        return false

      if (bookedSlotTickets.timeSlots === null) {
        if (bookedSlotTickets.booked + totalTicketSelections <= bookedSlotTickets.capacity) {
          return true
        } else {
          return false
        }
      } else {
        // Check if at least one time slot is available
        let isTimeSlotAvailable = false
        Object.keys(bookedSlotTickets.timeSlots).forEach((timeSlotLabel: string) => {
          if (bookedSlotTickets.timeSlots[timeSlotLabel].booked + totalTicketSelections <= bookedSlotTickets.timeSlots[timeSlotLabel].capacity) {
            isTimeSlotAvailable = true
          }
        })
        if (isTimeSlotAvailable)
          return true
        else
          return false
      }
    }

    return false
  };

  // Avoid some unwanted characters in number fields
  cleanNumbersKeydown(evt: any) {
    this.silentLog("--- cleanNumbersKeydown ---")
    if (["e", "E", "+", "-"].includes(evt.key))
      evt.preventDefault()
  }

  // Avoid some unwanted characters in tel fields
  cleanTelKeydown(evt: any) {
    this.silentLog("--- cleanTelKeydown ---")
    if (evt.which != 8 && !["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "+"].includes(evt.key))
      evt.preventDefault()
  }

  checkWelkomAgreement() {
    // this.silentLog("--- checkWelkomAgreement ---")
    this.isWelkomAgreementChecked = !this.isWelkomAgreementChecked
    // this.silentLog("isWelkomAgreementChecked", this.isWelkomAgreementChecked)
  }
  checkOrganizerAgreement() {
    // this.silentLog("--- checkOrganizerAgreement ---")
    this.isOrganizerAgreementChecked = !this.isOrganizerAgreementChecked
    // this.silentLog("isOrganizerAgreementChecked", this.isOrganizerAgreementChecked)
  }
  checkKoruAgreement() {
    // this.silentLog("--- checkKoruAgreement ---")
    this.isKoruAgreementChecked = !this.isKoruAgreementChecked
    // this.silentLog("isKoruAgreementChecked", this.isKoruAgreementChecked)
  }
  checkOptin() {
    // this.silentLog("--- checkOptin ---")
    this.isOptinChecked = !this.isOptinChecked
    // this.silentLog("isOptinChecked", this.isOptinChecked)
  }

  // Check if some conditions are set for the input
  // Conditions can be based on the value of another input based on input.conditionFieldName and ionput.conditionFieldOptionIndex
  // Return true if the input should be hidden
  hideBasedOnInputConditions(input: FormInput, depth: number = 0) {
    if (depth > 10) return false; // Prevent infinite recursion

    if (input.isHidden) {
      return true
    }

    if (input.applyToAllTicketTypes === false) {
      if (this.isMultipleVisitorForms) {
        // Each visitor form is tied to a specific cart line's ticket type: only check that one,
        // not every ticket type present in the cart, so unrelated ticket types' fields stay hidden.
        const currentTicketTypeId = this.visitorToCartMap[this.currentVisitorIndex]?.ticketTypeId
        if (!currentTicketTypeId || !(input.applicableTicketTypeIds ?? []).includes(currentTicketTypeId)) {
          return true
        }
      } else if (this.isMultipleTicketsAllowed) {
        const cartTicketTypeIds = this.cart.filter(item => item.ticketTypeId !== null).map(item => item.ticketTypeId as string);
        if (!cartTicketTypeIds.some(id => (input.applicableTicketTypeIds ?? []).includes(id))) {
          return true;
        }
      } else if (this.selectedTicketType) {
        if (!(input.applicableTicketTypeIds ?? []).includes(this.selectedTicketType.id)) {
          return true
        }
      }
    }

    if (input.isConditionEnabled) {
      if (input.conditionType === 'showSelect' || input.conditionType === 'hideSelect') {
        const conditionField = this.formData.inputs.find(i => i.fieldName === input.conditionFieldName);
        const isConditionFieldHidden = conditionField ? this.hideBasedOnInputConditions(conditionField, depth + 1) : false;

        if (
          !isConditionFieldHidden &&
          typeof input.conditionFieldOptionValue !== 'undefined' &&
          input.conditionFieldOptionValue.length > 0 &&
          this.inputForm.get(input.conditionFieldName)?.value !== null &&
          this.inputForm.get(input.conditionFieldName)?.value.includes(input.conditionFieldOptionValue)
        ) {
          if (input.conditionType === 'showSelect')
            return false
          else
            return true
        } else {
          if (input.conditionType === 'showSelect')
            return true
          else
            return false
        }
      } else if (input.conditionType === 'showURL' || input.conditionType === 'hideURL') {
        if (
          typeof input.conditionQueryParameter !== 'undefined' &&
          typeof this.queryParameters[input.conditionQueryParameter] !== 'undefined' &&
          this.queryParameters[input.conditionQueryParameter] === input.conditionQueryValue
        ) {
          if (input.conditionType === 'showURL')
            return false
          else
            return true
        } else {
          if (input.conditionType === 'showURL')
            return true
          else
            return false
        }
      } else {
        return false
      }
    } else {
      return false
    }
  }

  get checkEmailDifferentError() {
    return this.isFormSubmitted && this.isConfirmEmailDifferent
  }

  // Submit the form
  async submitForm() {
    if (!this.production)
      this.silentLog("form inputs", this.inputForm.value)
    this.isFormSubmitted = true

    // Check if the email is a personal email
    this.isPersonalEmail = this.isPersonalEmailBlocked
    // this.isPersonalEmail = this.isPersonalEmailBlocked && this.checkPersonalEmail();
    // this.silentLog("isPersonalEmail", this.isPersonalEmail);

    // Check if the confirmation email is different from the original email
    this.isConfirmEmailDifferent = false
    let currentVisitorEmail: string = ""
    if (this.isConfirmEmailAsked && this.isEmailConfirmationRequiredForCurrentVisitor) {
      this.formData.inputs.forEach((formInput: FormInput) => {
        if (formInput.type === 'email') {
          if (this.inputForm.value[formInput.fieldName] !== this.inputForm.value[formInput.fieldName + '_confirm']) {
            this.isConfirmEmailDifferent = true
          } else {
            currentVisitorEmail = this.inputForm.value[formInput.fieldName]
          }
        }
      })
    }
    if (!currentVisitorEmail)
      currentVisitorEmail = this.getEmailValueFromForm(this.inputForm)

    if (!this.production) {
      this.silentLog("isConfirmEmailDifferent", this.isConfirmEmailDifferent);
      this.silentLog("isConfirmEmailAsked", this.isConfirmEmailAsked);
    }

    // remove from controls from hidden fields
    let allInputsForHiding = [...(this.formData.inputs || [])];
    if (this.formData.sections) {
      this.formData.sections.forEach(s => {
        if (s.inputs) {
          s.inputs.forEach(i => {
            if (!allInputsForHiding.some(ai => ai.fieldName === i.fieldName)) {
              allInputsForHiding.push(i);
            }
          });
        }
      });
    }

    allInputsForHiding.forEach((formInput: FormInput) => {
      if (formInput.type === 'email' && !this.isEmailConfirmationRequiredForCurrentVisitor) {
        this.inputForm.get(formInput.fieldName + '_confirm')?.clearValidators();
        this.inputForm.get(formInput.fieldName + '_confirm')?.updateValueAndValidity();
      }

      if (this.hideBasedOnInputConditions(formInput)) {
        this.silentLog("Hiding field", formInput.fieldName)

        const fieldName: string = formInput.fieldName
        this.inputForm.get(fieldName)?.clearValidators();
        this.inputForm.get(fieldName)?.updateValueAndValidity();

        if (formInput.type === 'email' || formInput.firestoreKey === 'email') {
          this.inputForm.get(fieldName + '_confirm')?.clearValidators();
          this.inputForm.get(fieldName + '_confirm')?.updateValueAndValidity();
        }
      }
    })

    // Remove form controls for custom acknowledgment sections that are hidden (this.isMultipleVisitorForms && this.currentVisitorIndex > 0)
    this.formData.sections?.forEach((section: FormSection) => {
      if (section.isAcknowledgments && this.isMultipleVisitorForms && this.currentVisitorIndex > 0) {
        section.inputs?.forEach((input: FormInput) => {
          this.silentLog("Hiding acknowledgment field for returning visitor", input.fieldName)

          const fieldName: string = input.fieldName
          this.inputForm.get(fieldName)?.clearValidators();
          this.inputForm.get(fieldName)?.updateValueAndValidity();
        })
      }
    })

    // Check all required fields are set
    // (this.formData.organizerProfileId === 'qMNXFX4PpFC7IfVtlI0i' && !this.isKoruAgreementChecked)
    // (this.isMultipleVisitorForms && this.selectedTicketType.id === 'Eqa4EywCv1tzr48Rq9DG' && !this.isInternationalAgreementChecked)
    this.silentLog("this.inputForm.valid", this.inputForm.valid)
    this.silentLog("this.isMultipleVisitorForms", this.isMultipleVisitorForms)
    this.silentLog("this.currentVisitorIndex", this.currentVisitorIndex)
    this.silentLog("this.isWelkomAgreementChecked", this.isWelkomAgreementChecked)
    this.silentLog("this.isOrganizerAgreementChecked", this.isOrganizerAgreementChecked)
    this.silentLog("this.isSwapcardFirstAgreementChecked", this.isSwapcardFirstAgreementChecked)
    this.silentLog("this.isSwapcardSecondAgreementChecked", this.isSwapcardSecondAgreementChecked)
    this.silentLog("this.isPersonalEmail", this.isPersonalEmail)
    this.silentLog("this.isConfirmEmailDifferent", this.isConfirmEmailDifferent)
    if (
      !this.inputForm.valid ||
      (
        (!this.isMultipleVisitorForms || this.currentVisitorIndex === 0) &&
        (
          !this.isWelkomAgreementChecked ||
          !this.isOrganizerAgreementChecked ||
          (this.isReallyNexusClient && (!this.isSwapcardFirstAgreementChecked || !this.isSwapcardSecondAgreementChecked))
        )
      ) ||
      this.isPersonalEmail ||
      this.isConfirmEmailDifferent
    ) {
      this.silentLog('Please provide all the required values!')
    } else {
      this.silentLog('Form is valid!')

      if (this.isMultipleVisitorForms) {
        // Checking if email is not used for precedent form submission (within this order)
        this.silentLog("currentVisitorIndex", this.currentVisitorIndex)
        this.silentLog("currentVisitorEmail", currentVisitorEmail)
        this.silentLog("this.visitorEmails", this.visitorEmails)
        const duplicateIndex = this.findDuplicateVisitorEmailIndex(this.currentVisitorIndex)
        const isEmailUnique = duplicateIndex === null
        if (this.isReallyNexusClient && !isEmailUnique) {
          console.warn("Nexus, a same email used for multiple visitors")
          const errorAlert = await this.alertController.create({
            header: this.translateService.instant('DIALOGS.IS_EMAIL_USED_TWICE.TITLE'),
            message: this.translateService.instant('DIALOGS.IS_EMAIL_USED_TWICE.MESSAGE'),
            buttons: ['OK']
          })
          await errorAlert.present()
          return
        }

        this.updateCartVisitorsFromForms()
        if (this.currentVisitorIndex < this.visitorForms.length - 1) {
          this.goToVisitor(this.currentVisitorIndex + 1)
          return
        }
      }

      // Check if this email has already been used to register for this event
      // Only runs when the organiser has enabled the one-registration-per-email restriction
      if (this.formData.isOnlyOneRegistrationPerEmailAddress === true && this.formData.clientId && this.formData.eventId && currentVisitorEmail) {
        const checkLoading = await this.loadingControler.create({ message: this.translateService.instant('CONFIRMATION.GENERATING_TICKETS') })
        await checkLoading.present()
        try {
          const checkDuplicate = httpsCallable(this.functions, 'checkEmailAlreadyRegistered')
          const checkResult: any = await checkDuplicate({
            clientId: this.formData.clientId,
            eventId: this.formData.eventId,
            email: currentVisitorEmail.trim().toLowerCase()
          })
          if (checkResult?.data?.isDuplicate) {
            console.warn('Email already registered for this event:', currentVisitorEmail)
            await checkLoading.dismiss()
            const errorAlert = await this.alertController.create({
              header: this.translateService.instant('DIALOGS.IS_EMAIL_USED_TWICE.TITLE'),
              message: this.translateService.instant('DIALOGS.IS_EMAIL_USED_TWICE.MESSAGE'),
              buttons: ['OK']
            })
            await errorAlert.present()
            return
          }
        } catch (checkError) {
          // If the check fails (network, etc.), log it but do not block the user
          console.warn('checkEmailAlreadyRegistered failed, proceeding:', checkError)
        } finally {
          await checkLoading.dismiss()
        }
      }

      if (this.isSingleFreeTicketFlow) {
        void this.trackPublicFormConversion(3)
        this.registerForTheEvent()
      } else {
        this.goToStep4()
      }
    }
  }


  // Register the user for the event
  async registerForTheEvent() {
    // Use a Firebase function to register the user for the event
    this.silentLog("--- registerForTheEvent ---")

    if (!this.production)
      this.silentLog("this.cart", this.cart)

    const loading = await this.loadingControler.create({ message: this.translateService.instant('CONFIRMATION.GENERATING_TICKETS') })
    loading.present()

    try {
      // Setup the new exposant firestore document
      const inputFormKeys: string[] = Object.keys(this.inputForm.value)
      if (!this.production)
        this.silentLog("inputFormKeys", inputFormKeys)

      const primaryVisitor: VisitorInput | null = this.isMultipleVisitorForms ? this.getFirstVisitorInCart() : this.extractVisitorFromForm(this.inputForm)
      const pickValue = (visitorVal: any, formKey: string) => {
        if (visitorVal !== undefined && visitorVal !== null)
          return (typeof visitorVal === 'string') ? visitorVal.trim() : visitorVal
        const formVal = this.inputForm?.value?.[formKey]
        if (formVal !== undefined && formVal !== null)
          return (typeof formVal === 'string') ? formVal.trim() : formVal
        return ''
      }

      // Build custom fields node
      let customNode: any = {}
      inputFormKeys.forEach((formKey: string) => {
        if (formKey.startsWith('custom_')) {
          const matchingInput = this.formData.inputs.find(input => input.fieldName === formKey)
          const labelKey = (matchingInput) ?
            (typeof matchingInput.label === 'string' ? matchingInput.label : (matchingInput.label['en'] || Object.values(matchingInput.label)[0] || '')) :
            formKey.split('custom_')[1]
          customNode[formKey] = {
            label: labelKey,
            value: this.inputForm.value[formKey]
          }
        }
      })

      // Track custom acknowledgments
      if (this.formData.sections) {
        this.formData.sections.forEach(section => {
          if (section.isAcknowledgments && section.inputs) {

            if (this.isMultipleVisitorForms) {
              section.inputs.forEach(input => {
                customNode[input.fieldName] = {
                  label: this.getLocalizedLabel(input),
                  value: this.visitorForms[0].get(input.fieldName)?.value || false
                }
              })
            } else {
              section.inputs.forEach(input => {
                customNode[input.fieldName] = {
                  label: this.getLocalizedLabel(input),
                  value: this.inputForm.get(input.fieldName)?.value || false
                }
              })
            }
          }
        })
      }

      if (!this.production) {
        this.silentLog("customNode", customNode)
      }

      if (this.reservationInterval) clearInterval(this.reservationInterval);
      // Call a Firebase function to send the confirmation email and add the visitor to firestore
      // language: inputFormKeys.includes('userLanguage') && this.inputForm.value.userLanguage !== null ? this.inputForm.value.userLanguage.trim() : 'FR',
      const orderEmail: string = pickValue(primaryVisitor?.email, 'userEmail');
      const result: any = await this.callAuthenticatedFunction('registerWithoutPayment', {
        clientId: this.formData.clientId,
        eventId: this.formData.eventId,
        formId: this.formId,
        reservationId: this.reservationId,
        cart: this.cart,
        organizerMetadata: this.formData.organizerMetadata,
        organizerProfileId: this.formData.organizerProfileId,
        eventMetadata: this.formData.eventMetadata,
        organizerCommercialName: this.formData.organizerCommercialName,
        organizerMail: this.formData.organizerMail,
        isDateSlot: this.requiresDateSelection(this.selectedTicketType),
        isTimeSlot: this.selectedTicketType.isTimeSlot,
        slotDate: (this.requiresDateSelection(this.selectedTicketType)) ? this.selectedDate : null,
        slotTime: (this.selectedTicketType.isTimeSlot && this.selectedSlotTickets.label !== undefined) ? this.selectedSlotTickets.label : null,
        slotDuration: (this.selectedTicketType.isTimeSlot && this.selectedTicketType.timeSlotDuration !== undefined) ? this.selectedTicketType.timeSlotDuration : null,
        email: orderEmail,
        phone: pickValue(primaryVisitor?.phone, 'userPhone'),
        mobile: pickValue(primaryVisitor?.phone, 'userMobile'),
        firstname: pickValue(primaryVisitor?.firstname, 'userFirstname'),
        lastname: pickValue(primaryVisitor?.lastname, 'userLastname'),
        language: this.selectedLanguage,
        jobTitle: pickValue(primaryVisitor?.jobTitle, 'userJobTitle'),
        companyName: pickValue(primaryVisitor?.companyName, 'companyName'),
        companyAddress: pickValue(primaryVisitor?.companyAddress, 'companyAddress'),
        companyZipcode: pickValue(primaryVisitor?.companyZipcode, 'companyZipcode'),
        companyCity: pickValue(primaryVisitor?.companyCity, 'companyCity'),
        city: pickValue(primaryVisitor?.city, 'userCity'),
        companyIndustry: pickValue(primaryVisitor?.companyIndustry, 'companyIndustry'),
        country: pickValue(primaryVisitor?.country, 'userCountry'),
        zipcode: pickValue(primaryVisitor?.zipcode, 'userZipcode'),
        ageGroup: pickValue(primaryVisitor?.ageGroup, 'userAgeGroup'),
        gender: pickValue(primaryVisitor?.gender, 'userGender'),
        visitGoal: pickValue(primaryVisitor?.visitGoal, 'userVisitGoal'),
        promoCode: this.isOpenDaysOfferApplied ? this.openDaysOfferLabel : ((this.appliedPromoCode !== null) ? this.appliedPromoCode.code : ''),
        promoCodeId: this.isOpenDaysOfferApplied ? '' : ((this.appliedPromoCode !== null) ? this.appliedPromoCode.id : ''),
        testMode: false,
        optin: this.isOptinChecked,
        utm: {
          source: this.utm_source,
          medium: this.utm_medium,
          campaign: this.utm_campaign,
          term: this.utm_term,
          content: this.utm_content
        },
        userMetadata: customNode,
        exchangedFromOrderId: this.isExchangeMode ? this.exchangeState.originalOrderId : null,
        exchangedTicketIds: this.isExchangeMode ? this.exchangeState.originalTicketIds : null
      })
      if (!this.production)
        this.silentLog("registerWithoutPayment results", result)
      if (!result.data.success)
        throw ({ code: result.data.code, header: 'Server error', message: result.data.message })

      this.clearTemporaryReservationState();

      localStorage.removeItem('welkom_exchange_state_' + this.formId);

      loading.dismiss()
      if (!this.production)
        this.silentLog("result.data", result.data)

      // Redirect to the confirmation page — use URLSearchParams.set() to avoid
      // duplicating params that may already be present in the URL (e.g. lang)
      const redirectParams = new URLSearchParams(window.location.search);
      redirectParams.set('molliePaymentStatus', 'paid');
      redirectParams.set('email', orderEmail);
      redirectParams.set('lang', this.selectedLanguage);
      window.location.href = window.location.pathname + '?' + redirectParams.toString();
    } catch (error: any) {
      console.error(error)
      if (this.reservationId && this.reservationExpiry) this.startReservationTimer();
      loading.dismiss()

      // Alert the user of the error
      const errorAlert = await this.alertController.create({
        header: 'Error code: ' + error.code,
        message: error.message || "An error occurred while processing your request. Please try again later.",
      })
      errorAlert.present()
    }
  }

  async askForPromoCode() {
    this.silentLog("--- askForPromoCode ---")

    // Alert the user to enter a promo code
    const alert = await this.alertController.create({
      header: 'Promo Code',
      inputs: [
        {
          name: 'promoCode',
          type: 'text',
          placeholder: this.translateService.instant('CONFIRMATION.ENTER_PROMO_CODE')
        }
      ],
      buttons: [
        {
          text: this.translateService.instant('GENERIC.CANCEL'),
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            this.silentLog('Promo code cancelled');
          }
        },
        {
          text: this.translateService.instant('GENERIC.APPLY'),
          handler: async (data) => {
            this.silentLog('User promo code:', data.promoCode);
            if (!data.promoCode || data.promoCode.trim().length === 0) {
              return;
            }

            let loadingMessage = 'Verifying promo code...';
            if (this.selectedLanguage === 'fr') {
              loadingMessage = 'Vérification du code promo...';
            } else if (this.selectedLanguage === 'nl') {
              loadingMessage = 'Promotiecode controleren...';
            } else if (this.selectedLanguage === 'de') {
              loadingMessage = 'Gutscheincode verifizieren...';
            }

            const loading = await this.loadingControler.create({ message: loadingMessage });
            await loading.present();

            try {
              const verifyPromoCodeCallable = httpsCallable(this.functions, "verifyPromoCode");
              const result: any = await verifyPromoCodeCallable({
                clientId: this.formData.clientId,
                eventId: this.formData.eventId,
                promoCode: data.promoCode,
                cart: this.cart
              });

              await loading.dismiss();

              if (result.data && result.data.success && result.data.promoCode) {
                const matchedPromoCode = result.data.promoCode as PromoCodeData;

                // Client-side validation for exchange mode if applicable
                if (this.isExchangeMode && this.exchangeState) {
                  const hasExchangedGiftCard = this.exchangeState.originalTickets.some((ticket: any) => ticket.isGiftCard === true);
                  if (hasExchangedGiftCard) {
                    const promoOrderId = matchedPromoCode.orderId || '';
                    const promoLabel = matchedPromoCode.label || '';
                    const originalOrderId = this.exchangeState.originalOrderId;

                    if (
                      (promoOrderId && originalOrderId && promoOrderId === originalOrderId) ||
                      (originalOrderId && promoLabel.includes(originalOrderId))
                    ) {
                      const isFr = this.translateService.currentLang === 'fr';
                      const isDe = this.translateService.currentLang === 'de';
                      const isNl = this.translateService.currentLang === 'nl';
                      let errorMsg = 'You cannot use a promo code generated from the tickets you are exchanging.';
                      let errorTitle = 'Invalid Code';
                      if (isFr) {
                        errorMsg = 'Vous ne pouvez pas utiliser un code promo généré depuis les billets que vous échangez.';
                        errorTitle = 'Code invalide';
                      } else if (isDe) {
                        errorMsg = 'Sie können keinen Rabattcode verwenden, der von den Tickets generiert wurde, die Sie umtauschen.';
                        errorTitle = 'Ungültiger Code';
                      } else if (isNl) {
                        errorMsg = 'U kunt geen kortingscode gebruiken die is gegenereerd op basis van de tickets die u ruilt.';
                        errorTitle = 'Ongeldige code';
                      }

                      this.alertController.create({
                        header: errorTitle,
                        message: errorMsg,
                        buttons: ['OK']
                      }).then(alert => alert.present());
                      this.appliedPromoCode = null;
                      this.applyPromoCode();
                      return;
                    }
                  }
                }

                // If exchange check passes, apply promo code
                this.appliedPromoCode = matchedPromoCode;
                this.silentLog("Promo code applied:", this.appliedPromoCode);
                this.applyPromoCode();
              } else {
                // Determine the correct alert based on error type
                const error = result.data ? result.data.error : 'NOT_FOUND';
                this.appliedPromoCode = null;
                this.applyPromoCode();

                if (error === 'EXHAUSTED') {
                  this.alertController.create({
                    header: this.translateService.instant('DIALOGS.PROMO_CODE_EXHAUSTED.TITLE'),
                    message: this.translateService.instant('DIALOGS.PROMO_CODE_EXHAUSTED.MESSAGE'),
                    buttons: ['OK']
                  }).then(alert => alert.present());
                } else if (error === 'NOT_APPLICABLE') {
                  this.alertController.create({
                    header: this.translateService.instant('DIALOGS.INVALID_PROMO_CODE_FOR_THIS_TICKET.TITLE'),
                    message: this.translateService.instant('DIALOGS.INVALID_PROMO_CODE_FOR_THIS_TICKET.MESSAGE'),
                    buttons: ['OK']
                  }).then(alert => alert.present());
                } else {
                  this.alertController.create({
                    header: this.translateService.instant('DIALOGS.INVALID_PROMO_CODE.TITLE'),
                    message: this.translateService.instant('DIALOGS.INVALID_PROMO_CODE.MESSAGE'),
                    buttons: ['OK']
                  }).then(alert => alert.present());
                }
              }
            } catch (err) {
              console.error("Error verifying promo code:", err);
              await loading.dismiss();
              this.appliedPromoCode = null;
              this.applyPromoCode();

              this.alertController.create({
                header: this.translateService.instant('DIALOGS.INVALID_PROMO_CODE.TITLE'),
                message: this.translateService.instant('DIALOGS.INVALID_PROMO_CODE.MESSAGE'),
                buttons: ['OK']
              }).then(alert => alert.present());
            }
          }
        }
      ]
    });

    // Set the focus on the input field after a short delay
    setTimeout(() => {
      const adminCodeInput: any = document.querySelector('ion-alert input')
      adminCodeInput.focus()
    }, 500)

    await alert.present();
  }

  async applyPromoCode() {
    this.silentLog("--- applyPromoCode ---")

    if (this.isOpenDaysOfferApplied) {
      this.appliedPromoCode = null
      this.promoApplicationDetails = []
      this.totalPriceAfterPromotion = 0
      this.totalVATAfterPromotion = 0
      this.cart.forEach((cartItem: CartItem) => {
        cartItem.priceAfterPromotion = 0
      })
      return
    }

    if (this.appliedPromoCode === null) {
      this.silentLog("No promo code applied")
      this.totalPriceAfterPromotion = this.totalPrice
      this.totalVATAfterPromotion = this.totalVAT
      this.cart.forEach((cartItem: CartItem) => {
        cartItem.priceAfterPromotion = getFamilyDiscountedUnitPrice(cartItem)
      })

      // Automatic date and package discounts, including their VAT.
      if (this.familyDiscountApplications.length > 0 || this.datePromotionApplications.length > 0) {
        this.totalPriceAfterPromotion = 0
        this.totalVATAfterPromotion = 0
        this.cart.forEach((cartItem: CartItem) => {
          const TTC: number = cartItem.quantity * cartItem.priceAfterPromotion
          const VATRATE: number = cartItem.vat / 100
          this.totalVATAfterPromotion += VATRATE * TTC / (1 + VATRATE)
          this.totalPriceAfterPromotion += TTC
        })
      }
      return
    }

    // Apply discount to the total price
    this.totalVATAfterPromotion = 0
    this.totalPriceAfterPromotion = 0

    const promoApplyToAll = this.appliedPromoCode.applyToAllTicketTypes ?? true;
    const promoApplicableTicketTypeIds = this.appliedPromoCode.applicableTicketTypeIds ?? [];
    const promoApplyToAddOns = this.appliedPromoCode.applyToAddOns ?? false;
    const promoApplyToAllAddOns = this.appliedPromoCode.applyToAllAddOns ?? true;
    const promoApplicableAddOnIds = this.appliedPromoCode.applicableAddOnIds ?? [];

    const maxUsable = this.appliedPromoCode.maxTicketTypeUsableQuantity ?? Infinity;
    const currentUsage = this.appliedPromoCode.ticketTypeUsageCount ?? 0;
    let remainingGlobalQuantity = maxUsable - currentUsage;
    this.promoApplicationDetails = [];

    if (this.appliedPromoCode.discountType === 'percentage') {
      this.cart.forEach((cartItem: CartItem) => {
        const isTicketApplicable = cartItem.ticketTypeId && (promoApplyToAll || promoApplicableTicketTypeIds.includes(cartItem.ticketTypeId));
        const isAddOnApplicable = cartItem.addOnId && promoApplyToAddOns && (promoApplyToAllAddOns || promoApplicableAddOnIds.includes(cartItem.addOnId));
        const isApplicable = isTicketApplicable || isAddOnApplicable;

        const basePrice = getFamilyDiscountedUnitPrice(cartItem);
        if (isApplicable && basePrice !== undefined && basePrice > 0 && remainingGlobalQuantity > 0) {
          const discountedQuantity = Math.min(cartItem.quantity, remainingGlobalQuantity);
          const fullPriceQuantity = cartItem.quantity - discountedQuantity;

          const discountedPrice = basePrice - (basePrice * (this.appliedPromoCode?.discountValue || 0) / 100);

          // Weighted average price for the cart item
          cartItem.priceAfterPromotion = (discountedQuantity * discountedPrice + fullPriceQuantity * basePrice) / cartItem.quantity;
          remainingGlobalQuantity -= discountedQuantity;

          if (discountedQuantity > 0) {
            this.promoApplicationDetails.push({
              cartItem: cartItem,
              quantity: discountedQuantity
            });
          }
        } else {
          cartItem.priceAfterPromotion = basePrice;
        }

        // Round to 2 decimals
        cartItem.priceAfterPromotion = Math.round((cartItem.priceAfterPromotion + Number.EPSILON) * 100) / 100;

        // Re calculate the total VAT after promotion
        let TTC: number = cartItem.quantity * cartItem.priceAfterPromotion
        let VATRATE: number = cartItem.vat / 100
        this.totalVATAfterPromotion += VATRATE * TTC / (1 + VATRATE)
        this.totalPriceAfterPromotion += TTC
      })

      if (!this.production) {
        this.silentLog("this.totalVATAfterPromotion", this.totalVATAfterPromotion)
        this.silentLog("this.cart after promo code", this.cart)
      }
    }
    else if (this.appliedPromoCode.discountType === 'absolute') {
      const isModernPromo = maxUsable !== Infinity && maxUsable > 0;
      let totalDiscountToDistribute = 0;
      let totalApplicablePriceForUsableTickets = 0;
      let tempRemaining = remainingGlobalQuantity;

      this.cart.forEach((cartItem: CartItem) => {
        const isTicketApplicable = cartItem.ticketTypeId && (promoApplyToAll || promoApplicableTicketTypeIds.includes(cartItem.ticketTypeId));
        const isAddOnApplicable = cartItem.addOnId && promoApplyToAddOns && (promoApplyToAllAddOns || promoApplicableAddOnIds.includes(cartItem.addOnId));
        const isApplicable = isTicketApplicable || isAddOnApplicable;

        if (isApplicable && tempRemaining > 0) {
          const usableQuantity = Math.min(cartItem.quantity, tempRemaining);
          const itemBasePriceForUsable = usableQuantity * getFamilyDiscountedUnitPrice(cartItem);
          totalApplicablePriceForUsableTickets += itemBasePriceForUsable;
          if (isModernPromo) {
            totalDiscountToDistribute += Math.min(usableQuantity * (this.appliedPromoCode?.discountValue || 0), itemBasePriceForUsable);
          }
          tempRemaining -= usableQuantity;
        }
      });

      if (!isModernPromo) {
        totalDiscountToDistribute = Math.min(this.appliedPromoCode.discountValue, totalApplicablePriceForUsableTickets);
      }

      this.totalPriceAfterPromotion = this.totalPrice - this.automaticDiscountTotal - totalDiscountToDistribute;

      let totalPriceAfterPromoCheck: number = 0;
      tempRemaining = remainingGlobalQuantity;

      this.cart.forEach((cartItem: CartItem) => {
        const isTicketApplicable = cartItem.ticketTypeId && (promoApplyToAll || promoApplicableTicketTypeIds.includes(cartItem.ticketTypeId));
        const isAddOnApplicable = cartItem.addOnId && promoApplyToAddOns && (promoApplyToAllAddOns || promoApplicableAddOnIds.includes(cartItem.addOnId));
        const isApplicable = isTicketApplicable || isAddOnApplicable;

        if (isApplicable && totalApplicablePriceForUsableTickets > 0 && tempRemaining > 0) {
          const usableQuantity = Math.min(cartItem.quantity, tempRemaining);
          const basePrice = getFamilyDiscountedUnitPrice(cartItem);
          const itemTotalUsable = usableQuantity * basePrice;
          let itemDiscount = 0;
          if (isModernPromo) {
            itemDiscount = Math.min(usableQuantity * (this.appliedPromoCode?.discountValue || 0), itemTotalUsable);
          } else {
            itemDiscount = totalDiscountToDistribute * (itemTotalUsable / totalApplicablePriceForUsableTickets);
          }

          const fullPriceTotal = (cartItem.quantity - usableQuantity) * basePrice;
          cartItem.priceAfterPromotion = (itemTotalUsable - itemDiscount + fullPriceTotal) / cartItem.quantity;

          tempRemaining -= usableQuantity;

          if (usableQuantity > 0) {
            this.promoApplicationDetails.push({
              cartItem: cartItem,
              quantity: usableQuantity
            });
          }
        } else {
          cartItem.priceAfterPromotion = getFamilyDiscountedUnitPrice(cartItem)
        }

        cartItem.priceAfterPromotion = Math.round((cartItem.priceAfterPromotion + Number.EPSILON) * 100) / 100;

        // Re calculate the total VAT after promotion
        let TTC: number = cartItem.quantity * cartItem.priceAfterPromotion
        let VATRATE: number = cartItem.vat / 100
        this.totalVATAfterPromotion += VATRATE * TTC / (1 + VATRATE)

        totalPriceAfterPromoCheck += TTC
      })

      const priceDifference: number = Math.round((this.totalPriceAfterPromotion - totalPriceAfterPromoCheck + Number.EPSILON) * 100) / 100;
      if (priceDifference !== 0 && Math.abs(priceDifference) < 0.05) {
        const lastItem = this.cart[this.cart.length - 1];
        if (lastItem) {
          lastItem.priceAfterPromotion += priceDifference / lastItem.quantity
          lastItem.priceAfterPromotion = Math.round((lastItem.priceAfterPromotion + Number.EPSILON) * 100) / 100;
        }
      }
    }

    if (!this.production) {
      this.silentLog("this.totalVATAfterPromotion", this.totalVATAfterPromotion)
      this.silentLog("this.cart after promo code", this.cart)
    }

    // Ensure total price does not go below zero
    if (this.totalPriceAfterPromotion < 0) {
      this.totalPriceAfterPromotion = 0;
      this.totalVATAfterPromotion = 0;
    }
  }

  async resetPromoCode() {
    this.appliedPromoCode = null
    this.promoApplicationDetails = []
    this.computeBasketValue()
  }

  // Submit the form
  async proceedWithPayment() {
    this.silentLog("--- proceedWithPayment ---")

    this.silentLog("--- OK ---")
    this.recordingUser = true
    this.progress = 0
    const loading = await this.loadingControler.create()
    loading.present()

    try {
      setTimeout(() => {
        console.warn("Updating loading message")
        if (this.recordingUser) {
          loading.message = this.translateService.instant('CONFIRMATION.LOADING_MESSAGE_1')
        }
      }, 3000)

      setTimeout(() => {
        console.warn("Updating loading message")
        if (this.recordingUser) {
          loading.message = this.translateService.instant('CONFIRMATION.LOADING_MESSAGE_2')
        }
      }, 10000)

      setTimeout(async () => {
        console.warn("Cancel request and informing visitor something happened")
        if (this.recordingUser) {
          console.error("Nous ne parvenons malheureusement pas à enregistrer vos réponses. Merci de vérifier l'ensemble de vos champs, les caractères spéciaux le cas échéant, et de tester l'envoi depuis un autre poste.")
          loading.dismiss()
          this.recordingUser = false
          this.isFormSubmissionRecorded = false

          // Alert the user of the error
          const errorAlert = await this.alertController.create({
            header: this.translateService.instant('DIALOGS.FATAL_ERROR.TITLE'),
            message: this.translateService.instant('DIALOGS.FATAL_ERROR.MESSAGE')
          })
          errorAlert.present()
        }
      }, 20000)


      const firstLoadingBarInterval = setInterval(() => {
        this.progress += (0.01 + this.progress / 20);

        // Stop the progress bar when it reaches 80%
        // to continuously show the demo
        if (this.progress >= 0.80) {
          this.silentLog("--- Clearing firstLoadingBarInterval 1 ---")
          clearInterval(firstLoadingBarInterval);
        }
      }, 50);

      // Setup the new exposant firestore document
      const inputFormKeys: string[] = Object.keys(this.inputForm.value)
      if (!this.production)
        this.silentLog("inputFormKeys = ", inputFormKeys)

      // Build custom fields node
      let customNode: any = {}
      inputFormKeys.forEach((formKey: string) => {
        if (formKey.startsWith('custom_')) {
          const matchingInput = this.formData.inputs.find(input => input.fieldName === formKey)
          if (!this.production)
            this.silentLog("matchingInput = ", matchingInput)
          const labelKey = (matchingInput) ?
            (typeof matchingInput.label === 'string' ? matchingInput.label : (matchingInput.label['en'] || Object.values(matchingInput.label)[0] || '')) :
            formKey.split('custom_')[1]
          customNode[formKey] = {
            label: labelKey,
            value: this.inputForm.value[formKey],
            value_default_language: matchingInput?.options?.find(option => option.value === this.inputForm.value[formKey])?.label[this.formData.eventDefaultLanguage || 'en'] || this.inputForm.value[formKey]
          }
        }
      })

      // Track custom acknowledgments
      if (this.formData.sections) {
        this.formData.sections.forEach(section => {
          if (section.isAcknowledgments && section.inputs) {

            if (this.isMultipleVisitorForms) {
              section.inputs.forEach(input => {
                customNode[input.fieldName] = {
                  label: this.getLocalizedLabel(input),
                  value: this.visitorForms[0].get(input.fieldName)?.value || false
                }
              })
            } else {
              section.inputs.forEach(input => {
                customNode[input.fieldName] = {
                  label: this.getLocalizedLabel(input),
                  value: this.inputForm.get(input.fieldName)?.value || false
                }
              })
            }
          }
        })
      }

      if (!this.production)
        this.silentLog("customNode", customNode)

      // Call a Firebase function to send the confirmation email and add the visitor to firestore
      if (this.reservationInterval) clearInterval(this.reservationInterval);

      const primaryVisitor: VisitorInput | null = this.isMultipleVisitorForms ? this.getFirstVisitorInCart() : this.extractVisitorFromForm(this.inputForm)
      const pickValue = (visitorVal: any, formKey: string) => {
        if (visitorVal !== undefined && visitorVal !== null)
          return (typeof visitorVal === 'string') ? visitorVal.trim() : visitorVal
        const formVal = this.inputForm?.value?.[formKey]
        if (formVal !== undefined && formVal !== null)
          return (typeof formVal === 'string') ? formVal.trim() : formVal
        return ''
      }

      this.trackMetaPixelEvent("InitiateCheckout")

      // language: inputFormKeys.includes('userLanguage') ? this.inputForm.value.userLanguage.trim() : 'FR',
      const result: any = await this.callAuthenticatedFunction('startGenericMolliePaymentSession', {
        clientId: this.formData.clientId,
        eventId: this.formData.eventId,
        formId: this.formId,
        reservationId: this.reservationId,
        cart: this.cart,
        organizerMetadata: this.formData.organizerMetadata,
        organizerProfileId: this.formData.organizerProfileId,
        organizerMollieProfileId: this.formData.organizerMollieProfileId,
        organizerProfileRedirection: this.formData.organizerProfileRedirection,
        eventMetadata: this.formData.eventMetadata,
        eventName: this.formData.eventName,
        organizerCommercialName: this.formData.organizerCommercialName,
        organizerMail: this.formData.organizerMail,
        isDateSlot: this.requiresDateSelection(this.selectedTicketType),
        isTimeSlot: this.selectedTicketType.isTimeSlot,
        slotDate: (this.requiresDateSelection(this.selectedTicketType)) ? this.selectedDate : null,
        slotTime: (this.selectedTicketType.isTimeSlot && this.selectedSlotTickets.label !== undefined) ? this.selectedSlotTickets.label : null,
        slotDuration: (this.selectedTicketType.isTimeSlot && this.selectedTicketType.timeSlotDuration !== undefined) ? this.selectedTicketType.timeSlotDuration : null,
        email: pickValue(primaryVisitor?.email, 'userEmail'),
        phone: pickValue(primaryVisitor?.phone, 'userPhone'),
        mobile: pickValue(primaryVisitor?.phone, 'userMobile'),
        firstname: pickValue(primaryVisitor?.firstname, 'userFirstname'),
        lastname: pickValue(primaryVisitor?.lastname, 'userLastname'),
        jobTitle: pickValue(primaryVisitor?.jobTitle, 'userJobTitle'),
        country: pickValue(primaryVisitor?.country, 'userCountry'),
        zipcode: pickValue(primaryVisitor?.zipcode, 'userZipcode'),
        ageGroup: pickValue(primaryVisitor?.ageGroup, 'userAgeGroup'),
        gender: pickValue(primaryVisitor?.gender, 'userGender'),
        visitGoal: pickValue(primaryVisitor?.visitGoal, 'userVisitGoal'),
        companyName: pickValue(primaryVisitor?.companyName, 'companyName'),
        companyIndustry: pickValue(primaryVisitor?.companyIndustry, 'companyIndustry'),
        companyAddress: pickValue(primaryVisitor?.companyAddress, 'companyAddress'),
        companyZipcode: pickValue(primaryVisitor?.companyZipcode, 'companyZipcode'),
        companyCity: pickValue(primaryVisitor?.companyCity, 'companyCity'),
        city: pickValue(primaryVisitor?.city, 'userCity'),
        promoCode: (this.appliedPromoCode !== null) ? this.appliedPromoCode.code : '',
        promoCodeId: (this.appliedPromoCode !== null) ? this.appliedPromoCode.id : '',
        language: this.selectedLanguage,
        utm: {
          source: this.utm_source,
          medium: this.utm_medium,
          campaign: this.utm_campaign,
          term: this.utm_term,
          content: this.utm_content
        },
        optin: this.isOptinChecked,
        userMetadata: customNode,
        currentUrl: window.location.href,
        exchangedFromOrderId: this.isExchangeMode ? this.exchangeState.originalOrderId : null,
        exchangedTicketIds: this.isExchangeMode ? this.exchangeState.originalTicketIds : null
      })
      if (!this.production)
        this.silentLog("setNewGenericVisitor results", result)
      if (!result.data.success)
        throw ({ code: result.data.code, header: 'Serveur indisponible', message: result.data.message })

      this.silentLog("result.data.checkoutURL", result.data.checkoutURL)
      this.silentLog("--- Clearing firstLoadingBarInterval 2 ---")
      clearInterval(firstLoadingBarInterval);
      this.progress = 0.8
      const secondLoadingBarInterval = setInterval(() => {
        this.progress += 0.01;

        // Stop the progress bar when it reaches 80%
        // to continuously show the demo
        if (this.progress >= 1) {
          clearInterval(secondLoadingBarInterval);
          this.recordingUser = false
          this.isFormSubmissionRecorded = true
          loading.dismiss()

          window.location.href = result.data.checkoutURL
        }
      }, 50);
    } catch (error: any) {
      console.error(error)
      if (this.reservationId && this.reservationExpiry) this.startReservationTimer();
      loading.dismiss()
      this.recordingUser = false
      this.isFormSubmissionRecorded = false

      // Alert the user of the error
      const errorAlert = await this.alertController.create({
        header: 'Error code: ' + error.code,
        message: error.message || "An error occurred while processing your request. Please try again later.",
      })
      errorAlert.present()
    }
  }

  get selectedRefundAmount(): number {
    let total = 0;
    this.refundTickets.forEach(ticket => {
      if (this.selectedRefundTickets[ticket.id]) {
        total += ticket.ticketPrice || 0;
      }
    });
    return total;
  }

  /**
   * Number of units the fixed fee is charged on. refundTickets already groups each combined package
   * into a single row, so one selected row is one chargeable unit.
   */
  get selectedFeeUnitCount(): number {
    if (!this.hasFixedRefundFee) return 0;
    return this.refundTickets.filter(ticket => this.selectedRefundTickets[ticket.id] && ticket.ticketPrice > 0).length;
  }

  /** Total fixed fee for the current selection, capped to the value it is deducted from. */
  get totalFixedFee(): number {
    if (!this.hasFixedRefundFee || this.fixedRefundFeeAmount <= 0) return 0;
    const rawFee = this.fixedRefundFeeAmount * this.selectedFeeUnitCount;
    return Math.min(rawFee, this.selectedRefundAmount);
  }

  /** What the customer actually gets back once the fixed fee is deducted. */
  get netRefundAmount(): number {
    return Math.max(0, this.selectedRefundAmount - this.totalFixedFee);
  }

  /** Fixed fee withheld from the exchange credit, capped to that credit. */
  get exchangeFixedFee(): number {
    if (!this.isExchangeMode || !this.exchangeState) return 0;
    if (!this.hasFixedRefundFee || this.fixedRefundFeeAmount <= 0) return 0;
    const unitCount = (this.exchangeState.originalTickets || []).length;
    const rawFee = this.fixedRefundFeeAmount * unitCount;
    return Math.min(rawFee, this.exchangeState.originalValue || 0);
  }

  /** Exchange credit net of the fixed fee — mirrors what the server deducts from the cart. */
  get exchangeNetCredit(): number {
    if (!this.isExchangeMode || !this.exchangeState) return 0;
    return Math.max(0, (this.exchangeState.originalValue || 0) - this.exchangeFixedFee);
  }

  get refundCardModeKeySuffix(): string {
    if (this.isFreeReservation) return '_FREE';
    if (this.isEventRefundable && this.isEventExchangeable) return '';
    if (this.isEventExchangeable) return '_EXCHANGE_ONLY';
    return ''; // refund-only (or unresolved yet) keeps the default refund copy
  }

  get exchangeNetDifference(): number {
    if (!this.isExchangeMode || !this.exchangeState) return 0;
    const newTotal = this.hasAppliedPromotion ? this.totalPriceAfterPromotion : this.totalPrice;
    return newTotal - this.exchangeNetCredit;
  }

  get paymentRequired(): boolean {
    if (this.isExchangeMode) {
      return this.exchangeNetDifference > 0.01;
    }
    return (this.hasAppliedPromotion ? this.totalPriceAfterPromotion : this.totalPrice) > 0.01;
  }

  get showPromoCodeButton(): boolean {
    if (this.isOpenDaysOfferApplied) {
      return false;
    }
    if (this.isExchangeMode && this.exchangeNetDifference < -0.01) {
      return false;
    }
    return true;
  }

  /** Drops the exchange in progress (original tickets stay valid) and restarts a brand new order. */
  async cancelExchange() {
    const confirmAlert = await this.alertController.create({
      header: this.translateService.instant('REFUND_CARD.START_NEW_ORDER'),
      message: this.translateService.instant('REFUND_CARD.START_NEW_ORDER_CONFIRM_MESSAGE'),
      buttons: [
        {
          text: this.translateService.instant('GENERIC.CANCEL'),
          role: 'cancel',
          cssClass: 'secondary'
        },
        {
          text: this.translateService.instant('GENERIC.CONFIRM'),
          handler: () => {
            localStorage.removeItem('welkom_exchange_state_' + this.formId);
            this.isExchangeMode = false;
            this.exchangeState = null;
            // Release the tickets held for the exchange, otherwise the reload restores that cart
            if (this.reservationId)
              this.unbookTemporaryTickets();
            else
              window.location.reload();
          }
        }
      ]
    });
    await confirmAlert.present();
  }

  async confirmExchange() {
    this.silentLog("--- confirmExchange ---")

    const selectedIds: string[] = [];
    const selectedTickets: any[] = [];
    this.refundTickets.forEach(ticket => {
      if (this.selectedRefundTickets[ticket.id]) {
        if (ticket.isCombinedTicket && ticket.subTicketIds) {
          selectedIds.push(...ticket.subTicketIds);
          selectedTickets.push(ticket);
        } else {
          selectedIds.push(ticket.id);
          selectedTickets.push(ticket);
        }
      }
    });

    if (selectedIds.length === 0) {
      const noSelectionAlert = await this.alertController.create({
        header: this.translateService.instant('REFUND_CARD.TITLE'),
        message: this.translateService.instant('REFUND_CARD.SELECT_AT_LEAST_ONE'),
        buttons: ['OK']
      });
      await noSelectionAlert.present();
      return;
    }

    const confirmAlert = await this.alertController.create({
      header: this.translateService.instant('REFUND_CARD.EXCHANGE_CONFIRM_HEADER'),
      message: this.translateService.instant('REFUND_CARD.EXCHANGE_CONFIRM_MESSAGE'),
      buttons: [
        {
          text: this.translateService.instant('GENERIC.CANCEL'),
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            this.silentLog('Exchange cancelled by user');
          }
        },
        {
          text: this.translateService.instant('GENERIC.CONFIRM'),
          handler: () => {
            this.startExchange(selectedIds, selectedTickets);
          }
        }
      ]
    });
    await confirmAlert.present();
  }

  startExchange(selectedIds: string[], selectedTickets: any[]) {
    const originalValue = selectedTickets.reduce((acc, t) => acc + (t.ticketPrice || 0), 0);
    const exchangeState = {
      originalOrderId: this.mollieOrderId,
      originalTicketIds: selectedIds,
      originalValue: originalValue,
      originalTickets: selectedTickets,
      // Carried over because the booking flow reloads the page and never calls checkGenericRefundStatus again.
      hasFixedRefundFee: this.hasFixedRefundFee,
      fixedRefundFeeAmount: this.fixedRefundFeeAmount
    };

    localStorage.setItem('welkom_exchange_state_' + this.formId, JSON.stringify(exchangeState));

    // Redirect to standard booking flow
    const params = new URLSearchParams(window.location.search);
    params.delete('molliePaymentStatus');
    params.delete('mollieOrderId');
    params.delete('email');
    params.delete('token');
    window.location.href = window.location.pathname + '?' + params.toString();
  }

  processRefundTickets(tickets: any[]): any[] {
    if (!tickets || tickets.length === 0) return [];

    const standardTickets: any[] = [];
    const combinedGroups: { [key: string]: any[] } = {};

    tickets.forEach(ticket => {
      if (ticket.isCombinedTicket) {
        // Group key is combinedGroupId since all sub-tickets of a combined package instance share the same combinedGroupId, falling back to userName or 'default'
        const key = ticket.combinedGroupId || ticket.userName || 'default';
        if (!combinedGroups[key]) {
          combinedGroups[key] = [];
        }
        combinedGroups[key].push(ticket);
      } else {
        const isExchanged = !!(ticket.canceledReason && ticket.canceledReason.includes('Exchanged'));
        const ticketPrice = ticket.ticketPrice || 0;
        const isPartiallyRefunded = ticket.refundedAmount > 0 && !ticket.isRefunded;
        standardTickets.push({
          ...ticket,
          isExchanged,
          isPartiallyRefunded,
          // Free tickets can only be cancelled, which requires the refund/cancellation option
          isFullyDisabled: ticket.isRefunded || ticket.isCanceled || isExchanged || (ticketPrice === 0 && !this.isEventRefundable) || isPartiallyRefunded
        });
      }
    });

    const mergedCombinedTickets = Object.keys(combinedGroups).map(key => {
      const group = combinedGroups[key];
      const first = group[0];
      const totalPrice = group.reduce((sum, t) => sum + (t.ticketPrice || 0), 0);
      const subTicketIds = group.map(t => t.id);
      const isRefunded = group.every(t => t.isRefunded);
      const isCanceled = group.every(t => t.isCanceled);
      const canceledReason = group.map(t => t.canceledReason).find(r => !!r) || null;

      // Find the sub-ticket in the group that actually contains the combinedTicketTypeId (if any)
      const ticketWithComboId = group.find(t => !!t.combinedTicketTypeId) || first;
      const combinedTicketTypeId = ticketWithComboId.combinedTicketTypeId || null;

      // Smart Parent Label Resolution
      let combinedLabel = '';

      // 1. Try to find the parent ticket type in formData by combinedTicketTypeId
      if (combinedTicketTypeId && this.formData && this.formData.ticketTypes) {
        const parentType = this.formData.ticketTypes.find((tt: any) => tt.id === combinedTicketTypeId);
        if (parentType && parentType.label) {
          combinedLabel = parentType.label;
        }
      }

      // 2. Try to find if any sub-ticket's ticketTypeId matches a combined ticket in formData
      if (!combinedLabel && this.formData && this.formData.ticketTypes) {
        for (const t of group) {
          const matchingType = this.formData.ticketTypes.find((tt: any) => tt.id === t.ticketTypeId && tt.isCombinedTicket);
          if (matchingType && matchingType.label) {
            combinedLabel = matchingType.label;
            break;
          }
        }
      }

      // 3. Fallback to the first available non-empty label in the group
      if (!combinedLabel) {
        combinedLabel = group.map(t => t.ticketTypeLabel).find(lbl => !!lbl) || 'Billet Combiné';
      }

      // Collect all unique non-empty seat labels
      const uniqueSeats = Array.from(new Set(group.map(t => t.seatLabel).filter(s => !!s)));
      const seatLabel = uniqueSeats.length > 0 ? uniqueSeats.join(', ') : null;

      const totalRefundedAmount = group.reduce((sum, t) => sum + (t.refundedAmount || 0), 0);
      const isExchanged = group.some(t => !!(t.canceledReason && t.canceledReason.includes('Exchanged')));
      const ticketPrice = Math.max(0, totalPrice - totalRefundedAmount);
      const isPartiallyRefunded = totalRefundedAmount > 0 && !isRefunded;
      const isFullyDisabled = isRefunded || isCanceled || isExchanged || group.every(t => t.isRefunded || t.isCanceled) || (ticketPrice === 0 && !this.isEventRefundable) || isPartiallyRefunded;

      return {
        id: `combined_${key}`,
        ticketTypeId: combinedTicketTypeId || first.ticketTypeId || null,
        addOnId: null,
        ticketTypeLabel: combinedLabel,
        ticketPriceTag: first.ticketPriceTag || null,
        ticketPrice: ticketPrice,
        isRefunded: isRefunded,
        isCanceled: isCanceled,
        canceledReason: canceledReason,
        refundedAmount: totalRefundedAmount || null,
        userName: first.userName,
        isCombinedTicket: true,
        combinedTicketTypeId: combinedTicketTypeId || null,
        seatLabel: seatLabel,
        subTicketIds: subTicketIds,
        isExchanged: isExchanged,
        isPartiallyRefunded: isPartiallyRefunded,
        isFullyDisabled: isFullyDisabled
      };
    });

    return [...standardTickets, ...mergedCombinedTickets];
  }

  hasPartialRefund(): boolean {
    if (!this.refundTickets || this.refundTickets.length === 0) return false;
    return this.refundTickets.some(ticket => ticket.refundedAmount > 0 && !ticket.isRefunded);
  }

  get totalRefundedAmountAlreadyProcessed(): number {
    if (!this.refundTickets) return 0;
    return this.refundTickets.reduce((sum, ticket) => sum + (ticket.refundedAmount || 0), 0);
  }

  toggleRefundTicket(ticket: any, event: any) {
    const isChecked = event.detail.checked;
    this.selectedRefundTickets[ticket.id] = isChecked;
  }

  toggleAllRefundTickets(select: boolean) {
    this.refundTickets.forEach(ticket => {
      if (!ticket.isFullyDisabled && !(ticket.isGiftCard && ticket.isGiftCardPromoCodeUsed)) {
        this.selectedRefundTickets[ticket.id] = select;
      }
    });
  }

  isAnyTicketSelected(): boolean {
    return this.refundTickets.some(ticket => !ticket.isFullyDisabled && !(ticket.isGiftCard && ticket.isGiftCardPromoCodeUsed) && this.selectedRefundTickets[ticket.id]);
  }

  getTicketLabel(ticket: any): string {
    if (!ticket) return '';
    const label = ticket.ticketTypeLabel;
    if (!label) return '';

    let ticketTypeText = ''
    if (typeof label === 'object') {
      ticketTypeText = label[this.selectedLanguage] || label['en'] || (Object.values(label).length > 0 ? Object.values(label)[0] : '') as string || '';
    } else {
      ticketTypeText = label;
    }

    if (ticket.ticketPriceTag) {
      const tagLower = ticket.ticketPriceTag.toLowerCase();
      const resolvedTag = this.getTicketPriceTagLabel(ticket.ticketPriceTag, ticket.ticketTypeId);

      if (tagLower === 'normal') {
        if (resolvedTag !== 'Normal' && resolvedTag !== this.translateService.instant('GENERIC.NORMAL')) {
          ticketTypeText += ` (${resolvedTag})`;
        }
      } else if (tagLower !== 'early-bird') {
        ticketTypeText += ` (${resolvedTag})`;
      }
    }

    return ticketTypeText;
  }

  isAllTicketsAlreadyRefunded(): boolean {
    return this.refundTickets.length > 0 && this.refundTickets.every(ticket => ticket.isRefunded || ticket.isCanceled || (ticket.isGiftCard && ticket.isGiftCardPromoCodeUsed));
  }

  // Refund the payment
  async confirmRefund() {
    this.silentLog("--- confirmRefund ---")

    const selectedIds: string[] = [];
    this.refundTickets.forEach(ticket => {
      if (this.selectedRefundTickets[ticket.id]) {
        if (ticket.isCombinedTicket && ticket.subTicketIds) {
          selectedIds.push(...ticket.subTicketIds);
        } else {
          selectedIds.push(ticket.id);
        }
      }
    });

    if (selectedIds.length === 0) {
      const noSelectionAlert = await this.alertController.create({
        header: this.translateService.instant('REFUND_CARD.TITLE'),
        message: this.translateService.instant('REFUND_CARD.SELECT_AT_LEAST_ONE'),
        buttons: ['OK']
      });
      await noSelectionAlert.present();
      return;
    }

    const confirmAlert = await this.alertController.create({
      header: this.translateService.instant('REFUND_CARD.CONFIRM_HEADER'),
      message: this.translateService.instant(this.isFreeReservation ? 'REFUND_CARD.CONFIRM_MESSAGE_FREE' : 'REFUND_CARD.CONFIRM_MESSAGE'),
      buttons: [
        {
          text: this.translateService.instant('GENERIC.CANCEL'),
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            this.silentLog('Refund cancelled by user');
          }
        },
        {
          text: this.translateService.instant('GENERIC.CONFIRM'),
          handler: () => {
            this.executeRefund(selectedIds);
          }
        }
      ]
    });
    await confirmAlert.present();
  }

  async executeRefund(selectedIds: string[]) {
    const loading = await this.loadingControler.create({ message: this.translateService.instant(this.isFreeReservation ? 'DIALOGS.CANCELLATION_IN_PROGRESS.MESSAGE' : 'DIALOGS.REFUND_IN_PROGRESS.MESSAGE') })
    await loading.present()

    try {
      // Call a Firebase function to send the confirmation email and add the visitor to firestore
      const callable = httpsCallable(this.functions, "refundGenericMollieOrder");

      const result: any = await callable({
        clientId: this.formData.clientId,
        eventId: this.formData.eventId,
        orderId: this.mollieOrderId,
        selectedTicketIds: selectedIds,
        // Free tickets only: nothing to refund, the server only cancels them
        refundAmount: this.selectedRefundAmount > 0 ? this.selectedRefundAmount : null
      })
      if (!this.production)
        this.silentLog("refundGenericMollieOrder results", result)
      if (!result.data.success)
        throw ({ code: result.data.error.code, header: 'Serveur indisponible', message: result.data.error.message })

      loading.dismiss()
      // Alert the user of the error
      const successAlert = await this.alertController.create({
        header: this.translateService.instant(this.isFreeReservation ? 'DIALOGS.CANCELLATION_PROCESSED.TITLE' : 'DIALOGS.REFUND_PROCESSED.TITLE'),
        message: this.translateService.instant(this.isFreeReservation ? 'DIALOGS.CANCELLATION_PROCESSED.MESSAGE' : 'DIALOGS.REFUND_PROCESSED.MESSAGE'),
        buttons: [
          {
            text: 'OK',
            handler: () => {
              // Reload the current page
              window.location.reload();
            }
          }
        ]
      })
      successAlert.present()
    } catch (error: any) {
      console.error(error)
      loading.dismiss()

      let errorMessage = error.message || this.translateService.instant('DIALOGS.FATAL_REFUND_ERROR.MESSAGE');
      if (error.code === 'gift-card-already-used') {
        errorMessage = this.translateService.instant('DIALOGS.GIFT_CARD_ALREADY_USED_ERROR');
      }

      // Alert the user of the error
      const errorAlert = await this.alertController.create({
        header: this.translateService.instant('DIALOGS.FATAL_REFUND_ERROR.TITLE'),
        message: errorMessage
      })
      errorAlert.present()
    }
  }

  areAllItemsBookable(): boolean {
    // return false;
    if (this.cart.length === 0) return false;

    return this.cart.every(item => {
      if (item.isCombinedTicket) return true;

      if (item.ticketTypeId) {
        const ticketType = this.ticketTypes.find(t => t.id === item.ticketTypeId);
        if (ticketType && ticketType.isBookable === false) return false;
      }

      if (item.addOnId) {
        const addOn = this.addOns.find(a => a.id === item.addOnId);
        if (addOn && addOn.isBookable === false) return false;
      }

      return true;
    });
  }

  getBookableItems() {
    // return [];
    if (this.cart.length === 0) return [];

    return this.cart.filter(item => {
      if (item.isCombinedTicket) return true;
      // A seat is always held by the reservation, whatever the ticket type's isBookable flag
      if (item.seat?.id) return true;

      if (item.ticketTypeId) {
        const ticketType = this.ticketTypes.find(t => t.id === item.ticketTypeId);
        if (ticketType && ticketType.isBookable === false) return false;
      }

      if (item.addOnId) {
        const addOn = this.addOns.find(a => a.id === item.addOnId);
        if (addOn && addOn.isBookable === false) return false;
      }

      return true;
    });
  }

  async bookTemporaryTickets() {
    if (!this.formData) return false;
    if (this.formData.seatingEnabled && !this.isGiftCardMode) {
      return await this.bookTemporarySeatedTickets();
    }
    this.silentLog("--- bookTemporaryTickets ---");

    // if (!this.areAllItemsBookable()) {
    //   console.warn("Attempted to book non-bookable items");
    //   return;
    // }

    const cart = this.getBookableItems().map((item: any) => ({
      ticketTypeId: item.ticketTypeId,
      addOnId: item.addOnId,
      quantity: item.quantity,
      isCombinedTicket: item.isCombinedTicket,
      combinedTickets: item.isCombinedTicket ? item.combinedTickets : []
    }));
    const hasItems = cart.length > 0;

    if (!hasItems) {
      return false;
    }

    const loading = await this.loadingControler.create({
      message: this.translateService.instant('GENERIC.LOADING_BOOKING'),
    });
    await loading.present();

    try {
      const result: any = await this.callAuthenticatedFunction('reserveTickets', {
        clientId: this.formData.clientId,
        eventId: this.formData.eventId,
        cart: cart,
        lang: this.selectedLanguage,
        isDateSlot: this.requiresDateSelection(this.selectedTicketType),
        isTimeSlot: this.selectedTicketType?.isTimeSlot || false,
        slotDate: (this.requiresDateSelection(this.selectedTicketType)) ? this.selectedDate : null,
        slotTime: (this.selectedTicketType?.isTimeSlot && this.selectedSlotTickets?.label !== undefined) ? this.selectedSlotTickets.label : null,
        slotDuration: (this.selectedTicketType?.isTimeSlot && this.selectedTicketType?.timeSlotDuration !== undefined) ? this.selectedTicketType.timeSlotDuration : null,
      });

      this.silentLog("Reservation result", result);
      this.reservationId = result.data.reservationId;
      this.reservationExpiry = new Date(result.data.expiresAt);

      // Save to local storage with cart state for restoration after page refresh
      const addOnsSelections: any = {};
      this.addOns.forEach(addon => {
        if ((addon.selection || 0) > 0) addOnsSelections[addon.id] = addon.selection;
      });

      const ticketTypesPriceSelections: any = {};
      this.ticketTypes.forEach(tt => {
        if (tt.priceSelection) {
          ticketTypesPriceSelections[tt.id] = tt.priceSelection;
        }
      });

      localStorage.setItem('welkom_reservation_' + this.formId, JSON.stringify({
        id: this.reservationId,
        expiry: this.reservationExpiry,
        selectedTicketTypeId: this.selectedTicketType?.id,
        priceSelection: this.selectedTicketType?.priceSelection,
        ticketTypesPriceSelections: ticketTypesPriceSelections,
        addOnsSelections: addOnsSelections,
        selectedDate: this.selectedDate,
        selectedSlotTickets: this.selectedSlotTickets,
        seatMapPurchaseMode: this.seatMapPurchaseMode,
        reservationLinkKey: this.reservationLinkKey
      }));

      this.startReservationTimer();

      loading.dismiss();
      this.goToStep3();
      return true;

    } catch (error: any) {
      console.error("Error booking temporary tickets:", error);
      loading.dismiss();
      const isCapacityError = error.code === 'functions/resource-exhausted';
      const alert = await this.alertController.create({
        header: this.translateService.instant('GENERIC.ERROR'),
        message: (error.message || "An error occurred").replace('FirebaseError: ', '').replace('[object Object]', 'items'),
        buttons: ['OK']
      });
      await alert.present();

      // Reload current availability after the selected ticket capacity has been exhausted.
      if (isCapacityError) {
        await alert.onDidDismiss();
        window.location.reload();
      }

      return false;
    }
  }

  async bookTemporarySeatedTickets() {
    this.silentLog("--- bookTemporarySeatedTickets ---");
    if (this.reservationId) return true;

    // Only reserve bookable items: the checkout validates the reservation against the bookable cart only
    const cart = this.getBookableItems().map(item => ({
      ticketTypeId: item.ticketTypeId,
      addOnId: item.addOnId,
      label: item.label,
      description: item.description,
      quantity: item.quantity,
      priceTag: item.priceTag,
      price: item.price,
      priceAfterPromotion: item.priceAfterPromotion,
      vat: item.vat,
      seat: item.seat,
      isCombinedTicket: item.isCombinedTicket,
      combinedTickets: item.isCombinedTicket ? item.combinedTickets : []
    }));

    if (cart.length === 0) return false;

    const loading = await this.loadingControler.create({
      message: this.translateService.instant('GENERIC.LOADING_BOOKING'),
    });
    await loading.present();

    const slotTime = (this.selectedTicketType?.isTimeSlot && this.selectedSlotTickets?.label !== undefined) ? this.selectedSlotTickets.label : null;

    try {
      const result: any = await this.callAuthenticatedFunction('reserveSeatedTickets', {
        clientId: this.formData.clientId,
        eventId: this.formData.eventId,
        cart: cart,
        lang: this.selectedLanguage,
        isDateSlot: this.requiresDateSelection(this.selectedTicketType),
        isTimeSlot: this.selectedTicketType?.isTimeSlot || false,
        slotDate: this.selectedDate,
        slotTime: slotTime,
        slotDuration: (this.selectedTicketType?.isTimeSlot && this.selectedTicketType?.timeSlotDuration !== undefined) ? this.selectedTicketType.timeSlotDuration : null,
      });

      this.silentLog("Seated Reservation result", result);
      this.reservationId = result.data.reservationId;
      this.reservationExpiry = new Date(result.data.expiresAt);

      // Save to local storage
      const addOnsSelections: any = {};
      this.addOns.forEach(addon => {
        if ((addon.selection || 0) > 0) addOnsSelections[addon.id] = addon.selection;
      });

      localStorage.setItem('welkom_reservation_' + this.formId, JSON.stringify({
        id: this.reservationId,
        expiry: this.reservationExpiry,
        selectedTicketTypeId: this.selectedTicketType?.id,
        priceSelection: this.selectedTicketType?.priceSelection,
        addOnsSelections: addOnsSelections,
        selectedDate: this.selectedDate,
        selectedSlotTickets: this.selectedSlotTickets,
        selectedSeats: this.selectedSeats,
        reservationLinkKey: this.reservationLinkKey
      }));

      this.startReservationTimer();
      loading.dismiss();
      this.goToStep3();
      return true;

    } catch (error: any) {
      console.error("Error booking temporary seated tickets:", error);
      loading.dismiss();

      let header = this.translateService.instant('GENERIC.ERROR');
      let message = (error.message || "An error occurred").replace('FirebaseError: ', '').replace('[object Object]', 'items');

      if (error.code === 'functions/already-exists' && error.details) {
        const ticketTypeLabel = error.details.ticketTypeLabel;
        const ticketType = typeof ticketTypeLabel === 'object'
          ? (ticketTypeLabel?.[this.selectedLanguage] || ticketTypeLabel?.['en'] || (Object.values(ticketTypeLabel || {})[0] as string) || '')
          : (ticketTypeLabel || '');

        header = this.translateService.instant('DIALOGS.SEAT_ALREADY_BOOKED.TITLE');
        message = this.translateService.instant('DIALOGS.SEAT_ALREADY_BOOKED.MESSAGE', {
          row: error.details.row,
          col: error.details.col,
          ticketType: ticketType
        });

        // Reload seat map availability so seat(s) taken by another customer no longer appear as available,
        // then drop any of the customer's selected seats that are no longer available.
        if (this.selectedDate) {
          await this.fetchBookedSeatsForSlot(this.selectedDate, slotTime || undefined);
          this.selectedSeats = this.selectedSeats.filter(seat => !this.soldSeats.includes(seat.id));
          this.lastSelectedSeats = [...this.selectedSeats];
          this.computeBasketValue();
        }
      }

      const alert = await this.alertController.create({
        header: header,
        message: message,
        buttons: ['OK']
      });
      await alert.present();
      return false;
    }
  }

  private currentPopover: any = null;
  private popoverTimeout: any = null;

  async showReservationPopover(event: any) {
    // Clear any existing timeout
    if (this.popoverTimeout) {
      clearTimeout(this.popoverTimeout);
      this.popoverTimeout = null;
    }

    // Don't create a new popover if one is already open
    if (this.currentPopover) {
      return;
    }

    if (!this.cart || this.cart.length === 0) {
      return;
    }

    // Build the content as plain text with line breaks
    let content = '';

    // Group items by type
    const tickets = this.cart.filter(item => item.ticketTypeId);
    const addOns = this.cart.filter(item => item.addOnId);

    if (tickets.length > 0) {
      content += this.translateService.instant('GENERIC.TICKETS') + ':\n';
      tickets.forEach(item => {
        const label = typeof item.label === 'object' ? item.label[this.selectedLanguage] || item.label['en'] : item.label;
        content += `• ${label}`;
        if (item.priceTag) {
          const resolvedTag = this.getTicketPriceTagLabel(item.priceTag, item.ticketTypeId);
          if (resolvedTag) {
            content += ` (${resolvedTag})`;
          }
        }
        content += ` x${item.quantity}`;
        if (item.price > 0) {
          content += ` - ${(item.price * item.quantity).toFixed(2)}€`;
        }
        content += '\n';
      });
    }

    if (addOns.length > 0) {
      if (tickets.length > 0) content += '\n';
      content += this.translateService.instant('GENERIC.ADD_ONS') + ':\n';
      addOns.forEach(item => {
        const label = typeof item.label === 'object' ? item.label[this.selectedLanguage] || item.label['en'] : item.label;
        content += `• ${label} x${item.quantity}`;
        if (item.price > 0) {
          content += ` - ${(item.price * item.quantity).toFixed(2)}€`;
        }
        content += '\n';
      });
    }

    if (this.requiresDateSelection(this.selectedTicketType) && this.selectedDate) {
      content += '\n';
      content += this.translateService.instant('TIME_SLOTS.DATE') + ' ';
      content += new Date(this.selectedDate).toLocaleDateString(this.selectedLanguage, { year: 'numeric', month: 'long', day: 'numeric' }) + '\n';
    }

    if (this.selectedTicketType?.isTimeSlot && this.selectedSlotTickets?.label) {
      if (!this.requiresDateSelection(this.selectedTicketType)) {
        content += '\n';
      }
      content += this.translateService.instant('TIME_SLOTS.TIME') + ' ';
      content += (this.selectedSlotTickets.displayLabel || this.selectedSlotTickets.label) + '\n';
    }

    // Create a simple component inline for the popover
    const popover = await this.popoverController.create({
      component: ReservationDetailsPopover,
      componentProps: {
        content: content,
        onMouseEnter: () => {
          // Cancel auto-dismiss when hovering over popover
          if (this.popoverTimeout) {
            clearTimeout(this.popoverTimeout);
            this.popoverTimeout = null;
          }
        },
        onMouseLeave: () => {
          // Dismiss when leaving popover
          this.schedulePopoverDismissal();
        }
      },
      event: event,
      translucent: true,
      showBackdrop: false,
      cssClass: 'reservation-details-popover'
    });

    popover.onDidDismiss().then(() => {
      this.currentPopover = null;
      if (this.popoverTimeout) {
        clearTimeout(this.popoverTimeout);
        this.popoverTimeout = null;
      }
    });

    this.currentPopover = popover;
    await popover.present();

    // Auto-dismiss after 3 seconds
    this.schedulePopoverDismissal();
  }

  private schedulePopoverDismissal() {
    this.popoverTimeout = setTimeout(async () => {
      if (this.currentPopover) {
        await this.currentPopover.dismiss();
        this.currentPopover = null;
      }
      this.popoverTimeout = null;
    }, 3000);
  }

  /** Clears local temporary reservation state without releasing backend capacity. */
  private clearTemporaryReservationState(): void {
    if (this.reservationInterval) clearInterval(this.reservationInterval);
    this.reservationId = null;
    this.reservationExpiry = null;
    this.reservationCountdown = '';
    localStorage.removeItem('welkom_reservation_' + this.formId);
  }

  async unbookTemporaryTickets(reservationIdToUnbook: string | null = null, refresh: boolean = true, showLoading: boolean = true) {
    const id = reservationIdToUnbook || this.reservationId;
    if (!id || !this.formData) return;

    const loading = await this.loadingControler.create({
      message: this.translateService.instant('GENERIC.LOADING_UNBOOKING'),
    });

    if (showLoading) {
      await loading.present();
    }

    this.silentLog("--- unbookTemporaryTickets ---", id);

    // Clear state immediately to stop timer
    this.clearTemporaryReservationState();

    try {
      const unbookTickets = httpsCallable(this.functions, 'unbookTickets');
      await unbookTickets({
        clientId: this.formData.clientId,
        eventId: this.formData.eventId,
        reservationId: id
      });
      this.silentLog("Unbooked successfully");
    } catch (error) {
      console.error("Error unbooking:", error);
      if (showLoading) {
        loading.dismiss();
      }
    }

    // Reload page to refresh capacity
    if (refresh) {
      window.location.reload();
    } else {
      // If not reloading page, need to refresh the remaining tickets and add-ons
      // because if the user loads the page and a reservation is ongoing, 
      // the remaining tickets and add-ons take into account the reservation. 
      // So, when user cancels the reservation, the remaining tickets and add-ons are wrong.
      this.getTicketTypesRemaining()
      this.getAddOnsRemaining()
    }

    if (showLoading) {
      loading.dismiss();
    }
  }

  startReservationTimer() {
    if (this.reservationInterval) clearInterval(this.reservationInterval);

    this.updateCountdown();
    this.reservationInterval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  updateCountdown() {
    if (!this.reservationExpiry) return;

    const now = new Date().getTime();
    const expiry = new Date(this.reservationExpiry).getTime();
    const diff = expiry - now;

    if (diff <= 0) {
      this.reservationCountdown = "00:00";
      clearInterval(this.reservationInterval);
      this.unbookTemporaryTickets();

      // Alert user
      this.alertController.create({
        header: this.translateService.instant('GENERIC.RESERVATION_EXPIRED_TITLE'),
        message: this.translateService.instant('GENERIC.RESERVATION_EXPIRED_MESSAGE'),
        buttons: ['OK']
      }).then(a => a.present());
      return;
    }

    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    this.reservationCountdown = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  // Check if the email is a personal email
  /*
  checkPersonalEmail() {
    this.silentLog("--- checkPersonalEmail ---")
  
    // Get the email value
    const emailValue = this.inputForm.get('userEmail')?.value
    // Split and get domain name from email
    const domainName = emailValue.split('@')[1]
    // Check if the domain name is in the list of personal domain names
    const isPersonalEmail = this.personalDomainNames.includes(domainName)
    this.silentLog("isPersonalEmail", isPersonalEmail)
  
    // Return the result
    return isPersonalEmail
  }
  */
}

// Popover component for reservation details
@Component({
  selector: 'reservation-details-popover',
  template: `
    <div class="reservation-popover-content" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
      <div class="popover-header">{{ 'GENERIC.RESERVATION_DETAILS' | translate }}</div>
      <div class="popover-body">{{ content }}</div>
    </div>
  `,
  styles: [`
    .reservation-popover-content {
      padding: 12px;
      max-width: 300px;
    }
    .popover-header {
      font-weight: bold;
      margin-bottom: 8px;
      font-size: 14px;
    }
    .popover-body {
      white-space: pre-line;
      font-size: 13px;
      line-height: 1.5;
    }
  `],
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class ReservationDetailsPopover {
  content: string = '';
  onMouseEnter: () => void = () => { };
  onMouseLeave: () => void = () => { };
}
